// src/data/demoData.js

// ============================================================
// DEMO DATA MODULE
// Realistic DME/wound care data for demo mode.
// All ICD-10 codes, HCPCS codes, and product names are real.
// ============================================================

export const DEMO_ORG = "demo-org";

// -- Placeholder file content for demo document preview --
// Minimal valid PDF displaying "Demo Document - For Demonstration Purposes Only"
// prettier-ignore
export const DEMO_PLACEHOLDER_PDF = "JVBERi0xLjAKMSAwIG9iago8PC9UeXBlL0NhdGFsb2cvUGFnZXMgMiAwIFI+PgplbmRvYmoKMiAwIG9iago8PC9UeXBlL1BhZ2VzL0tpZHNbMyAwIFJdL0NvdW50IDE+PgplbmRvYmoKMyAwIG9iago8PC9UeXBlL1BhZ2UvTWVkaWFCb3hbMCAwIDYxMiA3OTJdL1BhcmVudCAyIDAgUi9SZXNvdXJjZXM8PC9Gb250PDwvRjEgNCAwIFI+Pj4+L0NvbnRlbnRzIDUgMCBSPj4KZW5kb2JqCjQgMCBvYmoKPDwvVHlwZS9Gb250L1N1YnR5cGUvVHlwZTEvQmFzZUZvbnQvSGVsdmV0aWNhPj4KZW5kb2JqCjUgMCBvYmoKPDwvTGVuZ3RoIDExNT4+CnN0cmVhbQpCVAovRjEgMjAgVGYKMTUwIDcwMCBUZAooRGVtbyBEb2N1bWVudCkgVGoKL0YxIDEyIFRmCjE1MCA2NzAgVGQKKEZvciBEZW1vbnN0cmF0aW9uIFB1cnBvc2VzIE9ubHkpIFRqCkVUCmVuZHN0cmVhbQplbmRvYmoKeHJlZgowIDYKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDA5IDAwMDAwIG4gCjAwMDAwMDAwNTggMDAwMDAgbiAKMDAwMDAwMDExNSAwMDAwMCBuIAowMDAwMDAwMjkyIDAwMDAwIG4gCjAwMDAwMDAzNjkgMDAwMDAgbiAKdHJhaWxlcgo8PC9TaXplIDYvUm9vdCAxIDAgUj4+CnN0YXJ0eHJlZgo1MzYKJSVFT0YK";

// Small 200x200 light gray PNG placeholder for wound/document images
// prettier-ignore
// eslint-disable-next-line
export const DEMO_PLACEHOLDER_IMAGE = "iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAOElEQVR42u3BAQ0AAADCoPd" + "PbQ43oAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAfgynMAABMjNGEAAAAAElFTkSuQmCC";

// -- Patients --
export const demoPatients = [
  {
    id: "demo-patient-1",
    firstName: "Margaret",
    lastName: "Thompson",
    dob: "1941-06-15",
    gender: "Female",
    insurance: "Medicare",
    insuranceId: "1EG4-TE5-MK72",
    phone: "(305) 555-0142",
    address: "2847 Palm Grove Dr, Miami, FL 33101",
  },
  {
    id: "demo-patient-2",
    firstName: "Robert",
    lastName: "Chen",
    dob: "1938-11-22",
    gender: "Male",
    insurance: "BlueCross BlueShield",
    insuranceId: "XYK928461553",
    phone: "(954) 555-0198",
    address: "1523 Bayview Terrace, Fort Lauderdale, FL 33301",
  },
  {
    id: "demo-patient-3",
    firstName: "Dorothy",
    lastName: "Williams",
    dob: "1945-03-08",
    gender: "Female",
    insurance: "Aetna",
    insuranceId: "W29385710042",
    phone: "(786) 555-0167",
    address: "891 Coral Way, Miami, FL 33145",
  },
  {
    id: "demo-patient-4",
    firstName: "James",
    lastName: "Martinez",
    dob: "1950-09-30",
    gender: "Male",
    insurance: "Medicare",
    insuranceId: "3KF7-RB2-NP41",
    phone: "(561) 555-0234",
    address: "4210 Congress Ave, Boynton Beach, FL 33426",
  },
  {
    id: "demo-patient-5",
    firstName: "Helen",
    lastName: "Johnson",
    dob: "1937-01-17",
    gender: "Female",
    insurance: "Medicare",
    insuranceId: "8HJ2-WQ9-LX56",
    phone: "(305) 555-0189",
    address: "655 Brickell Key Dr, Miami, FL 33131",
  },
  {
    id: "demo-patient-6",
    firstName: "William",
    lastName: "Davis",
    dob: "1943-07-25",
    gender: "Male",
    insurance: "UnitedHealthcare",
    insuranceId: "UHC-887432190",
    phone: "(954) 555-0211",
    address: "3700 NW 21st St, Lauderdale Lakes, FL 33311",
  },
  {
    id: "demo-patient-7",
    firstName: "Patricia",
    lastName: "Garcia",
    dob: "1948-12-03",
    gender: "Female",
    insurance: "Humana",
    insuranceId: "H90125478832",
    phone: "(786) 555-0156",
    address: "1200 SW 8th St, Miami, FL 33135",
  },
  {
    id: "demo-patient-8",
    firstName: "Richard",
    lastName: "Brown",
    dob: "1940-04-19",
    gender: "Male",
    insurance: "Medicare",
    insuranceId: "5MT8-YN3-GK29",
    phone: "(561) 555-0178",
    address: "890 SE 5th Ave, Delray Beach, FL 33483",
  },
];

// -- Products (matches orderEnums.js real products) --
export const demoProducts = [
  { id: "prod-1", name: "Collagen - 1x1 - A6021", hcpcs: "A6021", type: "primary" },
  { id: "prod-2", name: "Collagen - 2x2 - A6021", hcpcs: "A6021", type: "primary" },
  { id: "prod-3", name: "Collagen - 4x4 - A6021", hcpcs: "A6021", type: "primary" },
  { id: "prod-4", name: "Collagen - 7x7 - A6023", hcpcs: "A6023", type: "primary" },
  { id: "prod-5", name: "Collagen - 5x10 - A6023", hcpcs: "A6023", type: "primary" },
  { id: "prod-6", name: "Collagen Powder - A6010", hcpcs: "A6010", type: "primary" },
  { id: "prod-7", name: "Zetuvit 4x4 (A6196)", hcpcs: "A6196", type: "secondary" },
  { id: "prod-8", name: "Zetuvit 6x10 (A6197)", hcpcs: "A6197", type: "secondary" },
  { id: "prod-9", name: "Zetuvit 8x8 (A6197)", hcpcs: "A6197", type: "secondary" },
  { id: "prod-10", name: "Cosmopor 4x4 (A6219)", hcpcs: "A6219", type: "secondary" },
  { id: "prod-11", name: "Cosmopor 3.2x4 (A6219)", hcpcs: "A6219", type: "secondary" },
  // K-code wheelchair, used by demo-order-20 (Edward Kornyo). Lives alongside wound-care
  // products because woundAssessment[] is the canonical service-line array in this codebase.
  { id: "prod-12", name: "Standard Wheelchair - K0001", hcpcs: "K0001", type: "primary" },
];

// -- Locations --
export const demoLocations = [
  {
    id: "loc-1",
    name: "Miami Wound Care Center",
    address: "1200 NW 7th Ave, Miami, FL 33136",
    phone: "(305) 555-0100",
    npi: "1234567890",
  },
  {
    id: "loc-2",
    name: "Fort Lauderdale Clinic",
    address: "3500 E Commercial Blvd, Fort Lauderdale, FL 33308",
    phone: "(954) 555-0100",
    npi: "0987654321",
  },
  {
    id: "loc-3",
    name: "Boca Raton Medical Plaza",
    address: "950 NW 13th St, Boca Raton, FL 33486",
    phone: "(561) 555-0100",
    npi: "1122334455",
  },
];

// Shared media library used by every "manufacturer-side" demo role
// (salesDashboard / manufacturer / peptidesManufacturer). MediaView reads
// from auth.orgInfo.media via useMediaLibrary, so each manufacturer demo
// org needs the same files for the Media tab to render. Defined once so
// the three roles stay in sync without duplicating the (long) array.
export const demoSalesMediaLibrary = [
  // -- Folders --
  { id: "folder-sales", name: "Sales Materials", type: "folder", parentId: null, createdAt: "2025-10-01T00:00:00Z" },
  {
    id: "folder-training",
    name: "Training & How-To Videos",
    type: "folder",
    parentId: null,
    createdAt: "2025-10-01T00:00:00Z",
  },
  { id: "folder-clinical", name: "Clinical Resources", type: "folder", parentId: null, createdAt: "2025-11-01T00:00:00Z" },
  {
    id: "folder-compliance",
    name: "Compliance & Regulatory",
    type: "folder",
    parentId: null,
    createdAt: "2025-11-15T00:00:00Z",
  },
  {
    id: "folder-templates",
    name: "Email & Outreach Templates",
    type: "folder",
    parentId: null,
    createdAt: "2025-12-01T00:00:00Z",
  },

  // -- Sales Materials files --
  {
    id: "file-1",
    name: "Product Overview - Collagen Dressings.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "product-overview-collagen.pdf",
    size: 2450000,
    createdAt: "2025-10-05T00:00:00Z",
  },
  {
    id: "file-2",
    name: "DME Reimbursement Guide 2026.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "dme-reimbursement-guide-2026.pdf",
    size: 1850000,
    createdAt: "2025-10-10T00:00:00Z",
  },
  {
    id: "file-3",
    name: "Provider Onboarding One-Pager.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "provider-onboarding-one-pager.pdf",
    size: 980000,
    createdAt: "2025-10-12T00:00:00Z",
  },
  {
    id: "file-4",
    name: "Sales Pitch Deck - Q1 2026.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "sales-pitch-deck-q1-2026.pdf",
    size: 5200000,
    createdAt: "2026-01-05T00:00:00Z",
  },
  {
    id: "file-5",
    name: "Competitive Analysis - Wound Care Market.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "competitive-analysis-wound-care.pdf",
    size: 3100000,
    createdAt: "2025-11-20T00:00:00Z",
  },
  {
    id: "file-6",
    name: "HCPCS Code Quick Reference (A6010-A6024).pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "hcpcs-quick-reference.pdf",
    size: 720000,
    createdAt: "2025-10-15T00:00:00Z",
  },
  {
    id: "file-7",
    name: "Case Study - Sunshine Medical Group.pdf",
    type: "file",
    parentId: "folder-sales",
    filename: "case-study-sunshine.pdf",
    size: 1650000,
    createdAt: "2026-01-20T00:00:00Z",
  },

  // -- Training files --
  {
    id: "file-8",
    name: "Platform Demo Walkthrough.mp4",
    type: "file",
    parentId: "folder-training",
    filename: "platform-demo-walkthrough.mp4",
    size: 85000000,
    createdAt: "2025-10-20T00:00:00Z",
  },
  {
    id: "file-9",
    name: "How To - Create Your First Order.mp4",
    type: "file",
    parentId: "folder-training",
    filename: "how-to-create-first-order.mp4",
    size: 42000000,
    createdAt: "2025-10-22T00:00:00Z",
  },
  {
    id: "file-10",
    name: "How To - Upload Wound Photos.mp4",
    type: "file",
    parentId: "folder-training",
    filename: "how-to-upload-wound-photos.mp4",
    size: 28000000,
    createdAt: "2025-11-01T00:00:00Z",
  },
  {
    id: "file-11",
    name: "How To - Track Order Status.mp4",
    type: "file",
    parentId: "folder-training",
    filename: "how-to-track-order-status.mp4",
    size: 35000000,
    createdAt: "2025-11-05T00:00:00Z",
  },
  {
    id: "file-12",
    name: "New Rep Onboarding Guide.pdf",
    type: "file",
    parentId: "folder-training",
    filename: "new-rep-onboarding-guide.pdf",
    size: 4200000,
    createdAt: "2025-10-25T00:00:00Z",
  },
  {
    id: "file-13",
    name: "Commission Structure Explained.pdf",
    type: "file",
    parentId: "folder-training",
    filename: "commission-structure-explained.pdf",
    size: 1100000,
    createdAt: "2025-11-10T00:00:00Z",
  },

  // -- Clinical Resources files --
  {
    id: "file-14",
    name: "Wound Assessment Best Practices.pdf",
    type: "file",
    parentId: "folder-clinical",
    filename: "wound-assessment-best-practices.pdf",
    size: 3800000,
    createdAt: "2025-11-05T00:00:00Z",
  },
  {
    id: "file-15",
    name: "ICD-10 Codes for Wound Care.pdf",
    type: "file",
    parentId: "folder-clinical",
    filename: "icd10-codes-wound-care.pdf",
    size: 1500000,
    createdAt: "2025-11-08T00:00:00Z",
  },
  {
    id: "file-16",
    name: "Collagen Dressing Clinical Evidence.pdf",
    type: "file",
    parentId: "folder-clinical",
    filename: "collagen-clinical-evidence.pdf",
    size: 6700000,
    createdAt: "2025-11-15T00:00:00Z",
  },
  {
    id: "file-17",
    name: "Secondary Dressing Selection Guide.pdf",
    type: "file",
    parentId: "folder-clinical",
    filename: "secondary-dressing-selection-guide.pdf",
    size: 2100000,
    createdAt: "2025-12-01T00:00:00Z",
  },
  {
    id: "file-18",
    name: "Medicare Coverage Criteria - Skin Substitutes.pdf",
    type: "file",
    parentId: "folder-clinical",
    filename: "medicare-coverage-skin-substitutes.pdf",
    size: 4500000,
    createdAt: "2025-12-10T00:00:00Z",
  },

  // -- Compliance files --
  {
    id: "file-19",
    name: "HIPAA Compliance Checklist.pdf",
    type: "file",
    parentId: "folder-compliance",
    filename: "hipaa-compliance-checklist.pdf",
    size: 890000,
    createdAt: "2025-11-20T00:00:00Z",
  },
  {
    id: "file-20",
    name: "Anti-Kickback Statute Summary.pdf",
    type: "file",
    parentId: "folder-compliance",
    filename: "anti-kickback-summary.pdf",
    size: 1200000,
    createdAt: "2025-11-22T00:00:00Z",
  },
  {
    id: "file-21",
    name: "BAA Template - Provider Agreement.pdf",
    type: "file",
    parentId: "folder-compliance",
    filename: "baa-template-provider.pdf",
    size: 750000,
    createdAt: "2025-12-01T00:00:00Z",
  },
  {
    id: "file-22",
    name: "FDA 510k Clearance - Collagen Products.pdf",
    type: "file",
    parentId: "folder-compliance",
    filename: "fda-510k-collagen.pdf",
    size: 3200000,
    createdAt: "2025-12-15T00:00:00Z",
  },

  // -- Email Templates files --
  {
    id: "file-23",
    name: "Provider Introduction Email.pdf",
    type: "file",
    parentId: "folder-templates",
    filename: "provider-intro-email.pdf",
    size: 450000,
    createdAt: "2025-12-05T00:00:00Z",
  },
  {
    id: "file-24",
    name: "Follow-Up After Demo Email.pdf",
    type: "file",
    parentId: "folder-templates",
    filename: "follow-up-after-demo-email.pdf",
    size: 380000,
    createdAt: "2025-12-08T00:00:00Z",
  },
  {
    id: "file-25",
    name: "Reorder Reminder Template.pdf",
    type: "file",
    parentId: "folder-templates",
    filename: "reorder-reminder-template.pdf",
    size: 320000,
    createdAt: "2025-12-12T00:00:00Z",
  },
  {
    id: "file-26",
    name: "Quarterly Business Review Template.pdf",
    type: "file",
    parentId: "folder-templates",
    filename: "qbr-template.pdf",
    size: 1800000,
    createdAt: "2026-01-10T00:00:00Z",
  },
];

// -- Demo Users --
// Fake auth objects follow the same pattern as OrdersWizardDemoLauncher.js
// Must include: user, session, orgInfo, brain (with variables)
// BAA fields use format: baaSignatureDate_{baaId}, baaVersion_{baaId}
export const demoUsers = {
  provider: {
    user: {
      id: "demo-user-provider",
      firstName: "Dr. Sarah",
      lastName: "Mitchell",
      email: "demo.provider@lucashealth.ai",
      role: "advanced",
      groups: ["doctor"],
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        themePreference: null,
        npiNumber: "1234567890",
        baaSignatureDate_lucas: "2025-01-01",
        baaVersion_lucas: 1,
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-provider",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-provider",
    },
    orgInfo: {
      name: "Sunshine Wound Care Associates",
      id: DEMO_ORG,
      officeName: "Sunshine Wound Care Associates",
      officeAddress: "1200 NW 7th Ave",
      officeCity: "Miami",
      officeState: "FL",
      officeZip: "33136",
      dmeList: [
        {
          id: "dme-demo-1",
          companyName: "Coastal Medical Supply Co.",
          address: "8300 NW 53rd St, Suite 200",
          city: "Doral",
          state: "FL",
          zip: "33166",
          phone: "(305) 555-0300",
          email: "orders@coastalmedicalsupply.com",
          npi: "1928374650",
          ptan: "4G2881",
          nscNumber: "NSC0041825",
          taxId: "65-4821093",
          isDefault: true,
        },
      ],
    },
    brain: { variables: {} },
  },
  salesDashboard: {
    user: {
      id: "rep-torres",
      firstName: "Michael",
      lastName: "Torres",
      email: "demo.sales@lucashealth.ai",
      role: "advanced",
      groups: ["sales-rep-master"],
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        themePreference: null,
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-manufacturer",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-sales",
    },
    orgInfo: {
      name: "National DME Solutions",
      id: DEMO_ORG,
      officeName: "National DME Solutions",
      officeAddress: "500 S Andrews Ave",
      officeCity: "Fort Lauderdale",
      officeState: "FL",
      officeZip: "33301",
      media: demoSalesMediaLibrary,
    },
    brain: { variables: {} },
  },
  manufacturer: {
    user: {
      id: "demo-user-manufacturer",
      firstName: "Karen",
      lastName: "Patel",
      email: "demo.manufacturer@lucashealth.ai",
      role: "supervisor",
      groups: ["supervisor", "team-member"],
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        themePreference: null,
        baaSignatureDate_lucas: "2025-01-01",
        baaVersion_lucas: 1,
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-manufacturer",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-manufacturer",
    },
    orgInfo: {
      name: "National DME Solutions",
      id: DEMO_ORG,
      officeName: "National DME Solutions",
      officeAddress: "500 S Andrews Ave",
      officeCity: "Fort Lauderdale",
      officeState: "FL",
      officeZip: "33301",
      media: demoSalesMediaLibrary,
      // Manufacturer's credentialed DMEs — selectable per-order during manufacturer review
      // when the provider chose "Use Manufacturer's DME". Multiple entries supported; one is
      // marked default for convenience. Same shape as provider's `dmeList`.
      credentialedDmes: [
        {
          companyName: "Coastal DME Partners",
          address: "1200 Brickell Bay Dr",
          city: "Miami",
          state: "FL",
          zip: "33131",
          phone: "(305) 555-0440",
          ptan: "FL12345678",
          nscNumber: "5500441820",
          taxId: "20-1234567",
          email: "billing@coastaldme.example",
          npi: "1234567890",
          isDefault: true,
          setupDate: "2025-09-15T00:00:00.000Z",
        },
        {
          companyName: "Sunbelt Medical Supply",
          address: "8801 Biscayne Blvd",
          city: "Miami",
          state: "FL",
          zip: "33138",
          phone: "(305) 555-0521",
          ptan: "FL87654321",
          nscNumber: "5500771230",
          taxId: "20-7654321",
          email: "ar@sunbeltmedical.example",
          npi: "9876543210",
          isDefault: false,
          setupDate: "2025-10-02T00:00:00.000Z",
        },
      ],
    },
    brain: {
      variables: {
        ordersManagement: "true",
      },
    },
  },
};

// -- Orders --
const now = new Date();
const daysAgo = (n) => new Date(now.getTime() - n * 86400000).toISOString();
const hoursAgo = (n) => new Date(now.getTime() - n * 3600000).toISOString();
const dateOnly = (n) => new Date(now.getTime() - n * 86400000).toISOString().slice(0, 10);

export const demoOrders = [
  // ==========================================
  // DRAFT (3) — incomplete orders being prepared
  // ==========================================

  // 1: Margaret Thompson — 82yo diabetic, new left plantar foot ulcer
  {
    id: "demo-order-1",
    orderUuid: "demo-uuid-001",
    status: "draft",
    patientFirstName: "Margaret",
    patientLastName: "Thompson",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(1),
    createdOn: daysAgo(1),
    lastStatusChange: Date.now() - 1 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a new ulceration on the left plantar surface of the foot, noted during routine diabetic foot examination. Reports gradual onset over the past two weeks with increasing discomfort during ambulation.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Numbness"],
    medicalConditions: ["Diabetes", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 82-year-old female with insulin-dependent diabetes mellitus and peripheral neuropathy presenting with a new left plantar foot ulcer. The wound requires collagen dressing to promote granulation tissue formation and facilitate closure. Without treatment, the wound is at high risk for infection and progression to deeper tissue involvement given the patient's comorbidities.",
    icd10Codes: [{ code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" }],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "thompson_facesheet.pdf",
    clinicalDocumentationFile: null,
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [],
    productDispensed: ["Collagen - 2x2 - A6021", "Cosmopor 3.2x4 (A6219)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "7",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Diabetic foot ulcer",
        productOrdered: "Collagen - 2x2 - A6021",
        chargeAmount: 35.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Callused",
        woundStaging: "Full Thickness",
        drainage: "Scant serous drainage noted on dressing removal. Wound bed is moist but not saturated.",
        treatmentPlan:
          "Apply collagen 2x2 dressing daily with Cosmopor secondary cover. Offload left foot with diabetic shoe insert. Reassess wound in 7 days for signs of granulation progression.",
        location: {
          site: "Foot",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 2.5,
          width: 1.8,
          depth: 0.3,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Callused",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        creatorLabel: "Lisa Nguyen",
        comment: "Following up on the IVR — please review when you have a moment.",
        date: hoursAgo(2),
        from: "manufacturer",
      },
      {
        creatorLabel: "Dr. Sarah Mitchell",
        comment: "Confirmed — moving forward.",
        date: hoursAgo(1),
        from: "provider",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: hoursAgo(20), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: hoursAgo(4), editorLabel: "Dr. Sarah Mitchell" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 0,
    manufacturerComments: 0,
    additionalIvrInfo: null,
  },

  // 2: Robert Chen — 87yo, post-surgical abdominal wound dehiscence
  {
    id: "demo-order-2",
    orderUuid: "demo-uuid-002",
    status: "draft",
    patientFirstName: "Robert",
    patientLastName: "Chen",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(2),
    createdOn: daysAgo(2),
    lastStatusChange: Date.now() - 1 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with surgical wound dehiscence of the abdominal incision following exploratory laparotomy performed 10 days ago. The wound edges have separated and there is moderate serosanguinous drainage. Patient reports increasing pain at the site.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(8),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Fever"],
    medicalConditions: ["Cardiovascular Disease"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Warfarin", "Aspirin"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 87-year-old male with cardiovascular disease and recent exploratory laparotomy presenting with abdominal wound dehiscence. The open surgical wound requires collagen dressing to support granulation tissue formation and wound contraction. The wound demonstrates moderate serosanguinous drainage necessitating absorbent secondary dressing to maintain an optimal moist wound environment and prevent maceration of surrounding tissue.",
    icd10Codes: [
      { code: "T81.31XA", description: "Disruption of external operation wound, not elsewhere classified, initial encounter" },
    ],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "chen_facesheet.pdf",
    clinicalDocumentationFile: null,
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "chen_abdomen_wound.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023", "Zetuvit 8x8 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Surgical",
        cgsWoundType: "Dehisced surgical wound",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Erythematous",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serosanguinous drainage observed with each dressing change. Periincisional skin shows mild erythema but no signs of cellulitis.",
        treatmentPlan:
          "Apply collagen 7x7 dressing to fill wound bed, cover with Zetuvit 8x8 absorbent pad. Change dressing every 24-48 hours or when saturated. Monitor for signs of infection including increased erythema, purulent drainage, or fever. Reassess in 14 days.",
        location: {
          site: "Abdomen",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Anterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 8.0,
          width: 2.0,
          depth: 1.2,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Moderate",
          surroundingSkin: "Erythematous",
          temperature: "Warm",
          edema: "Mild",
          odor: "None",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [],
    notes: [
      {
        user: "Karen Patel",
        note: "Awaiting clarification on the IVR.",
        date: hoursAgo(3),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(2), editorLabel: "Dr. Sarah Mitchell" },
      { field: "isUrgent", value: true, date: hoursAgo(5), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 0,
    manufacturerComments: 0,
    additionalIvrInfo: null,
  },

  // 3: Dorothy Williams — 81yo, brand new order, no assessment, no docs, unassigned
  {
    id: "demo-order-3",
    orderUuid: "demo-uuid-003",
    status: "draft",
    patientFirstName: "Dorothy",
    patientLastName: "Williams",
    organizationId: "demo-org",
    organizationName: "Fort Lauderdale Clinic",
    dateOfService: dateOnly(0),
    createdOn: daysAgo(0),
    lastStatusChange: Date.now(),
    assignedTo: null,
    woundVisitNumber: "",
    chiefComplaint: "",
    hasContraindications: "",
    contraindications: [],
    isReceivingHomeCare: "",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: [],
    medicalConditions: [],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity: "",
    icd10Codes: [],
    followUpDays: "",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: null,
    clinicalDocumentationFile: null,
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [],
    productDispensed: [],
    woundAssessment: [],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [],
    notes: [],
    history: [{ field: "created", value: null, date: daysAgo(0), editorLabel: "Dr. Sarah Mitchell" }],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 0,
    manufacturerComments: 0,
    additionalIvrInfo: null,
  },

  // ==========================================
  // SUBMITTED (3) — orders awaiting physician signature
  // ==========================================

  // 4: James Martinez — 75yo URGENT, 2 wounds: sacral pressure ulcer stage III + right heel pressure ulcer with tunneling
  {
    id: "demo-order-4",
    orderUuid: "demo-uuid-004",
    status: "submitted",
    patientFirstName: "James",
    patientLastName: "Martinez",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(5),
    createdOn: daysAgo(5),
    lastStatusChange: Date.now() - 3 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "2",
    chiefComplaint:
      "Patient returns for follow-up of stage III sacral pressure ulcer and right heel pressure ulcer with tunneling. The sacral wound shows slow granulation progression. The heel wound continues to demonstrate purulent drainage and tunneling at 12 o'clock. Patient reports chills and increased pain at both sites over the past 48 hours.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(20),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Chills"],
    medicalConditions: ["Diabetes", "Decreased Mobility", "Infection"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Eliquis"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 75-year-old male with diabetes, decreased mobility, and suspected wound infection presenting with two pressure ulcers requiring ongoing wound care. The sacral stage III pressure ulcer requires collagen dressing to promote granulation in a slow-healing wound bed. The right heel pressure ulcer demonstrates tunneling at 2cm depth requiring collagen powder to fill the dead space and promote healing from the wound base. Both wounds require absorbent secondary dressings due to moderate exudate. The patient's diabetes and immobility place him at elevated risk for wound progression without appropriate treatment.",
    icd10Codes: [
      { code: "L89.153", description: "Pressure ulcer of sacral region, stage III" },
      { code: "L89.613", description: "Pressure ulcer of right heel, stage III" },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "martinez_facesheet.pdf",
    clinicalDocumentationFile: "martinez_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "martinez_sacral.jpg" }, { fileName: "martinez_heel.jpg" }],
    productDispensed: ["Collagen - 4x4 - A6021", "Zetuvit 6x10 (A6197)", "Collagen Powder - A6010", "Zetuvit 4x4 (A6196)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: "Zetuvit 6x10 (A6197)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate serous drainage noted. Wound bed is moist with 60% granulation tissue, 30% slough, and 10% eschar at wound margins. Periwound skin intact with mild erythema.",
        treatmentPlan:
          "Apply collagen 4x4 dressing to wound bed daily, cover with Zetuvit 6x10 absorbent pad. Continue pressure redistribution mattress and repositioning schedule every 2 hours. Monitor for signs of infection. Reassess in 14 days.",
        location: {
          site: "Sacrum",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Posterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 4.2,
          width: 3.1,
          depth: 0.5,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Erythematous",
          temperature: "WNL",
          edema: "Mild",
          odor: "None",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Present",
          pain: "true",
        },
      },
      {
        id: 2,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen Powder - A6010",
        chargeAmount: 85.0,
        secondaryDressing: "Zetuvit 4x4 (A6196)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate purulent drainage from wound base and tunneling tract. Wound bed shows 50% granulation, 40% slough, and 10% necrotic tissue. Surrounding skin is erythematous and warm to touch.",
        treatmentPlan:
          "Pack tunneling tract with collagen powder, apply Zetuvit 4x4 absorbent secondary cover. Change dressing daily. Continue offloading right heel with heel suspension boot. Obtain wound culture if purulent drainage persists. Reassess in 14 days.",
        location: {
          site: "Heel",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.0,
          width: 2.5,
          depth: 0.8,
          depthExposure: "Full Thickness",
          tunneling: "true",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Purulent",
          exudateAmount: "Moderate",
          surroundingSkin: "Erythematous",
          temperature: "Warm",
          edema: "Mild",
          odor: "Foul",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(4),
        comment:
          "Patient requires urgent assessment - multiple wound sites with signs of possible infection at heel wound. Cultures have been ordered.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(3),
        comment:
          "Insurance verification in progress for Medicare coverage of multi-wound dressing supplies. Expect confirmation within 24 hours.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(5), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(3), editorLabel: "Lisa Nguyen" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: null,
    // Reviewed after its newest activity (daysAgo(3)) so it lands in the
    // activity drawer's "Recently seen" tab with reviewer attribution.
    activityReviewInfo: {
      reviewedBy: "demo-user-manufacturer",
      reviewedByLabel: "Karen Patel",
      reviewedAt: daysAgo(2),
    },
  },

  // 5: Helen Johnson — 89yo, left plantar diabetic foot ulcer, IVR completed
  {
    id: "demo-order-5",
    orderUuid: "demo-uuid-005",
    status: "submitted",
    patientFirstName: "Helen",
    patientLastName: "Johnson",
    organizationId: "demo-org",
    organizationName: "Fort Lauderdale Clinic",
    dateOfService: dateOnly(4),
    createdOn: daysAgo(4),
    lastStatusChange: Date.now() - 3 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a diabetic foot ulcer on the left plantar surface, first identified by her home health nurse 5 days ago. The ulcer developed beneath a callus that was debrided revealing a shallow open wound. Patient reports numbness in both feet and mild pain with weight bearing.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(30),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Numbness"],
    medicalConditions: ["Diabetes", "CHF"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin", "Plavix"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 89-year-old female with type 2 diabetes, congestive heart failure, and peripheral neuropathy presenting with a new left plantar foot ulcer. Collagen dressing is medically necessary to promote granulation tissue formation in a patient with significantly impaired healing capacity due to diabetes and CHF. The scant exudate requires a light secondary cover to protect the wound. The patient's advanced age, neuropathy, and cardiac comorbidities place her at substantial risk for wound progression and limb-threatening infection without appropriate treatment.",
    icd10Codes: [{ code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "johnson_facesheet.pdf",
    clinicalDocumentationFile: "johnson_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "johnson_foot_ulcer.jpg" }],
    productDispensed: ["Collagen - 2x2 - A6021", "Cosmopor 3.2x4 (A6219)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every other day",
        woundType: "Chronic",
        cgsWoundType: "Diabetic foot ulcer",
        productOrdered: "Collagen - 2x2 - A6021",
        chargeAmount: 35.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Callused",
        woundStaging: "Partial Thickness",
        drainage:
          "Scant serous drainage noted. Wound bed is clean with 85% granulation tissue and 15% slough. No signs of infection.",
        treatmentPlan:
          "Apply collagen 2x2 dressing to wound bed, cover with Cosmopor 3.2x4. Change dressing every 48 hours. Patient to wear offloading diabetic shoe at all times during ambulation. Home health nurse to perform dressing changes. Reassess in 14 days.",
        location: {
          site: "Foot",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 2.0,
          width: 1.5,
          depth: 0.2,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Callused",
          temperature: "WNL",
          edema: "Mild",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(3),
        comment:
          "IVR completed successfully. Patient confirmed delivery address and availability for shipment. Home health nurse visits Monday, Wednesday, and Friday.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        creatorLabel: "Dr. Sarah Mitchell",
        comment: "Hey Karen, can you confirm the dressing size on this one?",
        date: hoursAgo(1),
        from: "provider",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(4), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(3), editorLabel: "Lisa Nguyen" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 0,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(3),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-00512",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 6: William Davis — 82yo, right medial ankle venous leg ulcer, HEAVY exudate (no secondary)
  {
    id: "demo-order-6",
    orderUuid: "demo-uuid-006",
    status: "submitted",
    patientFirstName: "William",
    patientLastName: "Davis",
    organizationId: "demo-org",
    organizationName: "Boca Raton Medical Plaza",
    dateOfService: dateOnly(3),
    createdOn: daysAgo(3),
    lastStatusChange: Date.now() - 2 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "3",
    chiefComplaint:
      "Patient returns for third visit to manage chronic venous leg ulcer of the right medial ankle. The wound continues to produce heavy serosanguinous drainage requiring frequent dressing changes. Compression therapy has been initiated but the patient reports difficulty tolerating wraps due to discomfort. Periwound skin shows maceration and hemosiderin staining consistent with chronic venous insufficiency.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Decreased Mobility", "Cardiovascular Disease"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Xarelto"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 82-year-old male with cardiovascular disease, chronic venous insufficiency, and decreased mobility presenting with a chronic venous leg ulcer producing heavy exudate. Collagen dressing is medically necessary to provide a bioactive wound matrix that supports granulation in a stalled wound. The heavy exudate volume precludes the use of a standard secondary dressing. The patient's venous disease and anticoagulant therapy contribute to delayed healing and continued high drainage output.",
    icd10Codes: [
      {
        code: "L97.919",
        description: "Non-pressure chronic ulcer of unspecified part of right lower leg with unspecified severity",
      },
    ],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "davis_facesheet.pdf",
    clinicalDocumentationFile: "davis_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "davis_venous_ulcer.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: false,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every other day",
        woundType: "Chronic",
        cgsWoundType: "Venous stasis ulcer",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: null,
        skinCondition: "Macerated",
        woundStaging: "Full Thickness",
        drainage:
          "Heavy serosanguinous drainage saturating dressings within 8-12 hours. Periwound maceration noted with hemosiderin staining extending 3cm from wound margins. Wound bed shows 40% granulation, 50% slough, and 10% fibrin.",
        treatmentPlan:
          "Apply collagen 7x7 dressing to wound bed. No secondary dressing due to heavy exudate volume — use compression wrap system as outer cover. Change dressing every 12-24 hours as needed. Continue compression therapy as tolerated. Apply skin barrier to periwound area to prevent further maceration. Reassess in 7 days.",
        location: {
          site: "Ankle",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Medial",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 5.8,
          width: 4.2,
          depth: 0.2,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "true",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Heavy",
          surroundingSkin: "Macerated",
          temperature: "WNL",
          edema: "Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(2),
        comment:
          "Heavy drainage is consistent with chronic venous insufficiency. Please ensure patient has adequate supply of dressings for frequent changes.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(2),
        comment:
          "Consider adding compression stockings to order if insurance covers. Patient needs multi-layer compression to manage edema.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        creatorLabel: "Karen Patel",
        comment: "Dr. Sarah, please review the updated IVR.",
        date: hoursAgo(1),
        from: "manufacturer",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(3), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(2), editorLabel: "Lisa Nguyen" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 0,
    additionalIvrInfo: null,
  },

  // ==========================================
  // SIGNED (2) — physician has signed, awaiting manufacturer review
  // ==========================================

  // 7: Patricia Garcia — 77yo, right medial ankle venous leg ulcer, heavy exudate
  {
    id: "demo-order-7",
    orderUuid: "demo-uuid-007",
    status: "approved",
    patientFirstName: "Patricia",
    patientLastName: "Garcia",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(8),
    createdOn: daysAgo(8),
    lastStatusChange: Date.now() - 5 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "2",
    chiefComplaint:
      "Patient returns for follow-up of chronic venous leg ulcer on the right medial ankle. The wound has shown minimal improvement since last visit. Heavy serosanguinous drainage persists. Patient reports leg heaviness and aching pain that worsens with prolonged standing. She has been compliant with elevation and compression therapy.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(25),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Swelling"],
    medicalConditions: ["CHF", "Anemia"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Warfarin"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 77-year-old female with congestive heart failure, anemia, and chronic venous insufficiency presenting with a non-healing venous leg ulcer producing heavy drainage. The wound has been present for over 6 weeks and shows stalled healing. Collagen dressing is medically necessary to provide a bioactive scaffold for granulation tissue formation. The patient's CHF contributes to lower extremity edema exacerbating venous hypertension and impaired wound healing. Anemia further compromises oxygen delivery to the wound bed.",
    icd10Codes: [
      {
        code: "L97.919",
        description: "Non-pressure chronic ulcer of unspecified part of right lower leg with unspecified severity",
      },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "garcia_facesheet.pdf",
    clinicalDocumentationFile: "garcia_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "garcia_venous_ulcer.jpg" }],
    productDispensed: ["Collagen - 4x4 - A6021"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: false,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Venous stasis ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: null,
        skinCondition: "Hemosiderin Staining",
        woundStaging: "Full Thickness",
        drainage:
          "Heavy serosanguinous drainage requiring dressing changes twice daily. Periwound skin shows chronic hemosiderin staining and early maceration. Wound bed demonstrates 55% granulation tissue with 35% slough and 10% fibrin.",
        treatmentPlan:
          "Apply collagen 4x4 dressing to wound bed. No secondary dressing due to heavy exudate — use multi-layer compression wrap as outer layer. Change inner dressing every 12 hours. Continue compression therapy. Elevate leg above heart level when resting. Reassess in 14 days. Consider referral to vascular surgery if no improvement by next visit.",
        location: {
          site: "Ankle",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Medial",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.5,
          width: 2.8,
          depth: 0.3,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Heavy",
          surroundingSkin: "Hemosiderin Staining",
          temperature: "WNL",
          edema: "Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: hoursAgo(12),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: hoursAgo(6),
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(6),
        comment: "Order is ready for processing. Patient has been verified and all clinical documentation is complete.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(5),
        comment:
          "Received. Currently reviewing insurance coverage for Humana plan and verifying prior authorization requirements.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(5),
        comment:
          "Please expedite review if possible - patient is experiencing significant pain and heavy drainage is saturating dressings rapidly.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
    ],
    notes: [
      {
        note: "Insurance verified - Humana covers collagen dressings under DME benefit. No prior authorization required for A6021.",
        creatorLabel: "Karen Patel",
        date: daysAgo(5),
      },
    ],
    history: [
      { field: "created", value: null, date: hoursAgo(22), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: hoursAgo(18), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "signed", date: hoursAgo(12), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: hoursAgo(6), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 1,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(6),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-00710",
      coverageDetails: {
        planCategory: "Commercial",
        commercialPlanType: "PPO",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        exclusions: "Skin substitutes require separate pre-auth",
        benefitMaximum: "5000.00",
      },
      financialResponsibility: {
        deductibleIndividual: "500.00",
        deductibleIndividualMet: "350.00",
        deductibleIndividualRemaining: "150.00",
        oopMaxIndividual: "6500.00",
        oopMaxIndividualMet: "1200.00",
        oopMaxIndividualRemaining: "5300.00",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
        exclusions: "Skin substitutes require separate pre-auth",
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 8: Richard Brown — 85yo URGENT, right heel pressure ulcer with tunneling, Collagen Powder
  {
    id: "demo-order-8",
    orderUuid: "demo-uuid-008",
    status: "signed",
    patientFirstName: "Richard",
    patientLastName: "Brown",
    organizationId: "demo-org",
    organizationName: "Fort Lauderdale Clinic",
    dateOfService: dateOnly(7),
    createdOn: daysAgo(7),
    lastStatusChange: Date.now() - 5 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a deep pressure ulcer on the right heel with tunneling identified during initial wound evaluation. The wound developed during a recent hospitalization for pneumonia. Patient is bed-bound with limited mobility and reports significant pain at the wound site. The tunneling tract extends 2cm at the 12 o'clock position.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(14),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Fever"],
    medicalConditions: ["Diabetes", "Infection"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Pradaxa"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 85-year-old male with diabetes and suspected wound infection presenting with a right heel pressure ulcer with 2cm tunneling. Collagen powder is medically necessary to fill the tunneling tract and promote healing from the wound base outward. The patient's diabetes, advanced age, and current anticoagulant therapy significantly impair wound healing and increase risk of wound progression. The presence of purulent drainage and tunneling indicates the need for urgent wound care intervention to prevent osteomyelitis and potential limb loss.",
    icd10Codes: [{ code: "L89.613", description: "Pressure ulcer of right heel, stage III" }],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "brown_facesheet.pdf",
    clinicalDocumentationFile: "brown_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "brown_heel_wound.jpg" }],
    productDispensed: ["Collagen Powder - A6010", "Zetuvit 4x4 (A6196)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen Powder - A6010",
        chargeAmount: 85.0,
        secondaryDressing: "Zetuvit 4x4 (A6196)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate purulent drainage from the wound base and tunneling tract. Wound culture pending. Wound bed shows 50% granulation tissue, 40% slough, and 10% necrotic tissue. Surrounding skin is erythematous and warm to palpation.",
        treatmentPlan:
          "Pack tunneling tract with collagen powder using cotton-tipped applicator. Cover wound with Zetuvit 4x4 absorbent pad. Change dressing daily. Maintain heel suspension with boot to offload pressure. Start empiric antibiotics pending culture results. Reassess wound in 7 days with focus on tunneling depth and drainage character.",
        location: {
          site: "Heel",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.0,
          width: 2.5,
          depth: 0.8,
          depthExposure: "Full Thickness",
          tunneling: "true",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Purulent",
          exudateAmount: "Moderate",
          surroundingSkin: "Erythematous",
          temperature: "Warm",
          edema: "Mild",
          odor: "Foul",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(5),
    signedBy: "Dr. Mark Phillips",
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(6),
        comment:
          "This patient needs urgent attention. Tunneling wound with purulent drainage and signs of active infection. Please prioritize processing.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(5),
        comment:
          "Received and flagged as urgent. Reviewing Medicare coverage for collagen powder and absorbent dressing supplies now.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(4),
        comment:
          "Wound culture returned MRSA positive. Patient has been switched to Bactrim DS BID. Please ensure dressing supplies ship as soon as possible.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
    ],
    notes: [
      {
        note: "Insurance verified - Medicare Part B covers collagen powder (A6010) and absorbent dressing (A6196). No prior auth needed for initial 30-day supply.",
        creatorLabel: "Karen Patel",
        date: daysAgo(5),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(7), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(6), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(5), editorLabel: "Dr. Mark Phillips" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 1,
    auditPacket: {
      status: "approved",
      events: [
        {
          id: "evt-demo-8-approved",
          type: "APPROVED",
          actor: { userId: "demo-user-manufacturer", name: "Karen Patel", role: "supervisor", orgId: "demo-org" },
          timestamp: hoursAgo(2),
          payload: { approvalComment: "All documentation in order.", compliancePercentage: 100 },
        },
      ],
    },
    additionalIvrInfo: {
      ivrStatus: "completed",
      auditLog: [
        {
          action: "cleared",
          user: "Karen Patel",
          timestamp: hoursAgo(4),
          message: "Reviewed and cleared by Karen Patel",
        },
      ],
      verificationDate: dateOnly(8),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-00815",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "03/01/2026",
        effectiveDateEnd: "02/28/2027",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // APPROVED (2) — manufacturer approved, ready to ship
  // ==========================================

  // 9: Margaret Thompson — surgical wound follow-up, visit #2, approved 9 days ago
  {
    id: "demo-order-9",
    orderUuid: "demo-uuid-009",
    status: "approved",
    patientFirstName: "Margaret",
    patientLastName: "Thompson",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(14),
    createdOn: daysAgo(14),
    lastStatusChange: Date.now() - 9 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "2",
    chiefComplaint:
      "Patient returns for follow-up of abdominal surgical wound following cholecystectomy. The wound has been healing with collagen dressing and shows improvement from the first visit. Wound dimensions have decreased and granulation tissue has increased. Patient reports decreasing pain and is tolerating dressing changes well.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(28),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Diabetes", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 82-year-old female with diabetes and decreased mobility presenting for follow-up of a healing surgical wound. Continued collagen dressing is medically necessary to maintain the progress of granulation tissue formation and support wound closure. The wound has shown improvement but remains open and requires ongoing treatment. Premature discontinuation of collagen therapy risks wound regression given the patient's impaired healing due to diabetes.",
    icd10Codes: [
      { code: "T81.31XA", description: "Disruption of external operation wound, not elsewhere classified, initial encounter" },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "thompson_facesheet_v2.pdf",
    clinicalDocumentationFile: "thompson_clinical_v2.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "thompson_surgical_wound.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023", "Zetuvit 8x8 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every other day",
        woundType: "Surgical",
        cgsWoundType: "Dehisced surgical wound",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Improving",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serosanguinous drainage, decreased from previous visit. Wound bed shows 75% granulation tissue with 25% slough. Wound edges are approximating and periwound skin shows resolving erythema.",
        treatmentPlan:
          "Continue collagen 7x7 dressing with Zetuvit 8x8 secondary cover. Change dressing every 24-48 hours. Monitor for continued wound contraction. Home health nurse to perform dressing changes on scheduled visits. Reassess in 14 days.",
        location: {
          site: "Abdomen",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Anterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 6.5,
          width: 1.8,
          depth: 0.9,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Moderate",
          surroundingSkin: "Mild Erythema",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Resolving",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(11),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(9),
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(10),
        comment: "Order approved and scheduling shipment. Stock has been confirmed for collagen 7x7 and Zetuvit 8x8.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(9),
        comment: "Thank you for the quick turnaround. Patient is expecting delivery and has confirmed availability.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(9),
        comment: "Stock confirmed in warehouse. Shipment will be processed within 2 business days.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Medicare coverage confirmed for reorder. No prior authorization required for A6023.",
        creatorLabel: "Karen Patel",
        date: daysAgo(10),
      },
      {
        note: "Insurance pre-auth obtained for continued wound care supplies through end of treatment period.",
        creatorLabel: "Karen Patel",
        date: daysAgo(9),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(14), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(12), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(11), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(9), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 2,
    additionalIvrInfo: {
      ivrStatus: "denied",
      auditLog: [
        {
          action: "denied",
          user: "Karen Patel",
          timestamp: hoursAgo(3),
          message: "Reviewed and denied — patient ineligible for HCPCS A6021",
        },
      ],
      verificationDate: dateOnly(10),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-00918",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 10: Robert Chen — sacral pressure ulcer reorder, visit #3, approved 8 days ago
  {
    id: "demo-order-10",
    orderUuid: "demo-uuid-010",
    status: "approved",
    patientFirstName: "Robert",
    patientLastName: "Chen",
    organizationId: "demo-org",
    organizationName: "Boca Raton Medical Plaza",
    dateOfService: dateOnly(12),
    createdOn: daysAgo(12),
    lastStatusChange: Date.now() - 8 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "3",
    chiefComplaint:
      "Patient returns for third visit managing sacral pressure ulcer. The wound shows steady improvement with granulation tissue increasing from 60% to 70% since last assessment. Wound depth has decreased. Patient is tolerating repositioning schedule and nutritional supplementation. Pain is well controlled with current regimen.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(40),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Cardiovascular Disease", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Warfarin", "Aspirin"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 87-year-old male with cardiovascular disease and limited mobility presenting for continued management of a sacral pressure ulcer. The wound is responding to collagen dressing therapy with measurable improvement in granulation tissue and wound depth. Continued collagen treatment is medically necessary to sustain healing trajectory. Interruption of treatment would risk wound regression given the patient's age, immobility, and cardiovascular comorbidities that compromise tissue perfusion.",
    icd10Codes: [{ code: "L89.153", description: "Pressure ulcer of sacral region, stage III" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { useManufacturerDME: true }, label: "Use Manufacturer's DME" },
    // Demo fixture: manufacturer picked one of their credentialed DMEs during review.
    // Drives the documentation auto-fill verification path (IVR, 1500, order PDF, etc.).
    manufacturerDmeProvider: {
      key: {
        companyName: "Coastal DME Partners",
        address: "1200 Brickell Bay Dr",
        city: "Miami",
        state: "FL",
        zip: "33131",
        phone: "(305) 555-0440",
        ptan: "FL12345678",
        nscNumber: "5500441820",
        taxId: "20-1234567",
        email: "billing@coastaldme.example",
        npi: "1234567890",
        isDefault: true,
      },
      label: "Coastal DME Partners",
    },
    useShorelineInsurance: "false",
    faceSheetFile: "chen_facesheet_reorder.pdf",
    clinicalDocumentationFile: "chen_clinical_reorder.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "chen_sacral_followup.jpg" }],
    productDispensed: ["Collagen - 4x4 - A6021", "Zetuvit 6x10 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: "Zetuvit 6x10 (A6197)",
        skinCondition: "Improving",
        woundStaging: "Stage 3",
        drainage:
          "Moderate serous drainage, volume decreasing compared to previous visits. Wound bed shows 70% granulation tissue, 20% slough, and 10% eschar at periphery. Wound is contracting with measurable reduction in dimensions.",
        treatmentPlan:
          "Continue collagen 4x4 dressing with Zetuvit 6x10 secondary cover. Change dressing daily. Maintain strict repositioning schedule every 2 hours. Continue high-protein nutritional supplements. Monitor eschar at wound margins — do not debride unless signs of infection develop. Reassess in 14 days.",
        location: {
          site: "Sacrum",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Posterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.8,
          width: 2.9,
          depth: 0.4,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Mild Erythema",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Mild",
          cellulitis: "Not Present",
          eschar: "Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(10),
    signedBy: "Dr. Mark Phillips",
    approvedOn: daysAgo(8),
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(9),
        comment: "BCBS coverage confirmed. Order has been approved for a 30-day supply of collagen and secondary dressings.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(8),
        comment:
          "Wound is improving steadily. Thank you for confirming coverage - patient has been anxious about supply continuity.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(8),
        comment: "Noted. We will prioritize shipment to ensure no gap in dressing supply for this patient.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "BlueCross BlueShield verified. Prior authorization on file through end of month for continued wound care supplies.",
        creatorLabel: "Karen Patel",
        date: daysAgo(9),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(12), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(11), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(10), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "approved", date: daysAgo(8), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 2,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(9),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01022",
      coverageDetails: {
        planCategory: "Commercial",
        commercialPlanType: "HMO",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        referralFrom: "PCP",
        referralNumber: "REF-88421",
        benefitMaximum: "10000.00",
      },
      financialResponsibility: {
        deductibleIndividual: "750.00",
        deductibleIndividualMet: "750.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "8000.00",
        oopMaxIndividualMet: "2100.00",
        oopMaxIndividualRemaining: "5900.00",
        coinsurancePercentage: "15",
      },
      authorizationReferral: {
        referralRequired: true,
        preAuthRequired: false,
        referralFrom: "PCP",
        referralNumber: "REF-88421",
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // SHIPPED (2) — products shipped to patient
  // ==========================================

  // 11: Dorothy Williams — left plantar diabetic foot ulcer, shipped 11 days ago via UPS
  {
    id: "demo-order-11",
    orderUuid: "demo-uuid-011",
    status: "shipped",
    patientFirstName: "Dorothy",
    patientLastName: "Williams",
    patientDOB: "1945-03-08",
    patientGender: "Female",
    patientAddress: "891 Coral Way",
    patientCity: "Miami",
    patientState: "FL",
    patientZipCode: "33145",
    patientPhone: "(786) 555-0167",
    primaryInsuranceName: "Aetna",
    primaryPolicyNumber: "W29385710042",
    primaryGroupNumber: "GRP-88210",
    primaryPlanType: "Commercial",
    primaryInsuredState: "FL",
    primaryInsuredZipCode: "33145",
    primaryInsuredPhone: "(786) 555-0167",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Sarah Mitchell",
    signedUserNPI: "1234567890",
    signedDate: daysAgo(15),
    officeName: "Sunshine Wound Care Associates",
    officeAddress: "1200 NW 7th Ave",
    officeCity: "Miami",
    officeState: "FL",
    officeZip: "33136",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(18),
    createdOn: daysAgo(18),
    lastStatusChange: Date.now() - 11 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a new diabetic foot ulcer on the left plantar surface, discovered during routine diabetic foot exam. The ulcer appears to have developed under a callus. Patient has peripheral neuropathy and was unaware of the wound until examination. No signs of infection at initial presentation.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Numbness"],
    medicalConditions: ["Diabetes", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "false",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 81-year-old female with diabetes and peripheral neuropathy presenting with a new left plantar foot ulcer. Collagen dressing is medically necessary to promote granulation tissue in a neuropathic ulcer with impaired sensation. The patient's neuropathy means she cannot feel pain that would normally prompt protective behaviors, increasing the risk of wound progression. Scant drainage requires a light secondary cover for wound protection.",
    icd10Codes: [{ code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "williams_facesheet.pdf",
    clinicalDocumentationFile: "williams_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "williams_pod.pdf",
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "williams_foot_ulcer.jpg" }],
    productDispensed: ["Collagen - 2x2 - A6021", "Cosmopor 3.2x4 (A6219)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Diabetic foot ulcer",
        productOrdered: "Collagen - 2x2 - A6021",
        chargeAmount: 35.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Callused",
        woundStaging: "Partial Thickness",
        drainage:
          "Scant serous drainage. Wound bed is clean with 80% granulation tissue and 20% slough. Callused periwound skin debrided at wound margins.",
        treatmentPlan:
          "Apply collagen 2x2 dressing to wound bed, cover with Cosmopor 3.2x4. Change dressing every 48 hours. Patient instructed to wear offloading diabetic shoe insert at all times during ambulation. Daily foot inspection required. Reassess in 14 days.",
        location: {
          site: "Foot",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 1.8,
          width: 1.4,
          depth: 0.2,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Callused",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "false",
        },
      },
    ],
    signedOn: daysAgo(15),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(13),
    shipmentDate: dateOnly(11),
    carrier: "UPS",
    trackingCode: "1Z999AA10123456784",
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(12),
        comment: "Shipped via UPS Ground. Tracking number: 1Z999AA10123456784. Estimated delivery within 2-3 business days.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(11),
        comment: "Received tracking information, thank you. Patient has been notified of expected delivery window.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(11),
        comment: "Package picked up by UPS. Estimated delivery date is within 2-3 business days from shipment.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Shipped from Miami warehouse via UPS Ground. Tracking: 1Z999AA10123456784.",
        creatorLabel: "Karen Patel",
        date: daysAgo(12),
      },
      {
        note: "Aetna coverage confirmed. UPS ground shipping - estimated 2 day delivery to patient address.",
        creatorLabel: "Karen Patel",
        date: daysAgo(11),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(18), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(16), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(15), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(13), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(11), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: {
      status: "signed",
      createdAt: hoursAgo(5),
      createdBy: "demo-user-provider",
      createdByLabel: "Dr. Sarah Mitchell",
      notes: "Late-finding addendum: patient also reports calf cramping at night. Adding venous component to plan of care.",
      signedAt: hoursAgo(5),
      signedBy: "demo-user-provider",
      signedByLabel: "Dr. Sarah Mitchell",
      signedByCredentials: "MD",
      signedByNPI: "1234567890",
      entries: [],
    },
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 2,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(14),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01105",
      coverageDetails: {
        planCategory: "Commercial",
        commercialPlanType: "PPO",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "7500.00",
      },
      financialResponsibility: {
        deductibleIndividual: "500.00",
        deductibleIndividualMet: "500.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "5000.00",
        oopMaxIndividualMet: "1800.00",
        oopMaxIndividualRemaining: "3200.00",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 12: James Martinez — URGENT, 2 wounds (venous ulcer + tunneling heel), shipped 12 days ago via FedEx
  {
    id: "demo-order-12",
    orderUuid: "demo-uuid-012",
    status: "shipped",
    patientFirstName: "James",
    patientLastName: "Martinez",
    patientDOB: "1950-09-30",
    patientGender: "Male",
    patientAddress: "4210 Congress Ave",
    patientCity: "Boynton Beach",
    patientState: "FL",
    patientZipCode: "33426",
    patientPhone: "(561) 555-0234",
    primaryInsuranceName: "Medicare",
    primaryPolicyNumber: "3KF7-RB2-NP41",
    primaryGroupNumber: "",
    primaryPlanType: "Medicare",
    primaryInsuredState: "FL",
    primaryInsuredZipCode: "33426",
    primaryInsuredPhone: "(561) 555-0234",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Sarah Mitchell",
    signedUserNPI: "1234567890",
    signedDate: daysAgo(16),
    officeName: "Sunshine Wound Care Associates",
    officeAddress: "1200 NW 7th Ave",
    officeCity: "Miami",
    officeState: "FL",
    officeZip: "33136",
    organizationId: "demo-org",
    organizationName: "Fort Lauderdale Clinic",
    dateOfService: dateOnly(20),
    createdOn: daysAgo(20),
    lastStatusChange: Date.now() - 12 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with two wounds requiring concurrent treatment: a left medial ankle venous leg ulcer with undermining and moderate serosanguinous drainage, and a left plantar heel wound with tunneling and purulent drainage. The venous ulcer has been present for approximately 3 months. The heel wound developed during a recent period of prolonged bed rest. Patient reports significant pain at both wound sites.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(25),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Swelling"],
    medicalConditions: ["Diabetes", "Decreased Mobility", "Cardiovascular Disease"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Eliquis"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 75-year-old male with diabetes, cardiovascular disease, and decreased mobility presenting with two concurrent wounds. The left medial ankle venous leg ulcer requires collagen 7x7 dressing to promote granulation in a chronic wound with undermining and moderate drainage. The left heel wound with tunneling requires collagen powder to fill the dead space and prevent abscess formation. Both wounds require absorbent secondary dressings. The patient's multiple comorbidities and anticoagulant therapy create a high-risk profile for wound progression and systemic infection without aggressive wound management.",
    icd10Codes: [
      {
        code: "L97.919",
        description: "Non-pressure chronic ulcer of unspecified part of right lower leg with unspecified severity",
      },
      { code: "L89.613", description: "Pressure ulcer of right heel, stage III" },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "martinez_facesheet_v2.pdf",
    clinicalDocumentationFile: "martinez_clinical_v2.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "martinez_pod.pdf",
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "martinez_venous_ulcer.jpg" }, { fileName: "martinez_heel_tunnel.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023", "Zetuvit 8x8 (A6197)", "Collagen Powder - A6010", "Zetuvit 4x4 (A6196)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Venous stasis ulcer",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Macerated",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serosanguinous drainage with periwound maceration and hemosiderin staining extending 3cm from wound margins. Wound bed shows 55% granulation, 35% slough, and 10% fibrin. Undermining noted at 2cm at 6 o'clock position.",
        treatmentPlan:
          "Apply collagen 7x7 dressing to wound bed, cover with Zetuvit 8x8 absorbent pad. Apply skin barrier to periwound area. Change dressing daily or when saturated. Initiate compression therapy as tolerated. Elevate leg when resting. Reassess in 14 days.",
        location: {
          site: "Ankle",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Medial",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 6.0,
          width: 5.5,
          depth: 0.3,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "true",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Moderate",
          surroundingSkin: "Macerated",
          temperature: "WNL",
          edema: "Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
      {
        id: 2,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen Powder - A6010",
        chargeAmount: 85.0,
        secondaryDressing: "Zetuvit 4x4 (A6196)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate purulent drainage from tunneling tract. Wound bed shows 45% granulation, 45% slough, and 10% necrotic tissue. Tunneling measures 1.5cm at 9 o'clock. Surrounding skin erythematous and warm.",
        treatmentPlan:
          "Pack tunneling tract with collagen powder. Cover with Zetuvit 4x4 absorbent pad. Change dressing daily. Offload left heel with suspension boot. Monitor for signs of worsening infection. Reassess in 14 days.",
        location: {
          site: "Heel",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 2.8,
          width: 2.0,
          depth: 0.6,
          depthExposure: "Full Thickness",
          tunneling: "true",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Purulent",
          exudateAmount: "Moderate",
          surroundingSkin: "Erythematous",
          temperature: "Warm",
          edema: "Mild",
          odor: "Foul",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(17),
    signedBy: "Dr. Mark Phillips",
    approvedOn: daysAgo(15),
    shipmentDate: dateOnly(12),
    carrier: "FedEx",
    trackingCode: "794644790138",
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(14),
        comment: "Shipped via FedEx Express for expedited delivery due to urgent status. Tracking: 794644790138.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(13),
        comment:
          "Thank you for expediting. Patient has been notified of FedEx delivery and his daughter will be available to receive the package.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(12),
        comment: "FedEx confirms package is in transit. Estimated delivery tomorrow by end of day.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(12),
        comment:
          "Patient's home health aide has been briefed on the new dressing protocol for both wound sites. Ready to begin treatment upon delivery.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
    ],
    notes: [
      {
        note: "Medicare coverage confirmed for all 4 products (A6023, A6197, A6010, A6196). FedEx tracking: 794644790138.",
        creatorLabel: "Karen Patel",
        date: daysAgo(14),
      },
      {
        note: "Shipped from Fort Lauderdale warehouse via FedEx Express. Expedited due to urgent multi-wound case.",
        creatorLabel: "Karen Patel",
        date: daysAgo(12),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(20), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(18), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(17), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "approved", date: daysAgo(15), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(12), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 2,
    auditPacket: {
      status: "in_review",
      events: [
        {
          id: "evt-demo-12-approved",
          type: "APPROVED",
          actor: { userId: "demo-user-manufacturer", name: "Karen Patel", role: "supervisor", orgId: "demo-org" },
          timestamp: hoursAgo(14),
          payload: { approvalComment: "Initial review passed.", compliancePercentage: 95 },
        },
        {
          id: "evt-demo-12-reopened",
          type: "REOPENED",
          actor: { userId: "demo-user-provider", name: "Dr. Sarah Mitchell", role: "doctor", orgId: "demo-org" },
          timestamp: hoursAgo(2),
          payload: { reopenReason: "Need to amend ICD-10 codes after specialist consult." },
        },
      ],
    },
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(15),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01208",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        authNumber: "AUTH-MC-90142",
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
        authNumber: "AUTH-MC-90142",
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // DELIVERED (2) — completed orders
  // ==========================================

  // 13: Helen Johnson — sacral pressure ulcer, delivered 15 days ago, has proof of delivery
  {
    id: "demo-order-13",
    orderUuid: "demo-uuid-013",
    status: "delivered",
    patientFirstName: "Helen",
    patientLastName: "Johnson",
    patientDOB: "1937-01-17",
    patientGender: "Female",
    patientAddress: "655 Brickell Key Dr",
    patientCity: "Miami",
    patientState: "FL",
    patientZipCode: "33131",
    patientPhone: "(305) 555-0189",
    primaryInsuranceName: "Medicare",
    primaryPolicyNumber: "8HJ2-WQ9-LX56",
    primaryGroupNumber: "",
    primaryPlanType: "Medicare",
    primaryInsuredState: "FL",
    primaryInsuredZipCode: "33131",
    primaryInsuredPhone: "(305) 555-0189",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Sarah Mitchell",
    signedUserNPI: "1234567890",
    signedDate: daysAgo(22),
    officeName: "Sunshine Wound Care Associates",
    officeAddress: "1200 NW 7th Ave",
    officeCity: "Miami",
    officeState: "FL",
    officeZip: "33136",
    form1500ReviewInfo: {
      status: "cleared",
      reviewedBy: "demo-user-manufacturer",
      reviewedByLabel: "Karen Patel",
      reviewedAt: daysAgo(17),
    },
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(25),
    createdOn: daysAgo(25),
    lastStatusChange: Date.now() - 15 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a sacral pressure ulcer identified during home health assessment. The wound developed during a prolonged period of bed rest following a fall. The patient has limited mobility and requires assistance with repositioning. Moderate serous drainage noted with intact periwound skin showing mild erythema.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(35),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Diabetes", "CHF", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin", "Plavix"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 89-year-old female with diabetes, congestive heart failure, and severely decreased mobility presenting with a sacral pressure ulcer. Collagen dressing is medically necessary to promote granulation tissue formation in a patient with profoundly impaired healing capacity. The combination of diabetes, CHF, advanced age, and immobility creates a severe risk profile for wound progression. Without appropriate wound care, the ulcer is likely to deepen and increase risk of sepsis.",
    icd10Codes: [{ code: "L89.153", description: "Pressure ulcer of sacral region, stage III" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "johnson_facesheet_v2.pdf",
    clinicalDocumentationFile: "johnson_clinical_v2.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "demo-pod-13.pdf",
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "johnson_sacral_pressure.jpg" }],
    productDispensed: ["Collagen - 4x4 - A6021", "Zetuvit 6x10 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: "Zetuvit 6x10 (A6197)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate serous drainage noted. Wound bed shows 60% granulation tissue, 30% slough, and 10% eschar at wound margins. Periwound skin intact with mild erythema. No signs of infection.",
        treatmentPlan:
          "Apply collagen 4x4 dressing to wound bed daily, cover with Zetuvit 6x10 absorbent pad. Maintain strict repositioning schedule every 2 hours. Use pressure redistribution mattress. Ensure adequate protein intake with supplements. Reassess in 14 days.",
        location: {
          site: "Sacrum",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Posterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 4.0,
          width: 3.2,
          depth: 0.5,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Mild Erythema",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(22),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(20),
    shipmentDate: dateOnly(17),
    carrier: "UPS",
    trackingCode: "1Z999AA10123456799",
    deliveryDate: dateOnly(15),
    comments: [
      {
        date: daysAgo(18),
        comment: "Order shipped via UPS. Tracking: 1Z999AA10123456799. Patient's daughter has been notified to expect delivery.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(15),
        comment:
          "Patient's daughter confirmed package was delivered and all supplies are accounted for. Beginning wound care protocol today.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(15),
        comment: "Delivery confirmed. Please upload the signed proof of delivery document when available.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(14),
        comment: "Proof of delivery has been uploaded. All documentation is complete for this order.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(14),
        comment:
          "POD received and verified. Order is now complete. Patient reports positive initial response to collagen dressing treatment.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Delivery confirmed by patient's daughter. Package signed for at front door.",
        creatorLabel: "Karen Patel",
        date: daysAgo(15),
      },
      {
        note: "POD verified - all documentation complete. Medicare billing submitted.",
        creatorLabel: "Karen Patel",
        date: daysAgo(14),
      },
      {
        note: "Reorder due in approximately 30 days based on current supply. Home health nurse will reassess wound at next visit.",
        creatorLabel: "Karen Patel",
        date: daysAgo(14),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(25), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(23), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(22), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(20), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(17), editorLabel: "Karen Patel" },
      { field: "status", value: "delivered", date: daysAgo(15), editorLabel: "Karen Patel" },
      {
        field: "documentReplaced",
        value: "Clinical documentation (previous: johnson_clinical_v1.pdf)",
        date: hoursAgo(3),
        editorLabel: "Dr. Sarah Mitchell",
      },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 3,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(20),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01314",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 14: William Davis — abdominal surgical wound, delivered 20 days ago, has proof of delivery
  {
    id: "demo-order-14",
    orderUuid: "demo-uuid-014",
    status: "delivered",
    patientFirstName: "William",
    patientLastName: "Davis",
    patientDOB: "1943-07-25",
    patientGender: "Male",
    patientAddress: "3700 NW 21st St",
    patientCity: "Lauderdale Lakes",
    patientState: "FL",
    patientZipCode: "33311",
    patientPhone: "(954) 555-0211",
    primaryInsuranceName: "UnitedHealthcare",
    primaryPolicyNumber: "UHC-887432190",
    primaryGroupNumber: "GRP-44521",
    primaryPlanType: "Commercial",
    primaryInsuredState: "FL",
    primaryInsuredZipCode: "33311",
    primaryInsuredPhone: "(954) 555-0211",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Mark Phillips",
    signedUserNPI: "9876543210",
    signedDate: daysAgo(27),
    officeName: "Boca Raton Medical Plaza",
    officeAddress: "950 NW 13th St",
    officeCity: "Boca Raton",
    officeState: "FL",
    officeZip: "33486",
    form1500ReviewInfo: {
      status: "cleared",
      reviewedBy: "demo-user-manufacturer",
      reviewedByLabel: "Karen Patel",
      reviewedAt: daysAgo(22),
    },
    organizationId: "demo-org",
    organizationName: "Boca Raton Medical Plaza",
    dateOfService: dateOnly(30),
    createdOn: daysAgo(30),
    lastStatusChange: Date.now() - 20 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with an abdominal surgical wound dehiscence following hernia repair surgery 2 weeks ago. The incision has partially separated with moderate serosanguinous drainage. The patient's anticoagulant therapy and cardiovascular disease have contributed to delayed wound healing. Patient reports moderate pain at the incision site.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(35),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Cardiovascular Disease", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Xarelto"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 82-year-old male with cardiovascular disease on anticoagulant therapy presenting with abdominal surgical wound dehiscence following hernia repair. Collagen dressing is medically necessary to promote granulation tissue formation and facilitate wound closure. The patient's anticoagulant use increases bleeding risk and may delay hemostasis at the wound site. The combination of age, cardiovascular disease, and surgical wound complexity necessitate advanced wound care to prevent infection and promote healing.",
    icd10Codes: [
      { code: "T81.31XA", description: "Disruption of external operation wound, not elsewhere classified, initial encounter" },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "davis_facesheet_v2.pdf",
    clinicalDocumentationFile: "davis_clinical_v2.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "demo-pod-14.pdf",
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "davis_surgical_wound.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023", "Zetuvit 8x8 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every other day",
        woundType: "Surgical",
        cgsWoundType: "Surgical wound",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Erythematous",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serosanguinous drainage from dehisced incision line. Wound bed shows 80% granulation tissue and 20% slough. Wound edges are partially approximated with resolving erythema. No signs of infection.",
        treatmentPlan:
          "Apply collagen 7x7 dressing to fill wound bed, cover with Zetuvit 8x8 absorbent pad. Change dressing every 24-48 hours. Abdominal binder to support wound during movement. Avoid heavy lifting or straining. Home health nurse to perform dressing changes. Reassess in 14 days.",
        location: {
          site: "Abdomen",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Anterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 7.5,
          width: 2.2,
          depth: 1.0,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Moderate",
          surroundingSkin: "Mild Erythema",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Resolving",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(27),
    signedBy: "Dr. Mark Phillips",
    approvedOn: daysAgo(25),
    shipmentDate: dateOnly(22),
    carrier: "UPS",
    trackingCode: "1Z999AA10123456801",
    deliveryDate: dateOnly(20),
    comments: [
      {
        date: daysAgo(23),
        comment: "UnitedHealthcare coverage verified and approved. Preparing shipment of collagen 7x7 and Zetuvit 8x8 supplies.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(22),
        comment: "Shipped via UPS. Tracking: 1Z999AA10123456801. Expected delivery in 2 business days.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(20),
        comment:
          "Patient confirmed delivery of all wound care supplies. Home health nurse will begin new dressing protocol at next scheduled visit.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(20),
        comment: "Delivery confirmed. Please upload the signed proof of delivery at your earliest convenience.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
      {
        date: daysAgo(19),
        comment:
          "POD uploaded and all documentation is complete. Patient reports the wound is responding well to the collagen dressing treatment after initial application.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
    ],
    notes: [
      {
        note: "UnitedHealthcare verified. Package delivered and signed by patient directly.",
        creatorLabel: "Karen Patel",
        date: daysAgo(20),
      },
      {
        note: "POD verified - all documentation complete. Insurance billing processed.",
        creatorLabel: "Karen Patel",
        date: daysAgo(19),
      },
      {
        note: "Reorder assessment scheduled for 14 days post-delivery. Home health nurse will evaluate wound progress and determine if continued collagen therapy is needed.",
        creatorLabel: "Karen Patel",
        date: daysAgo(19),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(30), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(28), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(27), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "approved", date: daysAgo(25), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(22), editorLabel: "Karen Patel" },
      { field: "status", value: "delivered", date: daysAgo(20), editorLabel: "Karen Patel" },
      { field: "documentUploaded", value: "Proof of delivery", date: hoursAgo(5), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 2,
    manufacturerComments: 3,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(25),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01420",
      coverageDetails: {
        planCategory: "Commercial",
        commercialPlanType: "PPO",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "15000.00",
      },
      financialResponsibility: {
        deductibleIndividual: "1000.00",
        deductibleIndividualMet: "1000.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "7000.00",
        oopMaxIndividualMet: "3500.00",
        oopMaxIndividualRemaining: "3500.00",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // REJECTED (2) — manufacturer requesting more info
  // ==========================================

  // 15: Ernesto Ruiz — 70yo, venous stasis ulcer left medial ankle, rejected for missing clinical docs
  {
    id: "demo-order-15",
    orderUuid: "demo-uuid-015",
    status: "rejected",
    patientFirstName: "Ernesto",
    patientLastName: "Ruiz",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(6),
    createdOn: daysAgo(6),
    lastStatusChange: Date.now() - 2 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with chronic venous stasis ulcer on the left medial ankle present for approximately 6 weeks. The wound has not responded to conservative treatment with compression therapy alone. Patient reports constant aching and heaviness in the left lower extremity that worsens with prolonged standing.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Swelling"],
    medicalConditions: ["Venous Insufficiency", "Obesity"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "false",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 70-year-old male with chronic venous insufficiency and obesity presenting with a non-healing left medial ankle ulcer unresponsive to compression therapy alone. Collagen dressing is medically necessary to promote granulation tissue formation and support wound closure in a patient with impaired venous return. The moderate serous drainage requires an absorbent secondary dressing.",
    icd10Codes: [{ code: "I87.312", description: "Chronic venous hypertension with ulcer of left lower extremity" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "ruiz_facesheet.pdf",
    clinicalDocumentationFile: null,
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "ruiz_ankle.jpg" }],
    productDispensed: ["Collagen - 4x4 - A6021", "Zetuvit 6x10 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Venous stasis ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: "Zetuvit 6x10 (A6197)",
        skinCondition: "Hemosiderin Staining",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serous drainage with yellowish exudate. Wound bed shows 70% granulation tissue and 30% fibrinous slough. Periwound skin demonstrates hemosiderin staining and mild lipodermatosclerosis.",
        treatmentPlan:
          "Apply collagen 4x4 dressing to wound bed, cover with Zetuvit 6x10 absorbent pad. Continue multi-layer compression wrapping. Elevate extremity when seated. Reassess in 14 days.",
        location: {
          site: "Ankle",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Medial",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.8,
          width: 2.9,
          depth: 0.4,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Hemosiderin Staining",
          temperature: "WNL",
          edema: "Moderate",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(4),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(3),
        comment: "Order submitted for approval. Patient has been on compression therapy for 6 weeks with no improvement.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(2),
        comment:
          "Order requires additional information before approval. Please upload clinical documentation including wound measurement history and compression therapy notes. Also need updated facesheet showing current insurance eligibility.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Returned to provider — missing clinical documentation and wound progression history. Cannot verify medical necessity without treatment records.",
        creatorLabel: "Karen Patel",
        date: daysAgo(2),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(6), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(5), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(4), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "rejected", date: hoursAgo(6), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: null,
  },

  // 16: Gladys Palmer — 78yo, right shin arterial ulcer, rejected for wound photo quality
  {
    id: "demo-order-16",
    orderUuid: "demo-uuid-016",
    status: "rejected",
    patientFirstName: "Gladys",
    patientLastName: "Palmer",
    organizationId: "demo-org",
    organizationName: "Fort Lauderdale Clinic",
    dateOfService: dateOnly(8),
    createdOn: daysAgo(8),
    lastStatusChange: Date.now() - 1 * 86400000,
    assignedTo: { key: "doc-003", label: "Phillips, Mark", npi: "9876543210" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with an arterial insufficiency ulcer on the right anterior shin, present for 3 weeks. Patient has a history of peripheral arterial disease and reports sharp pain at the wound site that worsens at night and with leg elevation.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Peripheral Arterial Disease", "Hypertension"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin", "Plavix"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 78-year-old female with peripheral arterial disease and hypertension presenting with a right anterior shin arterial ulcer. Collagen dressing is medically necessary to support granulation tissue formation in a wound with compromised arterial perfusion. The wound demonstrates scant drainage suitable for a light secondary cover.",
    icd10Codes: [{ code: "I70.232", description: "Atherosclerosis of native arteries of right leg with ulceration of calf" }],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "palmer_facesheet.pdf",
    clinicalDocumentationFile: "palmer_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "palmer_shin.jpg" }],
    productDispensed: ["Collagen - 2x2 - A6021", "Cosmopor 3.2x4 (A6219)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Arterial ulcer",
        productOrdered: "Collagen - 2x2 - A6021",
        chargeAmount: 35.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Thin/Fragile",
        woundStaging: "Partial Thickness",
        drainage:
          "Scant serous drainage. Wound bed is pale pink with minimal granulation. Wound edges are well-defined with punched-out appearance typical of arterial etiology.",
        treatmentPlan:
          "Apply collagen 2x2 dressing daily with Cosmopor secondary cover. Do NOT apply compression — arterial etiology. Keep extremity in dependent position when possible. Reassess in 14 days.",
        location: {
          site: "Leg",
          side: "Right",
          proximalDistal: "Distal",
          anteriorPosterior: "Anterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 1.8,
          width: 1.5,
          depth: 0.2,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Thin/Fragile",
          temperature: "Cool",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(6),
    signedBy: "Dr. Mark Phillips",
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(5),
        comment: "Wound photos submitted with order. Patient has documented PAD with ABI of 0.6 on the right.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Mark Phillips",
      },
      {
        date: daysAgo(1),
        comment:
          "Wound photographs are blurry and do not clearly show wound margins or wound bed characteristics. Please resubmit clear, well-lit photographs showing the full wound with a ruler for measurement verification.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Returned to provider — wound photos insufficient for clinical review. Need clear images with measurement ruler visible.",
        creatorLabel: "Karen Patel",
        date: daysAgo(1),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(8), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "submitted", date: daysAgo(7), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(6), editorLabel: "Dr. Mark Phillips" },
      { field: "status", value: "rejected", date: daysAgo(1), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: null,
  },

  // ==========================================
  // SHORELINE INSURANCE (1) — order using Shoreline Insurance (no secondary dressing)
  // ==========================================

  // 17: Lorraine Foster — 84yo, diabetic foot ulcer, Shoreline Insurance
  {
    id: "demo-order-17",
    orderUuid: "demo-uuid-017",
    status: "signed",
    patientFirstName: "Lorraine",
    patientLastName: "Foster",
    organizationId: "demo-org",
    organizationName: "Boca Raton Medical Plaza",
    dateOfService: dateOnly(3),
    createdOn: daysAgo(3),
    lastStatusChange: Date.now() - 1 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with a diabetic neuropathic ulcer on the right great toe, present for 3 weeks. Patient has poorly controlled type 2 diabetes with recent HbA1c of 9.2. Reports no pain at the ulcer site due to severe peripheral neuropathy but noticed drainage on her sock.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Numbness", "Drainage"],
    medicalConditions: ["Diabetes", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "false",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 84-year-old female with poorly controlled type 2 diabetes (HbA1c 9.2) and severe peripheral neuropathy presenting with a right great toe neuropathic ulcer. Collagen dressing is medically necessary to promote granulation tissue and wound closure. The patient's elevated glucose levels and neuropathy significantly impair wound healing capacity, placing her at risk for progression to osteomyelitis without appropriate wound care intervention.",
    icd10Codes: [
      { code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" },
      { code: "E11.42", description: "Type 2 diabetes mellitus with diabetic polyneuropathy" },
    ],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "true",
    faceSheetFile: "foster_facesheet.pdf",
    clinicalDocumentationFile: "foster_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "foster_toe.jpg" }],
    productDispensed: ["Collagen - 1x1 - A6021"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: false,
        lengthOfNeedDays: "7",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Diabetic foot ulcer",
        productOrdered: "Collagen - 1x1 - A6021",
        chargeAmount: 28.0,
        secondaryDressing: null,
        skinCondition: "Callused",
        woundStaging: "Full Thickness",
        drainage:
          "Scant serous drainage. Wound bed shows healthy pink granulation tissue centrally with callused margins. No signs of infection.",
        treatmentPlan:
          "Apply collagen 1x1 dressing daily. Offload right great toe with surgical shoe. Monitor blood glucose closely — target fasting glucose below 180 mg/dL. Reassess in 7 days.",
        location: {
          site: "Foot",
          side: "Right",
          proximalDistal: "Distal",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 1.0,
          width: 0.8,
          depth: 0.2,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "None",
          surroundingSkin: "Callused",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "false",
        },
      },
    ],
    signedOn: daysAgo(2),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(3), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(3), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(2), editorLabel: "Dr. Sarah Mitchell" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 0,
    manufacturerComments: 0,
    auditPacket: {
      status: "denied",
      events: [
        {
          id: "evt-demo-17-denied",
          type: "DENIED",
          actor: { userId: "demo-user-manufacturer", name: "Karen Patel", role: "supervisor", orgId: "demo-org" },
          timestamp: hoursAgo(6),
          payload: { denialReason: "Missing wound measurements on the most recent assessment.", denialCategory: "incomplete" },
        },
      ],
    },
    additionalIvrInfo: null,
  },

  // ==========================================
  // TUNNELING + UNDERMINING COMBO (1) — complex wound with Collagen Powder auto-select
  // ==========================================

  // 18: Clarence Washington — 68yo, right lateral malleolus ulcer with tunneling AND undermining
  {
    id: "demo-order-18",
    orderUuid: "demo-uuid-018",
    status: "submitted",
    patientFirstName: "Clarence",
    patientLastName: "Washington",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(3),
    createdOn: daysAgo(3),
    lastStatusChange: Date.now() - 1 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "3",
    chiefComplaint:
      "Patient returns for follow-up of chronic right lateral malleolus ulcer, initially caused by trauma 4 months ago. The wound has failed to progress despite two months of collagen sheet therapy. New tunneling tract identified at the 9 o'clock position and undermining at 3-6 o'clock. Patient reports deep throbbing pain and difficulty sleeping.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(60),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Insomnia"],
    medicalConditions: ["Diabetes", "Peripheral Arterial Disease", "Venous Insufficiency"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Xarelto"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 68-year-old male with mixed arterial-venous disease and diabetes presenting with a chronic right lateral malleolus ulcer with tunneling at 9 o'clock (2.5cm) and undermining at 3-6 o'clock (1.8cm). Collagen powder is medically necessary to fill the tunneling tract and undermined areas, promoting granulation from the wound base. The heavy drainage requires highly absorbent secondary dressing. The combination of arterial and venous compromise with diabetes creates a severely impaired healing environment requiring aggressive wound management.",
    icd10Codes: [
      {
        code: "L97.912",
        description: "Non-pressure chronic ulcer of unspecified part of right lower leg with fat layer exposed",
      },
      { code: "E11.622", description: "Type 2 diabetes mellitus with other skin ulcer" },
    ],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "washington_facesheet.pdf",
    clinicalDocumentationFile: "washington_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [{ fileName: "washington_vascular_study.pdf", name: "Vascular Study Results" }],
    wounds: [{ fileName: "washington_ankle.jpg" }, { fileName: "washington_ankle_tunneling.jpg" }],
    productDispensed: ["Collagen Powder - A6010", "Zetuvit 8x8 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Venous stasis ulcer",
        productOrdered: "Collagen Powder - A6010",
        chargeAmount: 85.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Hemosiderin Staining",
        woundStaging: "Full Thickness",
        drainage:
          "Heavy serosanguinous drainage, saturating dressings within 12 hours. Wound bed shows 40% granulation, 40% slough, 20% necrotic tissue. Tunneling tract at 9 o'clock probed to 2.5cm. Undermining at 3-6 o'clock extending 1.8cm. Foul odor noted.",
        treatmentPlan:
          "Pack tunneling tract and undermined areas with collagen powder. Cover with Zetuvit 8x8 absorbent pad. Change dressing every 12-24 hours due to heavy drainage. No compression on this visit due to mixed arterial-venous disease — pending vascular clearance. Reassess in 7 days. Consider wound VAC if no improvement.",
        location: {
          site: "Ankle",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Lateral",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 4.5,
          width: 3.2,
          depth: 1.5,
          depthExposure: "Full Thickness",
          tunneling: "true",
          tunnelingDepth: "2.5",
          tunnelingDirection: "9 o'clock",
          undermining: "true",
          underminingDepth: "1.8",
          underminingDirection: "3-6 o'clock",
        },
        characteristics: {
          exudateType: "Serosanguinous",
          exudateAmount: "Heavy",
          surroundingSkin: "Hemosiderin Staining",
          temperature: "Warm",
          edema: "Moderate",
          odor: "Foul",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: null,
    signedBy: null,
    approvedOn: null,
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(2),
        comment:
          "Wound has deteriorated significantly since last visit. Adding vascular study to documentation. Switching from collagen sheet to powder due to new tunneling and undermining.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(3), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(2), editorLabel: "Lisa Nguyen" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: true,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 0,
    additionalIvrInfo: null,
  },

  // ==========================================
  // POST-SURGICAL WITH ADDENDUM (1) — signed order with addendum for contraindication
  // ==========================================

  // 19: Vivian Chang — 72yo, post-surgical chest wound with contraindication addendum
  {
    id: "demo-order-19",
    orderUuid: "demo-uuid-019",
    status: "approved",
    patientFirstName: "Vivian",
    patientLastName: "Chang",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(10),
    createdOn: daysAgo(10),
    lastStatusChange: Date.now() - 4 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    woundType: "Surgical",
    chiefComplaint:
      "Patient presents with post-CABG sternal wound dehiscence. The surgical incision partially separated 8 days post-op with serous drainage. The patient is on immunosuppressive therapy following a kidney transplant 2 years ago, which is a known contraindication for standard wound healing protocols.",
    hasContraindications: "true",
    contraindications: ["Immunosuppressive therapy (Tacrolimus)"],
    isReceivingHomeCare: "true",
    homeHealthStartDate: dateOnly(12),
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Pain", "Drainage"],
    medicalConditions: ["Cardiovascular Disease", "Kidney Disease"],
    medicalConditionsOther: "Kidney transplant recipient on tacrolimus",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Aspirin", "Plavix"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 72-year-old female status post CABG with sternal wound dehiscence, complicated by immunosuppressive therapy (tacrolimus) for prior kidney transplant. Collagen dressing is medically necessary to support granulation tissue formation in a wound with severely compromised immune-mediated healing. Despite the contraindication of immunosuppression, collagen dressing provides a structural scaffold that does not rely on normal immune function for efficacy. The moderate drainage requires absorbent secondary coverage.",
    icd10Codes: [
      { code: "T81.31XA", description: "Disruption of external operation wound, initial encounter" },
      { code: "Z94.0", description: "Kidney transplant status" },
    ],
    followUpDays: "7",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "chang_facesheet.pdf",
    clinicalDocumentationFile: "chang_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [
      { fileName: "chang_transplant_history.pdf", name: "Transplant History" },
      { fileName: "chang_op_note.pdf", name: "CABG Operative Note" },
    ],
    wounds: [{ fileName: "chang_sternum.jpg" }],
    productDispensed: ["Collagen - 7x7 - A6023", "Zetuvit 8x8 (A6197)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Surgical",
        cgsWoundType: "Dehisced surgical wound",
        productOrdered: "Collagen - 7x7 - A6023",
        chargeAmount: 120.0,
        secondaryDressing: "Zetuvit 8x8 (A6197)",
        skinCondition: "Normal",
        woundStaging: "Full Thickness",
        drainage:
          "Moderate serous drainage. Wound bed shows healthy red granulation tissue along the inferior 2/3 of the incision. Superior 1/3 has separated edges with exposed subcutaneous tissue. No purulence. Surrounding skin intact with surgical staple marks.",
        treatmentPlan:
          "Apply collagen 7x7 dressing to fill dehisced area, cover with Zetuvit 8x8 absorbent pad. Reinforce with surgical tape strips to approximate wound edges. Limit upper body movement. Reassess in 7 days. Continue tacrolimus per nephrology — do NOT adjust immunosuppression without transplant team input.",
        location: {
          site: "Chest",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Anterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 12.0,
          width: 1.5,
          depth: 2.0,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Unremarkable",
          temperature: "WNL",
          edema: "Mild",
          odor: "None",
          erythema: "Mild",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(8),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(5),
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(7),
        comment:
          "Patient has a contraindication due to immunosuppressive therapy. Addendum has been completed explaining clinical rationale for collagen use despite this contraindication.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(5),
        comment:
          "Addendum reviewed and accepted. Contraindication acknowledged — collagen scaffold mechanism is independent of immune function. Order approved.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(10), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(9), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(8), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(5), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: {
      status: "signed",
      createdAt: daysAgo(8),
      createdBy: "demo-user-provider",
      createdByLabel: "Dr. Sarah Mitchell",
      signedAt: daysAgo(8),
      signedBy: "Dr. Sarah Mitchell",
      signedByNPI: "1234567890",
      signedByCredentials: "MD",
      notes:
        "Patient is on tacrolimus 2mg BID for kidney transplant maintenance. Collagen dressing provides a structural extracellular matrix scaffold that supports fibroblast migration and granulation independent of immune-mediated pathways. The benefit of promoting wound closure in this post-surgical dehiscence outweighs the theoretical risk of impaired immune response at the wound site. Infectious disease and nephrology teams have been consulted and agree with this approach.",
      entries: [
        {
          type: "contraindication",
          woundIndex: null,
          warningType: "contraindication",
          section: "patientStatus",
          originalWarning: "Patient has contraindications: Immunosuppressive therapy (Tacrolimus)",
          reason: "Immunosuppressive therapy may impair wound healing",
          response:
            "Collagen scaffold mechanism is independent of immune function. Transplant and ID teams consulted and concur with treatment plan.",
        },
      ],
    },
    additionalAddendums: [],
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(7),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-01905",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // ARCHIVED (1) — completed and archived delivered order
  // ==========================================

  // 20: Theodore Jackson — 80yo, archived delivered order, left plantar diabetic ulcer (healed)
  {
    id: "demo-order-20",
    orderUuid: "demo-uuid-020",
    status: "delivered",
    patientFirstName: "Theodore",
    patientLastName: "Jackson",
    patientDOB: "1946-02-14",
    patientGender: "Male",
    patientAddress: "1520 SW 3rd Ave",
    patientCity: "Miami",
    patientState: "FL",
    patientZipCode: "33129",
    patientPhone: "(305) 555-0273",
    primaryInsuranceName: "Medicare",
    primaryPolicyNumber: "2RL5-XT8-BW63",
    primaryGroupNumber: "",
    primaryPlanType: "Medicare",
    primaryInsuredState: "FL",
    primaryInsuredZipCode: "33129",
    primaryInsuredPhone: "(305) 555-0273",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Sarah Mitchell",
    signedUserNPI: "1234567890",
    signedDate: daysAgo(43),
    officeName: "Sunshine Wound Care Associates",
    officeAddress: "1200 NW 7th Ave",
    officeCity: "Miami",
    officeState: "FL",
    officeZip: "33136",
    form1500ReviewInfo: {
      status: "cleared",
      reviewedBy: "demo-user-manufacturer",
      reviewedByLabel: "Karen Patel",
      reviewedAt: daysAgo(36),
    },
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(45),
    createdOn: daysAgo(45),
    lastStatusChange: Date.now() - 30 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "4",
    chiefComplaint:
      "Patient returns for final follow-up of left plantar diabetic ulcer. The wound has been progressively healing over 4 visits with collagen dressing therapy. Current visit shows near-complete epithelialization with no drainage. Patient reports no pain and is ambulating without assistive device.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: [],
    medicalConditions: ["Diabetes"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "false",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is an 80-year-old male with type 2 diabetes completing a course of collagen dressing therapy for a left plantar foot ulcer. The wound has progressed from full thickness to near-complete epithelialization over 4 visits. Final supply order to complete the wound closure process.",
    icd10Codes: [{ code: "E11.621", description: "Type 2 diabetes mellitus with foot ulcer" }],
    followUpDays: "30",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "jackson_facesheet.pdf",
    clinicalDocumentationFile: "jackson_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "jackson_pod.pdf",
    packagingSlipFile: "jackson_packing.pdf",
    additionalDocs: [],
    wounds: [{ fileName: "jackson_foot.jpg" }],
    productDispensed: ["Collagen - 1x1 - A6021", "Cosmopor 3.2x4 (A6219)"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "14",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Diabetic foot ulcer",
        productOrdered: "Collagen - 1x1 - A6021",
        chargeAmount: 28.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Normal",
        woundStaging: "Partial Thickness",
        drainage:
          "No drainage. Wound bed is 95% epithelialized with healthy pink tissue. Remaining 5% is shallow granulation tissue at the wound center. Surrounding skin intact.",
        treatmentPlan:
          "Apply collagen 1x1 dressing to remaining open area daily with Cosmopor secondary cover. Continue diabetic shoe with custom insole for offloading. This is the final supply order — wound is expected to fully close within 7-10 days.",
        location: {
          site: "Foot",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "Plantar",
          inferiorSuperior: "",
        },
        measurements: {
          length: 0.5,
          width: 0.4,
          depth: 0.1,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "None",
          exudateAmount: "None",
          surroundingSkin: "Unremarkable",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "false",
        },
      },
    ],
    signedOn: daysAgo(43),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(40),
    shipmentDate: daysAgo(38),
    carrier: "FedEx",
    trackingCode: "7749 2810 3847",
    deliveryDate: daysAgo(35),
    comments: [
      {
        date: daysAgo(44),
        comment: "Final order for this patient. Wound nearly healed — great progress over 4 visits.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(35),
        comment: "Delivered and signed by patient. Wound care regimen complete.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [
      {
        note: "Final delivery confirmed. Patient wound care course complete. No reorder needed.",
        creatorLabel: "Karen Patel",
        date: daysAgo(34),
      },
    ],
    history: [
      { field: "created", value: null, date: daysAgo(45), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(44), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(43), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(40), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(38), editorLabel: "Karen Patel" },
      { field: "status", value: "delivered", date: daysAgo(35), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: true,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(40),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-02001",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // ==========================================
  // MULTI-WOUND (1) — 3 wounds across different body regions
  // ==========================================

  // 21: Rosa Delgado — 76yo, SNF patient with 3 wounds: sacral, left hip, right elbow
  {
    id: "demo-order-21",
    orderUuid: "demo-uuid-021",
    status: "approved",
    patientFirstName: "Rosa",
    patientLastName: "Delgado",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(7),
    createdOn: daysAgo(7),
    lastStatusChange: Date.now() - 2 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "2",
    chiefComplaint:
      "Patient is a 76-year-old female in a skilled nursing facility following a stroke with left-sided hemiplegia. She has developed multiple pressure ulcers due to immobility. This visit documents three active wounds requiring treatment: sacral stage III pressure ulcer, left greater trochanter stage II pressure ulcer, and right olecranon pressure ulcer.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "true",
    snfAdmissionDate: dateOnly(30),
    subjectiveSymptoms: ["Pain"],
    medicalConditions: ["Decreased Mobility", "Stroke"],
    medicalConditionsOther: "Left-sided hemiplegia from CVA",
    bloodThinnersEnabled: "true",
    bloodThinners: ["Eliquis"],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 76-year-old female with post-stroke left hemiplegia in a skilled nursing facility presenting with three pressure ulcers. Collagen dressings are medically necessary at all three sites to promote granulation and wound closure in a severely immobile patient. The patient's neurological impairment prevents self-repositioning, creating ongoing risk for wound progression. Multiple wound sites require different product sizes matched to wound dimensions.",
    icd10Codes: [
      { code: "L89.153", description: "Pressure ulcer of sacral region, stage III" },
      { code: "L89.222", description: "Pressure ulcer of left hip, stage II" },
      { code: "L89.012", description: "Pressure ulcer of right elbow, stage II" },
    ],
    followUpDays: "14",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    useShorelineInsurance: "false",
    faceSheetFile: "delgado_facesheet.pdf",
    clinicalDocumentationFile: "delgado_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: null,
    packagingSlipFile: null,
    additionalDocs: [],
    wounds: [{ fileName: "delgado_sacral.jpg" }, { fileName: "delgado_hip.jpg" }, { fileName: "delgado_elbow.jpg" }],
    productDispensed: [
      "Collagen - 4x4 - A6021",
      "Zetuvit 6x10 (A6197)",
      "Collagen - 2x2 - A6021",
      "Cosmopor 3.2x4 (A6219)",
      "Collagen - 1x1 - A6021",
      "Cosmopor 3.2x4 (A6219)",
    ],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 4x4 - A6021",
        chargeAmount: 48.0,
        secondaryDressing: "Zetuvit 6x10 (A6197)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 3",
        drainage:
          "Moderate serous drainage. Wound bed 50% granulation, 40% slough, 10% necrotic base. Periwound maceration noted at inferior wound edge.",
        treatmentPlan:
          "Apply collagen 4x4 to sacral wound bed daily, cover with Zetuvit 6x10. Reposition every 2 hours. Use pressure redistribution mattress. Apply barrier cream to periwound skin. Reassess in 14 days.",
        location: {
          site: "Sacrum",
          side: "Midline",
          proximalDistal: "",
          anteriorPosterior: "Posterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 3.5,
          width: 2.8,
          depth: 0.6,
          depthExposure: "Full Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Moderate",
          surroundingSkin: "Macerated",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "true",
        },
      },
      {
        id: 2,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every other day",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 2x2 - A6021",
        chargeAmount: 35.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Erythematous",
        woundStaging: "Stage 2",
        drainage:
          "Scant serous drainage. Wound bed is 80% granulation with intact blister roof partially present. Surrounding skin erythematous.",
        treatmentPlan:
          "Apply collagen 2x2 to left hip wound, cover with Cosmopor 3.2x4. Maintain lateral repositioning schedule. Use foam wedge between knees. Reassess in 14 days.",
        location: {
          site: "Hip",
          side: "Left",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "Lateral",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 2.0,
          width: 1.5,
          depth: 0.2,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Erythematous",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "false",
        },
      },
      {
        id: 3,
        secondaryDressingCoupled: true,
        lengthOfNeedDays: "30",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: "Every 3 days",
        woundType: "Chronic",
        cgsWoundType: "Pressure ulcer",
        productOrdered: "Collagen - 1x1 - A6021",
        chargeAmount: 28.0,
        secondaryDressing: "Cosmopor 3.2x4 (A6219)",
        skinCondition: "Normal",
        woundStaging: "Stage 2",
        drainage: "Scant serous drainage. Small shallow wound with 90% granulation tissue. Wound edges well-approximated.",
        treatmentPlan:
          "Apply collagen 1x1 to right elbow wound, cover with Cosmopor. Use elbow pad for protection. Elevate arm on pillow when in bed. Reassess in 14 days.",
        location: {
          site: "Elbow",
          side: "Right",
          proximalDistal: "",
          anteriorPosterior: "Posterior",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 1.2,
          width: 1.0,
          depth: 0.1,
          depthExposure: "Partial Thickness",
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: "Serous",
          exudateAmount: "Scant",
          surroundingSkin: "Unremarkable",
          temperature: "WNL",
          edema: "Not Present",
          odor: "None",
          erythema: "Not Present",
          cellulitis: "Not Present",
          eschar: "Not Present",
          pain: "false",
        },
      },
    ],
    signedOn: daysAgo(5),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(3),
    shipmentDate: null,
    carrier: null,
    trackingCode: null,
    deliveryDate: null,
    comments: [
      {
        date: daysAgo(6),
        comment:
          "SNF patient with 3 active pressure ulcers secondary to stroke immobility. All three wounds require concurrent treatment.",
        creator: "demo-user-provider",
        creatorLabel: "Dr. Sarah Mitchell",
      },
      {
        date: daysAgo(3),
        comment:
          "All 3 wound assessments reviewed and verified. Products matched to wound sizes. Order approved for shipment to SNF address.",
        creator: "demo-user-manufacturer",
        creatorLabel: "Karen Patel",
        from: "manufacturer",
      },
    ],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(7), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "submitted", date: daysAgo(6), editorLabel: "Lisa Nguyen" },
      { field: "status", value: "signed", date: daysAgo(5), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(3), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    addendum: null,
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 1,
    manufacturerComments: 1,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(5),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-02110",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Wound Care Supplies", "Collagen Products"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "180.00",
        deductibleIndividualRemaining: "60.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "Coastal Medical Supply Co.",
        dmePhone: "(305) 555-0300",
        dmeEmail: "orders@coastalmedicalsupply.com",
        dmeNpi: "1928374650",
        dmePtan: "4G2881",
        dmeNscNumber: "NSC0041825",
        dmeTaxId: "65-4821093",
        dmeAddress: "8300 NW 53rd St, Suite 200, Doral, FL 33166",
      },
    },
  },

  // 22: Edward Kornyo — K0001 standard wheelchair for diabetic peripheral neuropathy.
  // Wired with manufacturerDmeProvider so Box 33 resolves to HEALTHPRO1 (not the org's
  // default Coastal DME). Used to demo a fully-populated CMS-1500 in DME demo mode.
  {
    id: "demo-order-22",
    orderUuid: "demo-uuid-022",
    status: "shipped",
    patientFirstName: "Edward",
    patientLastName: "Kornyo",
    patientDOB: "1952-06-14",
    patientGender: "Male",
    patientAddress: "82 Dual Drive",
    patientCity: "Lake Grove",
    patientState: "NY",
    patientZipCode: "11755",
    patientPhone: "(314) 509-4237",
    primaryInsuranceName: "Medicare Part B",
    primaryPolicyNumber: "L97519",
    primaryGroupNumber: "",
    primaryPlanType: "Medicare",
    primaryInsuredState: "NY",
    primaryInsuredZipCode: "11755",
    primaryInsuredPhone: "(314) 509-4237",
    primaryRelationshipToPatient: "Self",
    signedUserLabel: "Dr. Sarah Mitchell",
    signedUserNPI: "1234567890",
    signedDate: daysAgo(6),
    officeName: "Sunshine Wound Care Associates",
    officeAddress: "1200 NW 7th Ave",
    officeCity: "Miami",
    officeState: "FL",
    officeZip: "33136",
    organizationId: "demo-org",
    organizationName: "Miami Wound Care Center",
    dateOfService: dateOnly(6),
    createdOn: daysAgo(8),
    lastStatusChange: Date.now() - 2 * 86400000,
    assignedTo: { key: "doc-001", label: "Mitchell, Sarah", npi: "1234567890" },
    woundVisitNumber: "1",
    chiefComplaint:
      "Patient presents with progressive loss of ambulation secondary to advanced diabetic peripheral neuropathy. Unable to safely walk household distances without assistance. Requires standard manual wheelchair for activities of daily living.",
    hasContraindications: "false",
    contraindications: [],
    isReceivingHomeCare: "false",
    homeHealthStartDate: null,
    isAtSNF: "false",
    snfAdmissionDate: null,
    subjectiveSymptoms: ["Numbness", "Pain"],
    medicalConditions: ["Diabetes", "Decreased Mobility"],
    medicalConditionsOther: "",
    bloodThinnersEnabled: "false",
    bloodThinners: [],
    bloodThinnersOther: "",
    medicalNecessity:
      "Patient is a 73-year-old male with longstanding Type 2 diabetes complicated by advanced peripheral neuropathy (G63). Marked sensory and motor deficits in both lower extremities have rendered ambulation unsafe. Standard manual wheelchair (K0001) is medically necessary for mobility within the home and for transfers to medical appointments. Patient has sufficient upper-body strength to self-propel.",
    icd10Codes: [
      { code: "G63", description: "Polyneuropathy in diseases classified elsewhere" },
      { code: "E11.62", description: "Type 2 diabetes mellitus with other skin complications" },
    ],
    followUpDays: "90",
    followUpDaysOther: null,
    dmeProvider: { key: { companyName: "Coastal Medical Supply Co." }, label: "Coastal Medical Supply Co." },
    manufacturerDmeProvider: {
      key: {
        id: "dme-healthpro1",
        companyName: "HEALTHPRO1",
        address: "120 Industrial Pkwy",
        city: "Hauppauge",
        state: "NY",
        zip: "11788",
        phone: "(631) 555-0142",
        email: "claims@healthpro1.com",
        npi: "1457821396",
        ptan: "FU76742Q",
        nscNumber: "NSC0098214",
        taxId: "47-3892106",
      },
      label: "HEALTHPRO1",
    },
    useShorelineInsurance: "false",
    faceSheetFile: "kornyo_facesheet.pdf",
    clinicalDocumentationFile: "kornyo_clinical.pdf",
    facesheetUploading: false,
    clinicalDocumentationUploading: false,
    proofOfDeliveryFile: "kornyo_pod.pdf",
    packagingSlipFile: null,
    additionalDocs: [],
    // K-code wheelchair has no wound photos; the file here is the equipment-receipt
    // photo that satisfies the supporting-documentation requirement for delivery.
    wounds: [{ fileName: "kornyo_wheelchair_delivery.jpg" }],
    productDispensed: ["Standard Wheelchair - K0001"],
    woundAssessment: [
      {
        id: 1,
        secondaryDressingCoupled: false,
        lengthOfNeedDays: "365",
        lengthOfNeedDaysOther: null,
        dressingChangeFrequency: null,
        woundType: null,
        cgsWoundType: null,
        productOrdered: "Standard Wheelchair - K0001",
        chargeAmount: 450.0,
        secondaryDressing: null,
        skinCondition: null,
        woundStaging: null,
        drainage: null,
        treatmentPlan:
          "Dispense standard manual wheelchair (K0001) with standard seat and back upholstery, swing-away footrests, and standard armrests. Patient and caregiver to be educated on safe transfers, propulsion technique, and pressure-relief schedule. Follow up in 90 days to assess fit and need for adjustments.",
        location: {
          site: "Lower Extremity",
          side: "Bilateral",
          proximalDistal: "",
          anteriorPosterior: "",
          medialLateral: "",
          dorsalPlantar: "",
          inferiorSuperior: "",
        },
        measurements: {
          length: 0,
          width: 0,
          depth: 0,
          depthExposure: null,
          tunneling: "false",
          undermining: "false",
        },
        characteristics: {
          exudateType: null,
          exudateAmount: null,
          surroundingSkin: null,
          temperature: null,
          edema: null,
          odor: null,
          erythema: null,
          cellulitis: null,
          eschar: null,
          pain: "true",
        },
      },
    ],
    signedOn: daysAgo(6),
    signedBy: "Dr. Sarah Mitchell",
    approvedOn: daysAgo(4),
    shipmentDate: daysAgo(2),
    carrier: "UPS",
    trackingCode: "1Z999AA10123456784",
    deliveryDate: daysAgo(1),
    comments: [],
    notes: [],
    history: [
      { field: "created", value: null, date: daysAgo(8), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "signed", date: daysAgo(6), editorLabel: "Dr. Sarah Mitchell" },
      { field: "status", value: "approved", date: daysAgo(4), editorLabel: "Karen Patel" },
      { field: "status", value: "shipped", date: daysAgo(2), editorLabel: "Karen Patel" },
    ],
    reminders: [],
    additionalAddendums: [],
    isArchived: false,
    isUrgent: false,
    isSuspended: false,
    providerComments: 0,
    manufacturerComments: 0,
    additionalIvrInfo: {
      ivrStatus: "completed",
      verificationDate: dateOnly(5),
      verificationRepName: "Patel, Karen",
      verificationRefNumber: "IVR-2026-02220",
      coverageDetails: {
        planCategory: "Government",
        governmentPlanType: "Medicare Part B",
        effectiveDateStart: "01/01/2026",
        effectiveDateEnd: "12/31/2026",
        coveredServices: ["Durable Medical Equipment", "Manual Wheelchair"],
        benefitMaximum: "",
      },
      financialResponsibility: {
        deductibleIndividual: "240.00",
        deductibleIndividualMet: "240.00",
        deductibleIndividualRemaining: "0.00",
        oopMaxIndividual: "",
        oopMaxIndividualMet: "",
        oopMaxIndividualRemaining: "",
        coinsurancePercentage: "20",
      },
      authorizationReferral: {
        referralRequired: false,
        preAuthRequired: false,
      },
      providerFacility: {
        dmeName: "HEALTHPRO1",
        dmePhone: "(631) 555-0142",
        dmeEmail: "claims@healthpro1.com",
        dmeNpi: "1457821396",
        dmePtan: "FU76742Q",
        dmeNscNumber: "NSC0098214",
        dmeTaxId: "47-3892106",
        dmeAddress: "120 Industrial Pkwy, Hauppauge, NY 11788",
      },
    },
  },
];

// Backfill 1500-form fields on skeleton demo orders so every demo order — across
// every status lane — renders a fully populated CMS-1500. The guard pattern
// (`if (order.field == null)`) means richly-populated orders keep their own
// patient/insurance/facility data; only the gaps in skeletons get the demo defaults.
// Reason this is a one-shot pass rather than a runtime helper: the orders are passed
// by reference into demoState.orders and then JSON-cloned at multiple call sites, so
// mutating once at module load gives every downstream consumer the same shape.
const DEMO_OFFICE = {
  officeName: "Sunshine Wound Care Associates",
  officeAddress: "1200 NW 7th Ave",
  officeCity: "Miami",
  officeState: "FL",
  officeZip: "33136",
};
const DEMO_PROVIDER_FOR_DOC = {
  "doc-001": { signedUserLabel: "Dr. Sarah Mitchell", signedUserNPI: "1234567890" },
  "doc-003": { signedUserLabel: "Dr. Mark Phillips", signedUserNPI: "9876543210" },
};
// Synthetic MBI generator — Medicare Beneficiary IDs are 11 chars alphanumeric with
// digit positions at 1/4/5/8/9/11 and letter positions elsewhere (CMS rule). Demo IDs
// follow the same shape so they look like real MBIs in screenshots.
const MBI_LETTERS = "ABCDEFGHJKMNPQRTUVWXY"; // CMS-approved letters (excludes S/L/O/I/B/Z)
const synthMbi = (idx) => {
  const L = (n) => MBI_LETTERS[(idx * 7 + n) % MBI_LETTERS.length];
  const D = (n) => String((idx * 13 + n) % 10);
  return `${D(0)}${L(1)}${L(2)}${D(3)}${D(4)}${L(5)}${L(6)}${D(7)}${D(8)}${L(9)}${D(10)}`;
};
// Draft / unassigned orders must NOT carry a signedDate — the form's Box 31 (and the
// CGS SWO_SIGNATURE check) treat signedDate as "provider attested." Skipping the
// backfill for status === "draft" and orders without an assignedTo preserves the
// "unsigned" intent of these fixtures.
const isUnsignableDraft = (order) => order.status === "draft" || order.status === "pending" || order.assignedTo == null;
demoOrders.forEach((order, idx) => {
  // Patient demographics — fall back to neutral but consistent values per order index.
  if (order.patientDOB == null) order.patientDOB = "1950-01-15";
  if (order.patientGender == null) order.patientGender = idx % 2 === 0 ? "Female" : "Male";
  if (order.patientAddress == null) order.patientAddress = `${100 + idx} Demo Street`;
  if (order.patientCity == null) order.patientCity = "Miami";
  if (order.patientState == null) order.patientState = "FL";
  if (order.patientZipCode == null) order.patientZipCode = "33145";
  if (order.patientPhone == null) order.patientPhone = `(305) 555-${String(100 + idx).padStart(4, "0")}`;

  // Insurance — Medicare default; policy number matches the CMS MBI shape so demo
  // forms look like real claims rather than obviously synthetic data.
  if (order.primaryInsuranceName == null) order.primaryInsuranceName = "Medicare Part B";
  if (order.primaryPolicyNumber == null) order.primaryPolicyNumber = synthMbi(idx);
  // primaryGroupNumber intentionally left unset on Medicare — Medicare has no group
  // number. Setting an empty string would write "" into the PDF field and could
  // overwrite a template-baked placeholder; leaving the field absent lets setValue
  // skip it cleanly.
  if (order.primaryPlanType == null) order.primaryPlanType = "Medicare";
  if (order.primaryInsuredState == null) order.primaryInsuredState = order.patientState;
  if (order.primaryInsuredZipCode == null) order.primaryInsuredZipCode = order.patientZipCode;
  if (order.primaryInsuredPhone == null) order.primaryInsuredPhone = order.patientPhone;
  if (order.primaryRelationshipToPatient == null) order.primaryRelationshipToPatient = "Self";

  // Box 12 patient signature gate — see mapOrder for the compliance reasoning. Anchor
  // to createdOn so consent never lands AFTER signedDate (CMS requires consent ≤ DOS).
  if (order.patientConsentDate == null) order.patientConsentDate = order.createdOn || daysAgo(30);

  // Provider attribution — pulled from assignedTo's doc key. If the key isn't in
  // the demo map, fall back to whatever signedUserNPI the order already carries
  // (preserves billing fidelity) rather than silently overwriting with doc-001's NPI.
  const docDefaults = DEMO_PROVIDER_FOR_DOC[order.assignedTo?.key];
  if (docDefaults) {
    if (order.signedUserLabel == null) order.signedUserLabel = docDefaults.signedUserLabel;
    if (order.signedUserNPI == null) order.signedUserNPI = docDefaults.signedUserNPI;
  }
  // signedDate ONLY for orders that should appear signed. Drafts and pending orders
  // must keep signedDate undefined so Box 31 stays blank and the CGS SWO_SIGNATURE
  // check correctly flags them as unsigned.
  if (order.signedDate == null && !isUnsignableDraft(order)) {
    order.signedDate = order.signedOn || order.createdOn || daysAgo(7);
  }

  // Facility (Box 32) — per-field guards so an order with a partial office (e.g.
  // its own officeName but null officeCity) keeps the bespoke name and only fills
  // the gaps. Object.assign was overwriting all five fields on a one-field gate.
  if (order.officeName == null) order.officeName = DEMO_OFFICE.officeName;
  if (order.officeAddress == null) order.officeAddress = DEMO_OFFICE.officeAddress;
  if (order.officeCity == null) order.officeCity = DEMO_OFFICE.officeCity;
  if (order.officeState == null) order.officeState = DEMO_OFFICE.officeState;
  if (order.officeZip == null) order.officeZip = DEMO_OFFICE.officeZip;

  // DME billing entity (Box 33) backfill removed — every demo order in the array
  // above carries an explicit dmeProvider (Coastal) or manufacturerDmeProvider
  // (Edward → HEALTHPRO1), so the prior `if (order.dmeProvider == null && ...)`
  // guard never fired. Future orders without an explicit dmeProvider should
  // declare one in the array literal rather than rely on backfill, for clarity.
});

// -- Sales Dashboard Stats (Order - Manufacturer - Stats response) --
// This is the format useOrdersStats expects: { output: { stats: [...orgs] } }
// Each org has organizationId, organizationName, providersCount, onboardedDate, invitedByLabel, and orders[]
// Each order needs: id, status, dateOfService, patientName, assignedTo, products[], isArchived, lastStatusChange, createdOn

const salesOrder = (id, status, patientName, products, daysAgoVal, assignedLabel, extra = {}) => ({
  id: `sales-order-${id}`,
  organizationId: "demo-org",
  status,
  dateOfService: daysAgo(daysAgoVal),
  patientName,
  assignedTo: { key: "doc-001", label: assignedLabel },
  products: products.map((p) => ({ productOrdered: p[0], lengthOfNeedDays: p[1] })),
  isArchived: false,
  lastStatusChange: Date.now() - daysAgoVal * 86400000,
  createdOn: daysAgo(daysAgoVal + 2),
  providerId: "prov-001",
  npi: "1234567890",
  ...extra,
});

export const demoManufacturerStats = [
  {
    organizationId: "org-sunshine",
    organizationName: "Sunshine Medical Group",
    providersCount: 3,
    onboardedDate: daysAgo(120),
    invitedByLabel: "Michael Torres",
    orgInfo: {
      officeName: "Sunshine Medical Group",
      officeAddress: "1200 NW 7th Ave",
      officeCity: "Miami",
      officeState: "FL",
      officeZip: "33136",
      officePhone: "(305) 555-0100",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        npi: "1928374650",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-1234567",
        isDefault: true,
      },
    ],
    orders: [
      salesOrder(
        1,
        "delivered",
        "Thompson, Margaret",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        25,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(23), followUpDays: "7" }
      ),
      salesOrder(2, "delivered", "Chen, Robert", [["Collagen - 7x7 - A6023", 14]], 22, "Mitchell, Sarah", {
        deliveryDate: daysAgo(20),
        followUpDays: "14",
      }),
      salesOrder(
        3,
        "delivered",
        "Williams, Dorothy",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        20,
        "Phillips, Mark",
        { deliveryDate: daysAgo(18), followUpDays: "7" }
      ),
      salesOrder(
        4,
        "shipped",
        "Martinez, James",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Collagen Powder - A6010", 7],
        ],
        12,
        "Mitchell, Sarah"
      ),
      salesOrder(
        5,
        "shipped",
        "Johnson, Helen",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        10,
        "Phillips, Mark"
      ),
      salesOrder(6, "approved", "Davis, William", [["Collagen - 2x2 - A6021", 7]], 8, "Mitchell, Sarah"),
      salesOrder(
        7,
        "signed",
        "Garcia, Patricia",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 6x10 (A6197)", 14],
        ],
        5,
        "Mitchell, Sarah"
      ),
      salesOrder(
        8,
        "submitted",
        "Brown, Richard",
        [
          ["Collagen Powder - A6010", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        3,
        "Phillips, Mark"
      ),
      salesOrder(9, "draft", "Thompson, Margaret", [["Collagen - 4x4 - A6021", 7]], 1, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-palm",
    organizationName: "Palm Beach Wound Center",
    providersCount: 2,
    onboardedDate: daysAgo(90),
    invitedByLabel: "Michael Torres",
    orgInfo: {
      officeName: "Palm Beach Wound Center",
      officeAddress: "4500 N Congress Ave",
      officeCity: "West Palm Beach",
      officeState: "FL",
      officeZip: "33407",
      officePhone: "(561) 555-0150",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-2345678",
      },
    ],
    orders: [
      salesOrder(
        10,
        "delivered",
        "Anderson, Carol",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        30,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(28), followUpDays: "14" }
      ),
      salesOrder(
        11,
        "delivered",
        "Wilson, Frank",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 4x4 (A6219)", 7],
        ],
        28,
        "Phillips, Mark",
        { deliveryDate: daysAgo(26), followUpDays: "7" }
      ),
      salesOrder(12, "delivered", "Taylor, Maria", [["Collagen Powder - A6010", 7]], 26, "Mitchell, Sarah", {
        deliveryDate: daysAgo(3),
        followUpDays: "21",
      }),
      salesOrder(
        13,
        "shipped",
        "Moore, Gerald",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        14,
        "Phillips, Mark"
      ),
      salesOrder(14, "approved", "Clark, Susan", [["Collagen - 7x7 - A6023", 14]], 9, "Mitchell, Sarah"),
      salesOrder(
        15,
        "signed",
        "Lewis, Thomas",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        6,
        "Phillips, Mark"
      ),
      salesOrder(16, "submitted", "Walker, Betty", [["Collagen - 4x4 - A6021", 7]], 4, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-coastal",
    organizationName: "Coastal Dermatology",
    providersCount: 2,
    onboardedDate: daysAgo(75),
    invitedByLabel: "Jessica Park",
    orgInfo: {
      officeName: "Coastal Dermatology",
      officeAddress: "2100 SE 17th St",
      officeCity: "Fort Lauderdale",
      officeState: "FL",
      officeZip: "33316",
      officePhone: "(954) 555-0175",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-3456789",
      },
    ],
    orders: [
      salesOrder(
        17,
        "delivered",
        "Hall, Raymond",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        35,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(33), followUpDays: "7" }
      ),
      salesOrder(
        18,
        "delivered",
        "Allen, Nancy",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        32,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(30), followUpDays: "14" }
      ),
      salesOrder(19, "delivered", "Young, Charles", [["Collagen - 2x2 - A6021", 7]], 29, "Phillips, Mark", {
        deliveryDate: daysAgo(27),
        followUpDays: "7",
      }),
      salesOrder(
        20,
        "shipped",
        "King, Linda",
        [
          ["Collagen Powder - A6010", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        13,
        "Mitchell, Sarah"
      ),
      salesOrder(
        21,
        "approved",
        "Wright, Donald",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        7,
        "Phillips, Mark"
      ),
      salesOrder(22, "submitted", "Lopez, Sandra", [["Collagen - 7x7 - A6023", 14]], 3, "Mitchell, Sarah"),
      salesOrder(23, "draft", "Hill, Joseph", [["Collagen - 2x2 - A6021", 7]], 1, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-miami-vascular",
    organizationName: "Miami Vascular Institute",
    providersCount: 1,
    onboardedDate: daysAgo(60),
    invitedByLabel: "Jessica Park",
    orgInfo: {
      officeName: "Miami Vascular Institute",
      officeAddress: "8950 N Kendall Dr",
      officeCity: "Miami",
      officeState: "FL",
      officeZip: "33176",
      officePhone: "(305) 555-0225",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-4567890",
      },
    ],
    orders: [
      salesOrder(
        24,
        "delivered",
        "Scott, Barbara",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 6x10 (A6197)", 14],
        ],
        40,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(38), followUpDays: "14" }
      ),
      salesOrder(25, "delivered", "Green, Edward", [["Collagen - 4x4 - A6021", 7]], 38, "Mitchell, Sarah", {
        deliveryDate: daysAgo(36),
        followUpDays: "7",
      }),
      salesOrder(
        26,
        "shipped",
        "Adams, Ruth",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        15,
        "Mitchell, Sarah"
      ),
      salesOrder(27, "signed", "Baker, Larry", [["Collagen Powder - A6010", 7]], 6, "Mitchell, Sarah"),
      salesOrder(
        28,
        "submitted",
        "Nelson, Sharon",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        2,
        "Mitchell, Sarah"
      ),
    ],
  },
  {
    organizationId: "org-bay-podiatry",
    organizationName: "Bay Area Podiatry",
    providersCount: 3,
    onboardedDate: daysAgo(100),
    invitedByLabel: "David Kim",
    orgInfo: {
      officeName: "Bay Area Podiatry",
      officeAddress: "7301 W Palmetto Park Rd",
      officeCity: "Boca Raton",
      officeState: "FL",
      officeZip: "33433",
      officePhone: "(561) 555-0130",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-5678901",
      },
    ],
    orders: [
      salesOrder(
        29,
        "delivered",
        "Carter, Virginia",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        45,
        "Phillips, Mark",
        { deliveryDate: daysAgo(43), followUpDays: "7" }
      ),
      salesOrder(
        30,
        "delivered",
        "Roberts, Kenneth",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        42,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(40), followUpDays: "14" }
      ),
      salesOrder(31, "delivered", "Evans, Donna", [["Collagen - 7x7 - A6023", 14]], 39, "Phillips, Mark", {
        deliveryDate: daysAgo(37),
        followUpDays: "14",
      }),
      salesOrder(
        32,
        "delivered",
        "Turner, Steven",
        [
          ["Collagen Powder - A6010", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        36,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(34), followUpDays: "7" }
      ),
      salesOrder(33, "shipped", "Phillips, Janet", [["Collagen - 4x4 - A6021", 7]], 11, "Phillips, Mark"),
      salesOrder(
        34,
        "approved",
        "Campbell, George",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 4x4 (A6219)", 7],
        ],
        8,
        "Mitchell, Sarah"
      ),
      salesOrder(
        35,
        "signed",
        "Parker, Debra",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        4,
        "Phillips, Mark"
      ),
      salesOrder(36, "submitted", "Collins, Paul", [["Collagen - 4x4 - A6021", 7]], 2, "Mitchell, Sarah"),
      salesOrder(37, "draft", "Stewart, Lisa", [["Collagen - 2x2 - A6021", 7]], 0, "Phillips, Mark"),
    ],
  },
  {
    organizationId: "org-atlantic",
    organizationName: "Atlantic Senior Care",
    providersCount: 1,
    onboardedDate: daysAgo(45),
    invitedByLabel: "Amanda Lopez",
    orgInfo: {
      officeName: "Atlantic Senior Care",
      officeAddress: "3100 N Federal Hwy",
      officeCity: "Pompano Beach",
      officeState: "FL",
      officeZip: "33064",
      officePhone: "(954) 555-0190",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-6789012",
      },
    ],
    orders: [
      salesOrder(
        38,
        "delivered",
        "Morris, Carol",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        33,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(31), followUpDays: "7" }
      ),
      salesOrder(39, "delivered", "Rogers, Daniel", [["Collagen - 7x7 - A6023", 14]], 30, "Mitchell, Sarah", {
        deliveryDate: daysAgo(28),
        followUpDays: "14",
      }),
      salesOrder(
        40,
        "approved",
        "Reed, Angela",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        10,
        "Mitchell, Sarah"
      ),
      salesOrder(41, "submitted", "Cook, Christopher", [["Collagen Powder - A6010", 7]], 3, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-orlando",
    organizationName: "Orlando Wound Specialists",
    providersCount: 2,
    onboardedDate: daysAgo(55),
    invitedByLabel: "Chris Morgan",
    orgInfo: {
      officeName: "Orlando Wound Specialists",
      officeAddress: "6001 Vineland Rd",
      officeCity: "Orlando",
      officeState: "FL",
      officeZip: "32819",
      officePhone: "(407) 555-0160",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-7890123",
      },
    ],
    orders: [
      salesOrder(
        42,
        "delivered",
        "Morgan, Diane",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        38,
        "Phillips, Mark",
        { deliveryDate: daysAgo(36), followUpDays: "14" }
      ),
      salesOrder(43, "delivered", "Bell, Matthew", [["Collagen - 4x4 - A6021", 7]], 35, "Phillips, Mark", {
        deliveryDate: daysAgo(33),
        followUpDays: "7",
      }),
      salesOrder(
        44,
        "shipped",
        "Murphy, Kathy",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 4x4 (A6219)", 7],
        ],
        16,
        "Mitchell, Sarah"
      ),
      salesOrder(
        45,
        "signed",
        "Bailey, Andrew",
        [
          ["Collagen Powder - A6010", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        5,
        "Phillips, Mark"
      ),
      salesOrder(46, "draft", "Rivera, Stephanie", [["Collagen - 4x4 - A6021", 7]], 1, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-everglades",
    organizationName: "Everglades Family Medicine",
    providersCount: 1,
    onboardedDate: daysAgo(15),
    invitedByLabel: "Natalie Cruz",
    orgInfo: {
      officeName: "Everglades Family Medicine",
      officeAddress: "1850 SW 8th St",
      officeCity: "Miami",
      officeState: "FL",
      officeZip: "33135",
      officePhone: "(305) 555-0245",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-8901234",
      },
    ],
    orders: [
      salesOrder(47, "submitted", "Cooper, Kevin", [["Collagen - 2x2 - A6021", 7]], 4, "Mitchell, Sarah"),
      salesOrder(48, "draft", "Richardson, Michelle", [["Collagen - 4x4 - A6021", 7]], 2, "Mitchell, Sarah"),
    ],
  },
  {
    organizationId: "org-gulf",
    organizationName: "Gulf Coast Nursing",
    providersCount: 1,
    onboardedDate: daysAgo(10),
    invitedByLabel: "Derek Washington",
    orgInfo: {
      officeName: "Gulf Coast Nursing",
      officeAddress: "4200 Henderson Blvd",
      officeCity: "Tampa",
      officeState: "FL",
      officeZip: "33629",
      officePhone: "(813) 555-0140",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-9012345",
      },
    ],
    orders: [salesOrder(49, "draft", "Howard, Jessica", [["Collagen - 7x7 - A6023", 14]], 1, "Mitchell, Sarah")],
  },
  {
    organizationId: "org-keys",
    organizationName: "Keys Medical Center",
    providersCount: 1,
    onboardedDate: daysAgo(30),
    invitedByLabel: "Ryan Foster",
    orgInfo: {
      officeName: "Keys Medical Center",
      officeAddress: "3000 Flagler Ave",
      officeCity: "Key West",
      officeState: "FL",
      officeZip: "33040",
      officePhone: "(305) 555-0280",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-0123456",
      },
    ],
    orders: [
      salesOrder(
        50,
        "delivered",
        "Perez, Maria",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        28,
        "Mitchell, Sarah",
        { deliveryDate: daysAgo(26), followUpDays: "7" }
      ),
      salesOrder(51, "shipped", "Diaz, Carlos", [["Collagen - 2x2 - A6021", 7]], 14, "Mitchell, Sarah"),
      salesOrder(
        52,
        "submitted",
        "Reyes, Ana",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        5,
        "Mitchell, Sarah"
      ),
    ],
  },
  // -- Level 3 sub-sub-rep accounts --
  {
    organizationId: "org-treasure",
    organizationName: "Treasure Coast Wound Clinic",
    providersCount: 1,
    onboardedDate: daysAgo(80),
    invitedByLabel: "Elena Santos",
    orgInfo: {
      officeName: "Treasure Coast Wound Clinic",
      officeAddress: "772 SE Federal Hwy",
      officeCity: "Stuart",
      officeState: "FL",
      officeZip: "34994",
      officePhone: "(772) 555-0130",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-1112233",
      },
    ],
    orders: [
      salesOrder(
        53,
        "delivered",
        "Vargas, Roberto",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        45,
        "Mitchell, Sarah"
      ),
      salesOrder(54, "delivered", "Blake, Catherine", [["Collagen - 2x2 - A6021", 7]], 35, "Mitchell, Sarah"),
      salesOrder(55, "shipped", "Porter, Dennis", [["Collagen - 7x7 - A6023", 14]], 12, "Mitchell, Sarah"),
      salesOrder(
        56,
        "submitted",
        "Webb, Gloria",
        [
          ["Collagen Powder - A6010", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        4,
        "Mitchell, Sarah"
      ),
    ],
  },
  {
    organizationId: "org-naples",
    organizationName: "Naples Senior Wound Care",
    providersCount: 1,
    onboardedDate: daysAgo(65),
    invitedByLabel: "Chidi Okafor",
    orgInfo: {
      officeName: "Naples Senior Wound Care",
      officeAddress: "1455 Pine Ridge Rd",
      officeCity: "Naples",
      officeState: "FL",
      officeZip: "34109",
      officePhone: "(239) 555-0170",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-2223344",
      },
    ],
    orders: [
      salesOrder(
        57,
        "delivered",
        "Fernandez, Luis",
        [
          ["Collagen - 7x7 - A6023", 14],
          ["Zetuvit 8x8 (A6197)", 14],
        ],
        40,
        "Phillips, Mark"
      ),
      salesOrder(58, "approved", "Hudson, Patricia", [["Collagen - 4x4 - A6021", 7]], 9, "Phillips, Mark"),
      salesOrder(
        59,
        "signed",
        "Wagner, Timothy",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        5,
        "Phillips, Mark"
      ),
    ],
  },
  {
    organizationId: "org-lakeland",
    organizationName: "Lakeland Podiatry & Wound Center",
    providersCount: 2,
    onboardedDate: daysAgo(45),
    invitedByLabel: "Tiffany Nguyen",
    orgInfo: {
      officeName: "Lakeland Podiatry & Wound Center",
      officeAddress: "3220 S Florida Ave",
      officeCity: "Lakeland",
      officeState: "FL",
      officeZip: "33803",
      officePhone: "(863) 555-0190",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-3334455",
      },
    ],
    orders: [
      salesOrder(
        60,
        "delivered",
        "Simmons, Brenda",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 6x10 (A6197)", 7],
        ],
        32,
        "Mitchell, Sarah"
      ),
      salesOrder(61, "shipped", "Bryant, Harold", [["Collagen Powder - A6010", 7]], 15, "Phillips, Mark"),
      salesOrder(
        62,
        "submitted",
        "Griffin, Rachel",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 4x4 (A6219)", 7],
        ],
        3,
        "Mitchell, Sarah"
      ),
      salesOrder(63, "draft", "Dixon, Jeffrey", [["Collagen - 7x7 - A6023", 14]], 1, "Phillips, Mark"),
    ],
  },
  {
    organizationId: "org-ocala",
    organizationName: "Ocala Regional Wound Center",
    providersCount: 1,
    onboardedDate: daysAgo(35),
    invitedByLabel: "Marcus Hayes",
    orgInfo: {
      officeName: "Ocala Regional Wound Center",
      officeAddress: "1500 SW 1st Ave",
      officeCity: "Ocala",
      officeState: "FL",
      officeZip: "34471",
      officePhone: "(352) 555-0210",
    },
    dmeList: [
      {
        id: "dme-1",
        companyName: "National DME Solutions",
        address: "500 S Andrews Ave",
        city: "Fort Lauderdale",
        state: "FL",
        zip: "33301",
        phone: "(954) 555-0200",
        email: "orders@nationaldme.com",
        ptan: "DME1234567",
        nscNumber: "NSC9876543",
        taxId: "59-4445566",
      },
    ],
    orders: [
      salesOrder(
        64,
        "delivered",
        "Murray, Angela",
        [
          ["Collagen - 2x2 - A6021", 7],
          ["Cosmopor 3.2x4 (A6219)", 7],
        ],
        25,
        "Mitchell, Sarah"
      ),
      salesOrder(
        65,
        "approved",
        "Ford, Kenneth",
        [
          ["Collagen - 4x4 - A6021", 7],
          ["Zetuvit 4x4 (A6196)", 7],
        ],
        8,
        "Mitchell, Sarah"
      ),
      salesOrder(66, "draft", "Warren, Diane", [["Collagen - 7x7 - A6023", 14]], 2, "Mitchell, Sarah"),
    ],
  },
];

// Post-process: set organizationId on orders + mark account ownership for filters
// Torres (demo sales user) directly owns: org-sunshine, org-palm
// All other accounts are sub-rep accounts
const torresDirectOrgs = ["org-sunshine", "org-palm"];
// Tag every-other org as peptide-enabled (dual-line DME + Peptide) so the
// Sales Dashboard → Accounts → Peptide product-line view shows accounts in
// BOTH "My Accounts" and "Rep Accounts" slices. Without this, Peptide view
// returns zero because no demo org has peptideOrders. The interceptor's
// isMyOrg rewrite (cloneStatsForManufacturerView) splits 14 orgs into 7
// "mine" / 7 "rep"; spreading peptide enablement across even indices puts
// ~4 peptide orgs in "mine" and ~3 in "rep".
const _peptideStatusByMod = ["delivered", "delivered", "submitted", "delivered", "ordered"];
demoManufacturerStats.forEach((org, idx) => {
  // Set organizationId on each order (useSalesRepsData cross-references by this)
  org.orders.forEach((order) => {
    order.organizationId = org.organizationId;
  });
  // Set ownership flags for AccountsView "My Accounts" / "Rep Accounts" filters
  org.isMyOrg = torresDirectOrgs.includes(org.organizationId);
  org.isMyRepOrg = !torresDirectOrgs.includes(org.organizationId);

  const isPeptideOrg = idx % 2 === 0; // 7 of 14 orgs (indices 0,2,4,6,8,10,12)
  org.productLines = { dme: true, peptides: isPeptideOrg };
  if (isPeptideOrg) {
    // Synthesize a small set of peptide orders so AccountsView's Peptide
    // tab populates with realistic delivered/in-progress counts. Shape
    // matches the fields AccountsView reads: status (for delivered count),
    // and array length (for total).
    const orderCount = 3 + (idx % 3); // 3, 4, or 5 orders per peptide org
    org.peptideOrders = Array.from({ length: orderCount }, (_, i) => ({
      id: `${org.organizationId}-pep-${i + 1}`,
      organizationId: org.organizationId,
      organizationName: org.organizationName,
      status: _peptideStatusByMod[(idx + i) % _peptideStatusByMod.length],
      totalCents: 8000 + i * 4500,
      createdAt: daysAgo(7 + idx + i * 3),
      updatedAt: daysAgo(2 + i),
      lineItems: [{ variantId: "bpc-157-10mg", quantity: 1 + (i % 3) }],
    }));
    // Refill candidates — flag the most-recent order on every other peptide
    // org as a refill candidate so the "Refill ready" filter has something
    // to show.
    org.refillCandidates = idx % 4 === 0 ? [{ orderId: org.peptideOrders[0].id, daysSinceLastOrder: 28 }] : [];
  } else {
    org.peptideOrders = [];
    org.refillCandidates = [];
  }
});

// -- Sales Rep Users (listSalesReps response shape) --
// Hierarchy: Torres (master) → Park, Kim, Cruz → Foster (under Park), Lopez & Morgan (under Kim), Washington (under Cruz)
export const demoSalesRepUsers = [
  {
    id: "rep-torres",
    firstName: "Michael",
    lastName: "Torres",
    email: "m.torres@nationaldme.com",
    groups: ["sales-rep-master"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(365),
    custom: {
      invitedBy: null,
      organizations: {
        "org-sunshine": {},
        "org-palm": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-park",
    firstName: "Jessica",
    lastName: "Park",
    email: "j.park@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(300),
    custom: {
      invitedBy: "rep-torres",
      organizations: {
        "org-coastal": {},
        "org-miami-vascular": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-foster",
    firstName: "Ryan",
    lastName: "Foster",
    email: "r.foster@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(120),
    custom: {
      invitedBy: "rep-park",
      organizations: {
        "org-keys": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-kim",
    firstName: "David",
    lastName: "Kim",
    email: "d.kim@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(280),
    custom: {
      invitedBy: "rep-torres",
      organizations: {
        "org-bay-podiatry": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-lopez",
    firstName: "Amanda",
    lastName: "Lopez",
    email: "a.lopez@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(200),
    custom: {
      invitedBy: "rep-kim",
      organizations: {
        "org-atlantic": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-morgan",
    firstName: "Chris",
    lastName: "Morgan",
    email: "c.morgan@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(180),
    custom: {
      invitedBy: "rep-kim",
      organizations: {
        "org-orlando": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-cruz",
    firstName: "Natalie",
    lastName: "Cruz",
    email: "n.cruz@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(150),
    custom: {
      invitedBy: "rep-torres",
      organizations: {
        "org-everglades": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-washington",
    firstName: "Derek",
    lastName: "Washington",
    email: "d.washington@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(60),
    custom: {
      invitedBy: "rep-cruz",
      organizations: {
        "org-gulf": {},
      },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  // -- Level 3: Sub-sub-reps (under Foster, Lopez, Morgan, Washington) --
  {
    id: "rep-santos",
    firstName: "Elena",
    lastName: "Santos",
    email: "e.santos@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(90),
    custom: {
      invitedBy: "rep-foster",
      organizations: { "org-treasure": {} },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-okafor",
    firstName: "Chidi",
    lastName: "Okafor",
    email: "c.okafor@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(75),
    custom: {
      invitedBy: "rep-lopez",
      organizations: { "org-naples": {} },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-nguyen",
    firstName: "Tiffany",
    lastName: "Nguyen",
    email: "t.nguyen@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(50),
    custom: {
      invitedBy: "rep-morgan",
      organizations: { "org-lakeland": {} },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
  {
    id: "rep-hayes",
    firstName: "Marcus",
    lastName: "Hayes",
    email: "m.hayes@nationaldme.com",
    groups: ["sales-rep"],
    role: "advanced",
    status: "active",
    createdAt: daysAgo(40),
    custom: {
      invitedBy: "rep-washington",
      organizations: { "org-ocala": {} },
      commission: 150,
      commissionPercent: 40,
      commissionType: "lesser",
    },
  },
];

// -- Team members for user management views --
export const demoTeamMembers = [
  {
    id: "team-1",
    firstName: "Dr. Sarah",
    lastName: "Mitchell",
    email: "s.mitchell@demo.com",
    role: "advanced",
    groups: ["doctor"],
    custom: { npiNumber: "1234567890", doctorType: "MD" },
    status: "active",
  },
  {
    id: "team-2",
    firstName: "Lisa",
    lastName: "Nguyen",
    email: "l.nguyen@demo.com",
    role: "advanced",
    groups: ["team-member"],
    custom: {},
    status: "active",
  },
  {
    id: "team-3",
    firstName: "Mark",
    lastName: "Phillips",
    email: "m.phillips@demo.com",
    role: "advanced",
    groups: ["doctor"],
    custom: { npiNumber: "2345678901", doctorType: "DO" },
    status: "active",
  },
  {
    id: "team-4",
    firstName: "Michael",
    lastName: "Torres",
    email: "m.torres@demo.com",
    role: "advanced",
    groups: ["sales-rep"],
    custom: {},
    status: "active",
  },
  {
    id: "team-5",
    firstName: "Karen",
    lastName: "Patel",
    email: "k.patel@demo.com",
    role: "supervisor",
    groups: [],
    custom: {},
    status: "active",
  },
  {
    id: "team-6",
    firstName: "Dr. James",
    lastName: "Rivera",
    email: "j.rivera@demo.com",
    role: "advanced",
    groups: ["doctor"],
    custom: { npiNumber: "3456789012", doctorType: "MD" },
    status: "active",
  },
  {
    id: "team-7",
    firstName: "Dr. Angela",
    lastName: "Brooks",
    email: "a.brooks@demo.com",
    role: "advanced",
    groups: ["doctor"],
    custom: { npiNumber: "4567890123", doctorType: "DPM" },
    status: "active",
  },
  {
    id: "team-8",
    firstName: "Dr. David",
    lastName: "Kim",
    email: "d.kim@demo.com",
    role: "advanced",
    groups: ["doctor"],
    custom: { npiNumber: "5678901234", doctorType: "MD" },
    status: "active",
  },
];

// ============================================================
// PEPTIDE DEMO DATA
// Used by the peptide demo mode (see demoInterceptor.js handlers).
// All product names, indications, and pricing are fictional but
// modeled on real peptide therapeutics commonly used in clinical
// peptide programs (research-use disclaimers omitted for demo).
// ============================================================

// Patient-safe field placeholders. Demo/dev only — manufacturer authors
// real values per product via the catalog management UI before patients
// see the catalog (per `2026-05-05-patient-peptide-home-design.md`:261).
// Spread into each demo product so every entry has the same placeholder
// shape; if/when manufacturer-specific text is needed for a particular
// product in dev, override the field on that product literal.
const PEPTIDE_PATIENT_PLACEHOLDER = Object.freeze({
  patientShortLabel: "Compounded peptide",
  patientDescription:
    "A compounded peptide product. Use only as directed by your provider, who will review and approve every order.",
  patientBenefits: ["Subcutaneous injection", "Provider-supervised"],
  patientDosingReference:
    "Common dosing for this product is in the range of [X–Y]. Discuss with your provider what's right for your situation.",
  patientShortLabelEs: "Péptido compuesto",
  patientDescriptionEs:
    "Un producto de péptido compuesto. Úselo solo como lo indique su proveedor, quien revisará y aprobará cada pedido.",
  patientBenefitsEs: ["Inyección subcutánea", "Supervisado por proveedor"],
  patientDosingReferenceEs:
    "La dosis común para este producto está en el rango de [X–Y]. Consulte con su proveedor sobre lo adecuado para su situación.",
});

export const demoPeptideCatalog = [
  {
    benefits: ["Fat breakdown stimulation", "Inhibits lipogenesis", "Joint health support"],
    image: "2026-04-06-16-52-04-643.png",
    subtitle: "Fragment 176-191",
    name: "AOD 9604",
    description:
      "Synthetic peptide from human growth hormone fragment. Stimulates fat breakdown (lipolysis) and inhibits new fat formation. May also support joint health.",
    id: "aod-9604",
    variants: [{ dosage: "5MG", distribCents: 3456, priceCents: 12500, id: "aod-9604-5mg" }],
    category: "singles",
    mechanism:
      "Derived from the fat-reducing region of HGH (amino acids 177–191), it mimics growth hormone's lipolytic effects without affecting blood sugar or cell proliferation.",
    dosing: "250–500mcg daily via subcutaneous injection, typically on an empty stomach. Cycle 5 days on, 2 days off.",
    tags: ["weightLoss"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Accelerated tissue healing", "Gut protection", "Anti-inflammatory", "Tendon & ligament repair"],
    image: "2026-04-06-16-52-08-281.png",
    subtitle: "Body Protection Compound",
    name: "BPC 157",
    description:
      "Body Protection Compound derived from gastric juice protein. Accelerates healing of tendons, ligaments, muscles, and bones. Protects gut and reduces inflammation.",
    id: "bpc-157",
    variants: [{ dosage: "10MG", distribCents: 3024, priceCents: 12500, id: "bpc-157-10mg" }],
    tag: "Best Seller",
    category: "singles",
    mechanism:
      "Derived from a protective protein in gastric juice, BPC-157 upregulates growth factor receptors, promotes angiogenesis, and modulates nitric oxide to accelerate tissue repair.",
    dosing: "250–500mcg 1–2 times daily via subcutaneous injection near the injury site. Typical cycle is 4–8 weeks.",
    tags: ["recovery", "muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Pulsatile GH release", "Muscle growth", "Fat loss", "Anti-aging support"],
    image: "2026-04-06-16-52-10-223.png",
    subtitle: "GHRH Analog",
    name: "CJC 1295",
    description:
      "Growth hormone releasing hormone analog. Stimulates pulsatile GH release for muscle growth, fat loss, improved recovery, and anti-aging effects.",
    id: "cjc-1295",
    variants: [{ dosage: "10MG", distribCents: 5212, priceCents: 12500, id: "cjc-1295-10mg" }],
    tag: "Popular",
    category: "singles",
    mechanism:
      "Binds to GHRH receptors on the pituitary gland, amplifying natural GH pulse amplitude without disrupting the body's feedback mechanisms.",
    dosing: "100–300mcg before bed via subcutaneous injection, 5 days per week. Best combined with a GHRP like Ipamorelin.",
    tags: ["muscleGrowth", "antiAging"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-06-16-52-12-762.png",
    subtitle: "Combo Stack",
    name: "CJC 1295 / Ipamorelin",
    description: "",
    id: "cjc-1295-ipamorelin",
    variants: [{ dosage: "5MG/5MG", distribCents: 5744, priceCents: 15000, id: "cjc-1295-ipamorelin-5mg-5mg" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Deep sleep promotion", "Insomnia relief", "Calming effects", "Natural sleep cycle"],
    image: "2026-04-06-16-52-15-444.png",
    subtitle: "Delta Sleep-Inducing Peptide",
    name: "DSIP",
    description:
      "Neuropeptide that promotes deep, slow-wave (delta) sleep. Naturally produced in the hypothalamus. Improves sleep quality, reduces insomnia, and has calming effects.",
    id: "dsip",
    variants: [{ dosage: "5MG", distribCents: 3888, priceCents: 12500, id: "dsip-5mg" }],
    category: "singles",
    mechanism:
      "Modulates sleep-wake cycles by influencing GABA, serotonin, and cortisol pathways. Promotes the transition into delta (slow-wave) sleep, the most restorative phase.",
    dosing: "100–200mcg via subcutaneous injection 30–60 minutes before bedtime. Can be used nightly or as needed.",
    tags: ["sleep", "cognitive"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Telomere maintenance", "Melatonin regulation", "Immune support", "Sleep quality"],
    image: "2026-04-06-16-52-18-778.png",
    subtitle: "Telomerase Activator",
    name: "Epithalon",
    description:
      "Synthetic tetrapeptide that stimulates telomerase activity to maintain telomere length. Enhances pineal gland function, melatonin production, and immune support.",
    id: "epithalon",
    variants: [{ dosage: "50MG", distribCents: 8064, priceCents: 12500, id: "epithalon-50mg" }],
    tag: "Popular",
    category: "singles",
    mechanism:
      "Activates telomerase enzyme to elongate telomeres on chromosomes, counteracting cellular aging. Also restores pineal gland function and normalizes melatonin production.",
    dosing: "5–10mg daily via subcutaneous injection for 10–20 day cycles. Repeat every 4–6 months.",
    tags: ["antiAging"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Myostatin inhibition", "Muscle growth", "Tissue repair"],
    image: "2026-04-09-14-00-31-750.png",
    subtitle: "Myostatin Inhibitor",
    name: "Folistatin 344 (95%)",
    description:
      "Naturally occurring glycoprotein that inhibits myostatin and activin, promoting muscle growth beyond natural limits and supporting tissue repair.",
    id: "folistatin-344",
    variants: [{ dosage: "1MG", distribCents: 3888, priceCents: 15000, id: "folistatin-344-1mg" }],
    category: "singles",
    mechanism:
      "Binds and neutralizes myostatin and activin, removing the natural brake on muscle growth. Also modulates follicle-stimulating hormone and inflammatory pathways.",
    dosing: "100mcg daily via subcutaneous injection. Typical cycle is 10–30 days. Advanced protocols may vary.",
    tags: ["muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Collagen synthesis", "Hair growth", "Wound healing", "Anti-wrinkle"],
    image: "2026-04-06-16-52-22-167.png",
    subtitle: "Copper Peptide",
    name: "GHK-CU",
    description:
      "Naturally occurring copper tripeptide. Stimulates collagen and elastin production, accelerates wound healing, promotes hair growth, and reduces wrinkles. Levels decline with age.",
    id: "ghk-cu",
    variants: [{ dosage: "100MG", distribCents: 3888, priceCents: 12500, id: "ghk-cu-100mg" }],
    tag: "Popular",
    category: "singles",
    mechanism:
      "Delivers bioavailable copper to activate genes involved in collagen synthesis, decorin production, and angiogenesis while suppressing inflammatory cytokines and metalloproteinases.",
    dosing: "1–2mg daily via subcutaneous injection. May also be used topically. Cycle 4–8 weeks on, 2–4 weeks off.",
    tags: ["skinHair", "antiAging", "recovery"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-06-16-52-24-346.png",
    subtitle: "GHK-CU / BPC-157 / TB-500",
    name: "GLOW 70",
    description: "",
    id: "glow-70",
    variants: [{ dosage: "50MG/10MG/10MG", distribCents: 12960, priceCents: 17500, id: "glow-70-50mg-10mg-10mg" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["recovery", "skinHair"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["LH stimulation", "Testosterone support", "Hormonal balance"],
    image: "2026-04-06-16-52-26-419.png",
    subtitle: "GnRH Agonist",
    name: "Gonadorelin",
    description: "GnRH agonist that stimulates luteinizing hormone and FSH for testosterone production and hormonal support.",
    id: "gonadorelin",
    variants: [{ dosage: "10MG", distribCents: 5400, priceCents: 12500, id: "gonadorelin-10mg" }],
    category: "singles",
    mechanism:
      "A synthetic GnRH that directly stimulates the pituitary to release LH and FSH, supporting endogenous testosterone production and testicular function.",
    dosing: "100–200mcg 2 times daily via subcutaneous injection. Often used alongside TRT to maintain fertility.",
    tags: ["sexualHealth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Testosterone support", "Fertility preservation", "Testicular function", "LH mimetic"],
    image: "2026-04-06-16-52-28-834.png",
    subtitle: "Human Chorionic Gonadotropin",
    name: "HCG",
    description:
      "Mimics luteinizing hormone to stimulate testosterone production and maintain testicular function. Widely used alongside TRT to preserve fertility.",
    id: "hcg",
    variants: [{ dosage: "5000IU", distribCents: 4240, priceCents: 12500, id: "hcg-5000iu" }],
    category: "singles",
    mechanism:
      "Binds to LH receptors on Leydig cells in the testes, stimulating endogenous testosterone production and maintaining testicular volume and spermatogenesis during TRT.",
    dosing: "250–500 IU 2–3 times weekly via subcutaneous injection. Timing and dose adjusted based on labs.",
    tags: ["sexualHealth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-09-14-00-56-477.png",
    subtitle: "Human Growth Hormone",
    name: "HGH",
    description: "",
    id: "hgh",
    variants: [{ dosage: "TBD", priceCents: 0, id: "hgh-tbd" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["muscleGrowth", "antiAging"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Extended half-life", "Muscle hypertrophy", "Tissue repair", "Protein synthesis"],
    image: "2026-04-06-16-52-31-109.png",
    subtitle: "Insulin-like Growth Factor",
    name: "IGF-1 LR3",
    description:
      "Synthetic analog of IGF-1 with extended half-life (20-30 hours). Promotes cell growth, muscle development, tissue repair, and protein synthesis.",
    id: "igf-1-lr3",
    variants: [{ dosage: "1MG", distribCents: 8640, priceCents: 12500, id: "igf-1-lr3-1mg" }],
    category: "singles",
    mechanism:
      "A modified form of IGF-1 with reduced IGF-binding protein affinity, resulting in a 20–30 hour half-life and sustained activation of the IGF-1 receptor for anabolic signaling.",
    dosing: "20–50mcg daily via subcutaneous or intramuscular injection. Cycle 4 weeks on, 4 weeks off.",
    tags: ["muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Clean GH release", "No cortisol spike", "Muscle recovery", "Fat metabolism"],
    image: "2026-04-06-16-52-33-115.png",
    subtitle: "Selective GH Secretagogue",
    name: "Ipamorelin",
    description:
      "Selective growth hormone secretagogue that stimulates GH release without affecting cortisol or prolactin. Supports muscle growth, fat metabolism, and recovery.",
    id: "ipamorelin",
    variants: [{ dosage: "10MG", distribCents: 4240, priceCents: 12500, id: "ipamorelin-10mg" }],
    tag: "Popular",
    category: "singles",
    mechanism:
      "Selectively activates ghrelin receptors on the pituitary to trigger GH pulses without stimulating cortisol, prolactin, or appetite — the cleanest GH secretagogue available.",
    dosing: "200–300mcg 2–3 times daily via subcutaneous injection. Best taken on an empty stomach, especially before bed.",
    tags: ["muscleGrowth", "antiAging"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-09-14-01-08-993.png",
    name: "Kisspeptin",
    description: "",
    id: "kisspeptin",
    variants: [{ dosage: "10MG", distribCents: 5072, priceCents: 12500, id: "kisspeptin-10mg" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["sexualHealth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-06-16-52-34-935.png",
    subtitle: "GHK-CU / BPC-157 / KPV / TB-500",
    name: "KLOW 80",
    description: "",
    id: "klow-80",
    variants: [{ dosage: "50MG/10MG/10MG/10MG", distribCents: 15080, priceCents: 19500, id: "klow-80-50mg-10mg-10mg-10mg" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["recovery", "immune"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Exercise mimetic", "Insulin sensitivity", "Energy metabolism", "Mitochondrial health"],
    image: "2026-04-06-16-52-36-678.png",
    subtitle: "Mitochondrial-Derived Peptide",
    name: "MOTS-C",
    description:
      "Mitochondrial-derived peptide that enhances insulin sensitivity, promotes glucose uptake, and improves energy metabolism. Mimics some effects of exercise.",
    id: "mots-c",
    variants: [{ dosage: "10MG", distribCents: 3888, priceCents: 12500, id: "mots-c-10mg" }],
    category: "singles",
    mechanism:
      "Encoded by mitochondrial DNA, MOTS-c activates AMPK signaling to enhance glucose metabolism and fatty acid oxidation, mimicking the metabolic benefits of exercise.",
    dosing: "5mg 2–3 times per week via subcutaneous injection. Often cycled 4 weeks on, 2 weeks off.",
    tags: ["antiAging", "energy"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["DNA repair support", "Sirtuin activation", "Energy production", "Longevity support"],
    image: "2026-04-06-16-52-38-452.png",
    subtitle: "Essential Coenzyme",
    name: "NAD+",
    description:
      "Essential coenzyme for energy production, DNA repair, and cell signaling. Levels decline with age. Supports sirtuins (longevity proteins) and PARP enzymes for DNA repair.",
    id: "nad-plus",
    variants: [
      { dosage: "500MG", distribCents: 4688, priceCents: 12500, id: "nad-plus-500mg" },
      { dosage: "1000MG", distribCents: 7344, priceCents: 25000, id: "nad-plus-1000mg" },
    ],
    tag: "Popular",
    category: "singles",
    mechanism:
      "A critical cofactor for NAD+-dependent enzymes including sirtuins (gene silencing, longevity) and PARPs (DNA repair). Direct supplementation bypasses biosynthetic bottlenecks.",
    dosing: "100–500mg via IV infusion or subcutaneous injection 1–3 times weekly. Start low and titrate up based on tolerance.",
    tags: ["antiAging", "energy", "immune"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Social bonding", "Emotional wellness", "Trust enhancement"],
    image: "2026-04-06-16-52-40-232.png",
    subtitle: "Social Bonding Neuropeptide",
    name: "Oxytocin",
    description:
      "Neuropeptide involved in social bonding, trust, and sexual arousal. Supports emotional wellness and connection.",
    id: "oxytocin",
    variants: [{ dosage: "10MG", distribCents: 3888, priceCents: 12500, id: "oxytocin-10mg" }],
    category: "singles",
    mechanism:
      "Binds to oxytocin receptors in the brain to facilitate social bonding, reduce anxiety, and enhance trust. Also plays a role in sexual arousal and uterine contractions.",
    dosing: "10–20 IU intranasally as needed. Effects typically last 2–4 hours.",
    tags: ["sexualHealth", "sleep"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Central nervous system action", "Increased desire", "Works for both sexes", "Non-vascular mechanism"],
    image: "2026-04-06-16-52-41-980.png",
    subtitle: "Bremelanotide",
    name: "PT-141",
    description:
      "Acts on the central nervous system by stimulating melanocortin receptors (MC3R/MC4R) to increase sexual desire and arousal. Works differently from PDE5 inhibitors like Viagra.",
    id: "pt-141",
    variants: [{ dosage: "10MG", distribCents: 3888, priceCents: 12500, id: "pt-141-10mg" }],
    tag: "Popular",
    category: "singles",
    mechanism:
      "Activates MC3R and MC4R melanocortin receptors in the hypothalamus, stimulating dopaminergic pathways involved in sexual desire and arousal — a fundamentally different mechanism from PDE5 inhibitors.",
    dosing:
      "1.75mg via subcutaneous injection 45 minutes before anticipated activity. Maximum 1 dose per 24 hours, 8 doses per month.",
    tags: ["sexualHealth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Triple receptor targeting", "Lean mass preservation", "Enhanced glycemic control", "Next-generation efficacy"],
    image: "2026-04-06-16-52-43-947.png",
    subtitle: "Retatrutide",
    name: "Reta GLP-3",
    description:
      "Triple agonist targeting GLP-1, GIP, and glucagon receptors. Enhances weight loss, glycemic control, and may preserve lean muscle mass.",
    id: "reta-glp-3",
    variants: [
      { dosage: "10MG", distribCents: 6544, priceCents: 24000, id: "reta-glp-3-10mg" },
      { dosage: "20MG", distribCents: 9792, priceCents: 36000, id: "reta-glp-3-20mg" },
      { dosage: "30MG", distribCents: 14400, priceCents: 54000, id: "reta-glp-3-30mg" },
      { dosage: "50MG", distribCents: 20000, priceCents: 90000, id: "reta-glp-3-50mg" },
    ],
    tag: "New",
    category: "singles",
    mechanism:
      "Simultaneously activates GLP-1, GIP, and glucagon receptors, leveraging glucagon's thermogenic effects alongside incretin-mediated appetite suppression for superior weight loss.",
    dosing: "Start at 1mg weekly, titrate gradually. Target maintenance of 4–12mg weekly via subcutaneous injection.",
    tags: ["glp", "weightLoss"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: true,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Anti-anxiety", "BDNF enhancement", "Cognitive clarity", "No sedation"],
    image: "2026-04-06-16-52-45-980.png",
    subtitle: "Anxiolytic Nootropic Peptide",
    name: "Selank",
    description:
      "Synthetic peptide derived from tuftsin. Increases BDNF in hippocampus, influences serotonin and dopamine. Anti-anxiety and cognitive-enhancing effects without sedation or dependence.",
    id: "selank",
    variants: [
      { dosage: "5MG", distribCents: 3024, priceCents: 7500, id: "selank-5mg" },
      { dosage: "10MG", distribCents: 4688, priceCents: 12500, id: "selank-10mg" },
    ],
    category: "singles",
    mechanism:
      "A synthetic analog of tuftsin (immune peptide) that increases BDNF expression in the hippocampus, modulates serotonin and dopamine, and enhances IL-6 for immune–brain axis support.",
    dosing: "250–500mcg intranasally 2–3 times daily. Can be used daily without tolerance or dependence.",
    tags: ["cognitive"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Appetite suppression", "Blood sugar regulation", "Sustained weight loss", "Improved metabolic health"],
    image: "2026-04-06-16-52-47-887.png",
    subtitle: "Semaglutide",
    name: "Sema GLP-1",
    description:
      "GLP-1 receptor agonist that regulates blood sugar, stimulates insulin release, slows gastric emptying, and reduces appetite for weight management.",
    id: "sema-glp-1",
    variants: [
      { dosage: "5MG", distribCents: 2800, priceCents: 10500, id: "sema-glp-1-5mg" },
      { dosage: "10MG", distribCents: 3460, priceCents: 15000, id: "sema-glp-1-10mg" },
      { dosage: "12.5MG (Activated)", distribCents: 3960, priceCents: 19000, id: "sema-glp-1-12-5mg-activated" },
      { dosage: "20MG", distribCents: 6050, priceCents: 30000, id: "sema-glp-1-20mg" },
    ],
    tag: "Best Seller",
    category: "singles",
    mechanism:
      "Mimics the GLP-1 hormone to activate receptors in the brain that regulate appetite and food intake, while slowing gastric emptying to promote satiety.",
    dosing:
      "Start at 0.25mg weekly, titrate up every 4 weeks. Maintenance dose typically 1.0–2.4mg weekly via subcutaneous injection.",
    tags: ["glp", "weightLoss"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: true,
    restrictedShippingStates: [],
  },
  {
    benefits: ["BDNF & NGF boost", "Cerebral blood flow", "Stress resilience", "Focus enhancement"],
    image: "2026-04-06-16-52-49-878.png",
    subtitle: "ACTH Fragment Nootropic",
    name: "Semax",
    description:
      "Synthetic ACTH fragment nootropic. Increases BDNF and NGF, enhances cerebral blood flow, and improves memory, focus, and stress resilience. Approved in Russia for stroke recovery.",
    id: "semax",
    variants: [
      { dosage: "10MG", distribCents: 3456, priceCents: 12500, id: "semax-10mg" },
      { dosage: "30MG", priceCents: 0, id: "semax-30mg" },
    ],
    category: "singles",
    mechanism:
      "A synthetic fragment of ACTH (4–10) that increases BDNF and NGF expression, enhances cerebral circulation, and modulates dopaminergic and serotoninergic neurotransmission.",
    dosing: "200–600mcg intranasally 1–2 times daily. Typically cycled 2–3 weeks on, 1–2 weeks off.",
    tags: ["cognitive"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Natural GH boost", "Improved sleep", "Skin elasticity", "Energy enhancement"],
    image: "2026-04-06-16-52-51-918.png",
    subtitle: "Synthetic GHRH (1-29)",
    name: "Sermorelin",
    description:
      "Synthetic GHRH analog (first 29 amino acids). Boosts natural GH production for improved energy, skin elasticity, muscle mass, fat loss, sleep, and recovery.",
    id: "sermorelin",
    variants: [{ dosage: "10MG", distribCents: 7344, priceCents: 12500, id: "sermorelin-10mg" }],
    category: "singles",
    mechanism:
      "Contains the first 29 amino acids of endogenous GHRH, which is the bioactive portion. Stimulates pituitary GH release while preserving the natural feedback loop.",
    dosing: "200–500mcg daily via subcutaneous injection at bedtime. Allow 3–6 months for full effects.",
    tags: ["muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Tissue repair", "Angiogenesis", "Reduced inflammation", "Improved flexibility"],
    image: "2026-04-06-16-52-53-802.png",
    subtitle: "Thymosin Beta 4",
    name: "TB 500",
    description:
      "Synthetic Thymosin Beta-4 that accelerates tissue repair, reduces inflammation, promotes blood vessel formation, and improves flexibility and mobility.",
    id: "tb-500",
    variants: [{ dosage: "10MG", distribCents: 4688, priceCents: 12500, id: "tb-500-10mg" }],
    category: "singles",
    mechanism:
      "Upregulates actin, a cell-building protein, to promote cell migration and blood vessel formation. Reduces inflammatory cytokines and promotes tissue regeneration.",
    dosing: "2–5mg twice weekly via subcutaneous injection during loading phase (4–6 weeks), then 2mg weekly for maintenance.",
    tags: ["recovery", "muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Visceral fat reduction", "Cognitive support", "Lean mass increase", "FDA-approved GHRH"],
    image: "2026-04-06-16-52-55-658.png",
    subtitle: "GHRH Analog",
    name: "Tesamorelin",
    description:
      "GHRH analog that stimulates pulsatile GH release. Reduces visceral fat, increases lean muscle mass, and supports cognitive function.",
    id: "tesamorelin",
    variants: [{ dosage: "10MG", distribCents: 4590, priceCents: 12500, id: "tesamorelin-10mg" }],
    category: "singles",
    mechanism:
      "A stabilized GHRH analog that stimulates the pituitary to release GH in natural pulsatile patterns, particularly effective at reducing visceral adipose tissue.",
    dosing: "1–2mg daily via subcutaneous injection, typically at bedtime. Use continuously; effects plateau after 6–12 months.",
    tags: ["muscleGrowth", "weightLoss", "sleep"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: [],
    image: "2026-04-06-16-52-57-622.png",
    subtitle: "Combo Stack",
    name: "Tesamorelin / Ipamorelin",
    description: "",
    id: "tesamorelin-ipamorelin",
    variants: [{ dosage: "10MG/5MG", distribCents: 7873, priceCents: 17500, id: "tesamorelin-ipamorelin-10mg-5mg" }],
    category: "singles",
    mechanism: "",
    dosing: "",
    tags: ["muscleGrowth"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: false,
    restrictedShippingStates: [],
  },
  {
    benefits: ["Superior weight loss", "Dual receptor action", "Improved insulin sensitivity", "Reduced cardiovascular risk"],
    image: "2026-04-06-16-52-59-561.png",
    subtitle: "Tirzepatide",
    name: "Tirz GLP-2",
    description:
      "Dual GIP/GLP-1 receptor agonist for blood sugar control and weight reduction. Greater efficacy than GLP-1-only drugs.",
    id: "tirz-glp-2",
    variants: [
      { dosage: "10MG", distribCents: 6120, priceCents: 20000, id: "tirz-glp-2-10mg" },
      { dosage: "20MG", distribCents: 6912, priceCents: 30000, id: "tirz-glp-2-20mg" },
      { dosage: "30MG", distribCents: 8140, priceCents: 45000, id: "tirz-glp-2-30mg" },
      { dosage: "45MG (Activated)", priceCents: 67500, id: "tirz-glp-2-45mg-activated" },
      { dosage: "50MG (Activated)", distribCents: 13480, priceCents: 75000, id: "tirz-glp-2-50mg-activated" },
      { dosage: "60MG", distribCents: 16160, priceCents: 90000, id: "tirz-glp-2-60mg" },
      { dosage: "75MG (Activated)", distribCents: 20480, priceCents: 112500, id: "tirz-glp-2-75mg-activated" },
    ],
    tag: "Best Seller",
    category: "singles",
    mechanism:
      "Activates both GIP and GLP-1 receptors simultaneously, providing enhanced glucose-dependent insulinotropic action with stronger weight-loss effects than GLP-1 monotherapy.",
    dosing:
      "Start at 2.5mg weekly, titrate up every 4 weeks. Maintenance dose typically 5–15mg weekly via subcutaneous injection.",
    tags: ["glp", "weightLoss"],
    ...PEPTIDE_PATIENT_PLACEHOLDER,
    isCompounded: true,
    isHighScrutinyTier: true,
    restrictedShippingStates: [],
  },
];

// Tier pricing in cents. Tier order: A (best wholesale) → W (patient retail).
// Margin between A and W is roughly 2x; W is what tier-W (patient) users see.
export const demoPeptideTierPricing = {
  "tirz-glp-2-10mg": { A: 7000, B: 8000, distrib: 6120, C: 9000, D: 10000, W: 20000 },
  "folistatin-344-1mg": { A: 11500, B: 11500, distrib: 3888, C: 11500, D: 11500, W: 15000 },
  "klow-80-50mg-10mg-10mg-10mg": { A: 10500, B: 11500, distrib: 15080, C: 12500, D: 13500, W: 19500 },
  "ghk-cu-100mg": { A: 5500, B: 6500, distrib: 3888, C: 7500, D: 8500, W: 12500 },
  "nad-plus-1000mg": { A: 8500, B: 9500, distrib: 7344, C: 11500, D: 12500, W: 25000 },
  "tirz-glp-2-50mg-activated": { distrib: 13480 },
  "mots-c-10mg": { A: 5500, B: 6500, distrib: 3888, C: 7500, D: 8500, W: 12500 },
  "tirz-glp-2-75mg-activated": { distrib: 20480 },
  "reta-glp-3-30mg": { A: 29000, B: 30000, distrib: 14400, C: 32000, D: 34000, W: 54000 },
  "selank-10mg": { distrib: 4688, W: 12500 },
  "test-3g": {},
  "tirz-glp-2-20mg": { A: 12500, B: 13500, distrib: 6912, C: 14500, D: 16000, W: 30000 },
  "semax-30mg": {},
  "aod-9604-5mg": { A: 5500, B: 6500, distrib: 3456, C: 7500, D: 8500, W: 12500 },
  "sema-glp-1-12-5mg-activated": { distrib: 3960 },
  "reta-glp-3-50mg": { A: 44000, B: 45000, distrib: 20000, C: 47500, D: 49500, W: 90000 },
  "tirz-glp-2-60mg": { A: 32000, B: 34000, distrib: 16160, C: 36000, D: 39000, W: 90000 },
  "hgh-tbd": {},
  "dynacord-2ml": { A: 180000, B: 210000, C: 250000, D: 300000, W: 320000 },
  "tesamorelin-10mg": { A: 5500, B: 6500, distrib: 4590, C: 7500, D: 7500, W: 12500 },
  "lipo-plus-30ml": { A: 8100, B: 8100, distrib: 8100, C: 8100, D: 8100, W: 8100 },
  "nad-plus-500mg": { A: 5500, B: 6500, distrib: 4688, C: 8500, D: 9500, W: 12500 },
  "reta-glp-3-20mg": { A: 20000, B: 22000, distrib: 9792, C: 23000, D: 24000, W: 36000 },
  "tirz-glp-2-30mg": { A: 21000, B: 22000, distrib: 8140, C: 23000, D: 25000, W: 45000 },
  "kisspeptin-10mg": { distrib: 5072, W: 12500 },
  "ipamorelin-10mg": { A: 5500, B: 6500, distrib: 4240, C: 7500, D: 8500, W: 12500 },
  "test-product-10mg": { distrib: 1500 },
  "bpc-157-10mg": { A: 6000, B: 7000, distrib: 3024, C: 7500, D: 8500, W: 12500 },
  "pt-141-10mg": { A: 5000, B: 6000, distrib: 3888, C: 7500, D: 8500, W: 12500 },
  "sema-glp-1-10mg": { A: 5500, B: 6500, distrib: 3460, C: 7500, D: 8500, W: 15000 },
  "glow-70-50mg-10mg-10mg": { A: 9500, B: 10500, distrib: 12960, C: 11500, D: 12500, W: 17500 },
  "reta-glp-3-10mg": { A: 11500, B: 13500, distrib: 6544, C: 15000, D: 16000, W: 24000 },
  "tb-500-10mg": { A: 6000, B: 7000, distrib: 4688, C: 7500, D: 8500, W: 12500 },
  "l-carnitine-500mg-ml-30ml": { A: 8100, B: 8100, distrib: 8100, C: 8100, D: 8100, W: 8100 },
  "selank-5mg": { A: 3000, B: 4000, distrib: 3024, C: 6000, D: 7000, W: 7500 },
  "hcg-5000iu": { A: 5500, B: 6500, distrib: 4240, C: 7500, D: 8500, W: 12500 },
  "oxytocin-10mg": { A: 5000, B: 6000, distrib: 3888, C: 7500, D: 8500, W: 12500 },
  "wolverine-10mg-10mg": { A: 8500, B: 9500, distrib: 6480, C: 10500, D: 11500, W: 15500 },
  "semax-10mg": { A: 4500, B: 5500, distrib: 3456, C: 7500, D: 8500, W: 12500 },
  "epithalon-50mg": { A: 3500, B: 4500, distrib: 8064, C: 6500, D: 7500, W: 12500 },
  "sema-glp-1-20mg": { A: 9500, B: 10500, distrib: 6050, C: 11500, D: 12500, W: 30000 },
  "dynacord-1ml": { A: 100000, B: 125000, C: 135000, D: 150000, W: 165000 },
  "glutathione-200mg-ml-30ml": { A: 7000, B: 7000, distrib: 7000, C: 7000, D: 7000, W: 7000 },
  "dynacord-5ml": { A: 400000, B: 500000, C: 600000, D: 750000, W: 750000 },
  "bacteriostatic-water-30ml": { A: 2500, B: 3000, distrib: 3000, C: 3500, D: 3500, W: 4500 },
  "tirz-glp-2-45mg-activated": {},
  "igf-1-lr3-1mg": { A: 7500, B: 8500, distrib: 8640, C: 9000, D: 10000, W: 12500 },
  "sema-glp-1-5mg": { A: 4000, B: 5000, distrib: 2800, C: 6000, D: 7000, W: 10500 },
  "tesamorelin-ipamorelin-10mg-5mg": { distrib: 7873 },
  "sermorelin-10mg": { A: 5500, B: 6500, distrib: 7344, C: 7500, D: 8500, W: 12500 },
  "cjc-1295-10mg": { A: 5500, B: 6500, distrib: 5212, C: 7500, D: 8500, W: 12500 },
  "gonadorelin-10mg": { A: 5500, B: 6500, distrib: 5400, C: 7500, D: 8500, W: 12500 },
  "dsip-5mg": { A: 4000, B: 5000, distrib: 3888, C: 6500, D: 7500, W: 12500 },
  "cjc-1295-ipamorelin-5mg-5mg": { A: 8500, B: 9500, distrib: 5744, C: 10500, D: 11500, W: 15000 },
};

// Manufacturer cost per variant in cents (used in margin calculations).
// Roughly 30-40% of tier A.
export const demoPeptideCostData = {
  "aod-9604-5mg": 3456,
  "bpc-157-10mg": 3024,
  "cjc-1295-10mg": 5212,
  "cjc-1295-ipamorelin-5mg-5mg": 5744,
  "dsip-5mg": 3888,
  "epithalon-50mg": 8064,
  "folistatin-344-1mg": 3888,
  "ghk-cu-100mg": 3888,
  "glow-70-50mg-10mg-10mg": 12960,
  "gonadorelin-10mg": 5400,
  "hcg-5000iu": 4240,
  "igf-1-lr3-1mg": 8640,
  "ipamorelin-10mg": 4240,
  "kisspeptin-10mg": 5072,
  "klow-80-50mg-10mg-10mg-10mg": 15080,
  "mots-c-10mg": 3888,
  "nad-plus-1000mg": 7344,
  "nad-plus-500mg": 4688,
  "oxytocin-10mg": 3888,
  "pt-141-10mg": 3888,
  "reta-glp-3-10mg": 6544,
  "reta-glp-3-20mg": 9792,
  "reta-glp-3-30mg": 14400,
  "reta-glp-3-50mg": 20000,
  "selank-10mg": 4688,
  "selank-5mg": 3024,
  "sema-glp-1-10mg": 3460,
  "sema-glp-1-12-5mg-activated": 3960,
  "sema-glp-1-20mg": 6050,
  "sema-glp-1-5mg": 2800,
  "semax-10mg": 3456,
  "sermorelin-10mg": 7344,
  "tb-500-10mg": 4688,
  "tesamorelin-10mg": 4590,
  "tesamorelin-ipamorelin-10mg-5mg": 7873,
  "tirz-glp-2-10mg": 6120,
  "tirz-glp-2-20mg": 6912,
  "tirz-glp-2-30mg": 8140,
  "tirz-glp-2-50mg-activated": 13480,
  "tirz-glp-2-60mg": 16160,
  "tirz-glp-2-75mg-activated": 20480,
  "wolverine-10mg-10mg": 6480,
  "test-product-10mg": 1500,
};

// Linked provider organizations (clinics) for the demo manufacturer.
// Returned by the manufacturer-side stats handler so peptide manufacturer's
// "linked providers" UI has content.
export const demoLinkedProviders = [
  {
    organizationId: "demo-pep-provider-1",
    organizationName: "Coral Gables Wellness Clinic",
    orgInfo: {
      officeName: "Coral Gables Wellness Clinic",
      officeEmail: "orders@coralgableswellness.com",
      officePhone: "(305) 555-0410",
      officeAddress: "2401 Ponce de Leon Blvd",
      officeCity: "Coral Gables",
      officeState: "FL",
      officeZip: "33134",
      pricingTier: "A",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-2",
    organizationName: "Sunrise Hormone Center",
    orgInfo: {
      officeName: "Sunrise Hormone Center",
      officeEmail: "info@sunrisehormone.com",
      officePhone: "(954) 555-0123",
      officeAddress: "8970 W Oakland Park Blvd",
      officeCity: "Sunrise",
      officeState: "FL",
      officeZip: "33351",
      pricingTier: "B",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-3",
    organizationName: "South Beach Performance Medicine",
    orgInfo: {
      officeName: "South Beach Performance Medicine",
      officeEmail: "ops@sbperfmed.com",
      officePhone: "(305) 555-0788",
      officeAddress: "1100 Lincoln Rd, Suite 300",
      officeCity: "Miami Beach",
      officeState: "FL",
      officeZip: "33139",
      pricingTier: "B",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-4",
    organizationName: "Tampa Bay Longevity",
    orgInfo: {
      officeName: "Tampa Bay Longevity",
      officeEmail: "support@tampalongevity.com",
      officePhone: "(813) 555-0234",
      officeAddress: "3450 Bayshore Blvd",
      officeCity: "Tampa",
      officeState: "FL",
      officeZip: "33611",
      pricingTier: "C",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-5",
    organizationName: "Orlando Vitality MD",
    orgInfo: {
      officeName: "Orlando Vitality MD",
      officeEmail: "rx@orlandovitality.com",
      officePhone: "(407) 555-0987",
      officeAddress: "12000 University Blvd",
      officeCity: "Orlando",
      officeState: "FL",
      officeZip: "32817",
      pricingTier: "C",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-6",
    organizationName: "Naples Anti-Aging Institute",
    orgInfo: {
      officeName: "Naples Anti-Aging Institute",
      officeEmail: "team@naplesaging.com",
      officePhone: "(239) 555-0345",
      officeAddress: "885 5th Ave S",
      officeCity: "Naples",
      officeState: "FL",
      officeZip: "34102",
      pricingTier: "D",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-7",
    organizationName: "Jacksonville Peptide Clinic",
    orgInfo: {
      officeName: "Jacksonville Peptide Clinic",
      officeEmail: "hello@jaxpeptide.com",
      officePhone: "(904) 555-0567",
      officeAddress: "9119 Beach Blvd",
      officeCity: "Jacksonville",
      officeState: "FL",
      officeZip: "32216",
      pricingTier: "C",
    },
    orders: [],
  },
  {
    organizationId: "demo-pep-provider-8",
    organizationName: "Boca Regenerative Health",
    orgInfo: {
      officeName: "Boca Regenerative Health",
      officeEmail: "orders@bocaregen.com",
      officePhone: "(561) 555-0789",
      officeAddress: "5550 Glades Rd, Suite 500",
      officeCity: "Boca Raton",
      officeState: "FL",
      officeZip: "33431",
      pricingTier: "B",
    },
    orders: [],
  },
];

// Tier assignment map (manufacturer-side) — providerOrgId → tier letter.
// Mirrors the pricingTier on each linked provider above.
export const demoPeptideProviderTiers = {
  "demo-pep-provider-1": "A",
  "demo-pep-provider-2": "B",
  "demo-pep-provider-3": "B",
  "demo-pep-provider-4": "C",
  "demo-pep-provider-5": "C",
  "demo-pep-provider-6": "D",
  "demo-pep-provider-7": "C",
  "demo-pep-provider-8": "B",
};

// Patient profiles for the peptide manufacturer/provider patient list.
// Format mirrors the shape returned by listClinicalProfiles (see
// usePeptidePricing.loadDefaultPatients).
export const demoPeptidePatients = [
  {
    id: "demo-pep-pt-1",
    firstName: "Maria",
    lastName: "Lopez",
    email: "maria.lopez.demo@example.com",
    phone: "(305) 555-1101",
    dob: "1985-04-12",
    address: "1500 SW 27th Ave",
    city: "Miami",
    state: "FL",
    zip: "33145",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Maria",
        lastName: "Lopez",
        dob: "1985-04-12",
        sex: "Female",
        email: "maria.lopez.demo@example.com",
        phone: "(305) 555-1101",
        heightFt: 5,
        heightIn: 4,
        weight: 148,
      },
      chief: {
        primaryComplaint: "Persistent brain fog and difficulty concentrating",
        severity: 6,
        onset: "18 months",
        concerns: [
          "Difficulty focusing at work",
          "Word-finding delays",
          "Afternoon energy crashes",
          "Mild weight gain despite no dietary changes",
        ],
      },
      pmh: {
        conditions: ["Hypothyroidism", "Polycystic ovary syndrome (PCOS)"],
      },
      medications: {
        list: [
          { name: "Levothyroxine", dose: "75 mcg", frequency: "Daily" },
          { name: "Metformin", dose: "500 mg", frequency: "Twice daily" },
          { name: "Vitamin D3", dose: "2000 IU", frequency: "Daily" },
        ],
      },
      allergies: {
        common: ["Penicillin"],
        custom: [{ allergen: "Ibuprofen", reaction: "Stomach ulcers" }],
      },
      surgical: {
        list: [{ procedure: "Laparoscopic ovarian cyst removal", year: 2016 }],
      },
      family: {
        list: [
          { relation: "Mother", condition: "Type 2 Diabetes" },
          { relation: "Father", condition: "Hypertension" },
          { relation: "Maternal grandmother", condition: "Alzheimer's disease", notes: "Onset age 72" },
        ],
      },
      social: {
        tobacco: "Never",
        alcohol: "Social — 2–3 drinks/week",
        substances: "None",
        exercise: "Yoga 2×/week, light walking",
        occupation: "Marketing Director",
      },
      ros: {
        systems: {
          General: ["Fatigue", "Mild weight gain"],
          Neurological: ["Brain fog", "Word-finding difficulties"],
          Endocrine: ["Temperature sensitivity", "Hair thinning"],
          Sleep: ["Non-restorative sleep", "Difficulty falling asleep"],
          GI: ["Bloating after meals"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-2",
    firstName: "Jonathan",
    lastName: "Reed",
    email: "j.reed.demo@example.com",
    phone: "(954) 555-1102",
    dob: "1978-09-30",
    address: "2200 N University Dr",
    city: "Pembroke Pines",
    state: "FL",
    zip: "33024",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Jonathan",
        lastName: "Reed",
        dob: "1978-09-30",
        sex: "Male",
        email: "j.reed.demo@example.com",
        phone: "(954) 555-1102",
        heightFt: 5,
        heightIn: 11,
        weight: 198,
      },
      chief: {
        primaryComplaint: "Low testosterone symptoms — fatigue, low libido, decreased muscle mass",
        severity: 7,
        onset: "2 years",
        concerns: [
          "Low energy and motivation",
          "Reduced sexual drive",
          "Loss of muscle despite regular gym attendance",
          "Increased belly fat",
          "Mood changes — irritability and low mood",
        ],
      },
      pmh: {
        conditions: ["Hyperlipidemia", "Mild hypertension"],
      },
      medications: {
        list: [
          { name: "Atorvastatin", dose: "20 mg", frequency: "Daily at bedtime" },
          { name: "Lisinopril", dose: "10 mg", frequency: "Daily" },
          { name: "Zinc", dose: "30 mg", frequency: "Daily" },
        ],
      },
      allergies: {
        none: true,
      },
      surgical: {
        list: [{ procedure: "Right knee arthroscopy (meniscal repair)", year: 2010 }],
      },
      family: {
        list: [
          { relation: "Father", condition: "Coronary artery disease", notes: "MI at age 58" },
          { relation: "Father", condition: "Type 2 Diabetes" },
          { relation: "Mother", condition: "Osteoporosis" },
          { relation: "Brother", condition: "Hypertension" },
        ],
      },
      social: {
        tobacco: "Former — quit 8 years ago",
        alcohol: "Moderate — 5–7 drinks/week",
        substances: "None",
        exercise: "Weight training 3×/week, occasional cycling",
        occupation: "Civil Engineer",
      },
      ros: {
        systems: {
          General: ["Fatigue", "Decreased stamina"],
          Endocrine: ["Low libido", "Decreased muscle mass", "Central weight gain"],
          Cardiovascular: ["Exertional dyspnea on vigorous activity"],
          Musculoskeletal: ["Mild right knee ache with heavy squats"],
          Sleep: ["Difficulty staying asleep", "Night sweats"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-3",
    firstName: "Aisha",
    lastName: "Patel",
    email: "a.patel.demo@example.com",
    phone: "(305) 555-1103",
    dob: "1990-12-15",
    address: "888 Brickell Ave, Apt 1402",
    city: "Miami",
    state: "FL",
    zip: "33131",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Aisha",
        lastName: "Patel",
        dob: "1990-12-15",
        sex: "Female",
        email: "a.patel.demo@example.com",
        phone: "(305) 555-1103",
        heightFt: 5,
        heightIn: 6,
        weight: 138,
      },
      chief: {
        primaryComplaint: "Slow recovery from training and minor joint pain",
        severity: 4,
        onset: "6 months",
        concerns: [
          "Prolonged muscle soreness after workouts (3–4 days)",
          "Mild left shoulder impingement",
          "Achilles tendon stiffness in the mornings",
          "Wants to optimize performance and longevity",
        ],
      },
      pmh: {
        conditions: ["Mild iron-deficiency anemia"],
      },
      medications: {
        list: [
          { name: "Ferrous sulfate", dose: "325 mg", frequency: "Every other day" },
          { name: "Oral contraceptive (Lo Loestrin Fe)", dose: "1 tablet", frequency: "Daily" },
          { name: "Magnesium glycinate", dose: "400 mg", frequency: "Nightly" },
          { name: "Omega-3 fish oil", dose: "2 g", frequency: "Daily" },
        ],
      },
      allergies: {
        common: ["Sulfonamides"],
        custom: [],
      },
      surgical: {
        none: true,
      },
      family: {
        list: [
          { relation: "Mother", condition: "Hypothyroidism" },
          { relation: "Paternal uncle", condition: "Type 2 Diabetes" },
        ],
      },
      social: {
        tobacco: "Never",
        alcohol: "Rare — less than 2 drinks/month",
        substances: "None",
        exercise: "CrossFit 5×/week, weekend trail running",
        occupation: "Physical Therapist",
      },
      ros: {
        systems: {
          Musculoskeletal: ["Left shoulder impingement", "Achilles tendon stiffness", "Prolonged DOMS"],
          General: ["Fatigue late in training cycles"],
          GI: ["Occasional GI upset with high-intensity exercise"],
          Skin: ["Slow healing of minor skin abrasions"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-4",
    firstName: "David",
    lastName: "Kim",
    email: "d.kim.demo@example.com",
    phone: "(813) 555-1104",
    dob: "1982-07-04",
    address: "4400 W Kennedy Blvd",
    city: "Tampa",
    state: "FL",
    zip: "33609",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "David",
        lastName: "Kim",
        dob: "1982-07-04",
        sex: "Male",
        email: "d.kim.demo@example.com",
        phone: "(813) 555-1104",
        heightFt: 5,
        heightIn: 9,
        weight: 182,
      },
      chief: {
        primaryComplaint: "Chronic fatigue despite adequate sleep",
        severity: 7,
        onset: "3 years",
        concerns: [
          "Persistent daytime fatigue even after 7–8 hours of sleep",
          "Difficulty concentrating at work",
          "Unrefreshing sleep — wakes up tired",
          "Low motivation and anhedonia",
          "Muscle aches without physical exertion",
        ],
      },
      pmh: {
        conditions: ["Obstructive sleep apnea (on CPAP)", "Mild depression (in remission)"],
      },
      medications: {
        list: [
          { name: "CPAP therapy", dose: "8–10 cmH2O", frequency: "Nightly" },
          { name: "Sertraline", dose: "50 mg", frequency: "Daily" },
          { name: "Vitamin B12", dose: "1000 mcg", frequency: "Daily" },
          { name: "CoQ10", dose: "200 mg", frequency: "Daily" },
        ],
      },
      allergies: {
        common: [],
        custom: [{ allergen: "Codeine", reaction: "Nausea and dysphoria" }],
      },
      surgical: {
        list: [{ procedure: "Tonsillectomy", year: 1995 }],
      },
      family: {
        list: [
          { relation: "Father", condition: "Obstructive sleep apnea" },
          { relation: "Mother", condition: "Fibromyalgia" },
          { relation: "Paternal grandfather", condition: "Colorectal cancer", notes: "Onset age 65" },
        ],
      },
      social: {
        tobacco: "Never",
        alcohol: "Light — 1–2 drinks/week",
        substances: "None",
        exercise: "Walks 20 min/day; sedentary otherwise",
        occupation: "Software Engineer (remote)",
      },
      ros: {
        systems: {
          General: ["Chronic fatigue", "Muscle aches", "Low motivation"],
          Sleep: ["Unrefreshing sleep", "Residual somnolence despite CPAP"],
          Neurological: ["Poor concentration", "Brain fog"],
          Cardiovascular: ["Palpitations occasionally"],
          GI: ["Constipation — 2–3 times/week"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-5",
    firstName: "Sophia",
    lastName: "Garcia",
    email: "s.garcia.demo@example.com",
    phone: "(407) 555-1105",
    dob: "1995-03-22",
    address: "1300 E Colonial Dr",
    city: "Orlando",
    state: "FL",
    zip: "32803",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Sophia",
        lastName: "Garcia",
        dob: "1995-03-22",
        sex: "Female",
        email: "s.garcia.demo@example.com",
        phone: "(407) 555-1105",
        heightFt: 5,
        heightIn: 5,
        weight: 122,
      },
      chief: {
        primaryComplaint: "Hair thinning and dull skin",
        severity: 5,
        onset: "1 year",
        concerns: [
          "Noticeable hair shedding — pillow and shower drain",
          "Loss of hair shine and texture",
          "Skin appears dull, dry, and less elastic",
          "Fine lines developing around eyes",
          "Interested in aesthetic and anti-aging peptides",
        ],
      },
      pmh: {
        conditions: ["Mild acne vulgaris"],
      },
      medications: {
        list: [
          { name: "Spironolactone", dose: "50 mg", frequency: "Daily" },
          { name: "Tretinoin 0.025%", dose: "pea-sized amount", frequency: "Nightly" },
          { name: "Biotin", dose: "5000 mcg", frequency: "Daily" },
          { name: "Collagen peptides powder", dose: "10 g", frequency: "Daily in smoothie" },
        ],
      },
      allergies: {
        none: true,
      },
      surgical: {
        none: true,
      },
      family: {
        list: [
          { relation: "Mother", condition: "Androgenetic alopecia" },
          { relation: "Maternal aunt", condition: "Systemic lupus erythematosus" },
        ],
      },
      social: {
        tobacco: "Never",
        alcohol: "Social — 3–5 drinks/week",
        substances: "None",
        exercise: "Pilates 3×/week, barre class once/week",
        occupation: "Graphic Designer",
      },
      ros: {
        systems: {
          Skin: ["Hair thinning", "Dry skin", "Dull complexion", "Fine lines periorbital"],
          General: ["Mild fatigue in afternoons"],
          Endocrine: ["Irregular periods — 35–40 day cycles"],
          Neurological: ["Occasional tension headaches"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-6",
    firstName: "Marcus",
    lastName: "Thompson",
    email: "m.thompson.demo@example.com",
    phone: "(561) 555-1106",
    dob: "1972-11-08",
    address: "3300 Federal Hwy",
    city: "Boca Raton",
    state: "FL",
    zip: "33431",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Marcus",
        lastName: "Thompson",
        dob: "1972-11-08",
        sex: "Male",
        email: "m.thompson.demo@example.com",
        phone: "(561) 555-1106",
        heightFt: 6,
        heightIn: 1,
        weight: 218,
      },
      chief: {
        primaryComplaint: "Knee and shoulder pain limiting activity",
        severity: 6,
        onset: "4 years, progressively worsening",
        concerns: [
          "Right knee pain with stairs and prolonged walking",
          "Left shoulder ache with overhead movements",
          "Joint stiffness in the mornings lasting ~30 minutes",
          "Interested in longevity and staying active into his 60s",
        ],
      },
      pmh: {
        conditions: [
          "Osteoarthritis — bilateral knees, early stage",
          "Hypertension",
          "Hyperlipidemia",
          "Gout (last flare 2 years ago)",
        ],
      },
      medications: {
        list: [
          { name: "Amlodipine", dose: "5 mg", frequency: "Daily" },
          { name: "Atorvastatin", dose: "40 mg", frequency: "Daily at bedtime" },
          { name: "Allopurinol", dose: "300 mg", frequency: "Daily" },
          { name: "Naproxen", dose: "220 mg", frequency: "As needed for joint pain" },
          { name: "Glucosamine/Chondroitin", dose: "1500/1200 mg", frequency: "Daily" },
        ],
      },
      allergies: {
        common: ["Aspirin"],
        custom: [{ allergen: "Shellfish", reaction: "Hives and throat tightening" }],
      },
      surgical: {
        list: [
          { procedure: "Right knee partial meniscectomy", year: 2005 },
          { procedure: "Left shoulder rotator cuff repair", year: 2019 },
          { procedure: "Appendectomy", year: 1991 },
        ],
      },
      family: {
        list: [
          { relation: "Father", condition: "Osteoarthritis" },
          { relation: "Father", condition: "Prostate cancer", notes: "Diagnosed age 69, treated successfully" },
          { relation: "Mother", condition: "Hypertension" },
          { relation: "Mother", condition: "Type 2 Diabetes" },
          { relation: "Paternal grandfather", condition: "Coronary artery disease", notes: "Fatal MI at 71" },
        ],
      },
      social: {
        tobacco: "Former — quit 15 years ago (10 pack-year history)",
        alcohol: "Moderate — 4–6 drinks/week",
        substances: "None",
        exercise: "Swimming 2×/week; golf on weekends",
        occupation: "Orthopedic Surgeon (semi-retired, part-time consulting)",
      },
      ros: {
        systems: {
          Musculoskeletal: ["Bilateral knee pain", "Left shoulder impingement", "Morning stiffness"],
          General: ["Mild fatigue", "Weight gain over past 5 years"],
          Cardiovascular: ["Controlled hypertension", "Occasional mild exertional dyspnea"],
          GI: ["Mild GERD with NSAIDs"],
          Sleep: ["Difficulty staying asleep due to joint discomfort"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-7",
    firstName: "Isabella",
    lastName: "Rossi",
    email: "i.rossi.demo@example.com",
    phone: "(305) 555-1107",
    dob: "1988-05-19",
    address: "1455 Ocean Dr",
    city: "Miami Beach",
    state: "FL",
    zip: "33139",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Isabella",
        lastName: "Rossi",
        dob: "1988-05-19",
        sex: "Female",
        email: "i.rossi.demo@example.com",
        phone: "(305) 555-1107",
        heightFt: 5,
        heightIn: 7,
        weight: 132,
      },
      chief: {
        primaryComplaint: "Insomnia and high stress",
        severity: 7,
        onset: "2 years (worsened after job promotion)",
        concerns: [
          "Takes 1–2 hours to fall asleep",
          "Wakes 2–3 times per night",
          "High-stress work environment — feels chronically overwhelmed",
          "Heart racing at night",
          "Anxious rumination when trying to sleep",
        ],
      },
      pmh: {
        conditions: ["Generalized anxiety disorder (GAD)", "Migraine with aura"],
      },
      medications: {
        list: [
          { name: "Escitalopram", dose: "10 mg", frequency: "Daily" },
          { name: "Sumatriptan", dose: "50 mg", frequency: "As needed for migraines" },
          { name: "Melatonin", dose: "0.5 mg", frequency: "Nightly" },
          { name: "Magnesium threonate", dose: "2000 mg", frequency: "Nightly" },
        ],
      },
      allergies: {
        common: ["Latex"],
        custom: [],
      },
      surgical: {
        list: [{ procedure: "Wisdom tooth extraction (×4)", year: 2011 }],
      },
      family: {
        list: [
          { relation: "Mother", condition: "Generalized anxiety disorder" },
          { relation: "Father", condition: "Migraine disorder" },
          { relation: "Paternal grandmother", condition: "Parkinson's disease", notes: "Onset age 75" },
        ],
      },
      social: {
        tobacco: "Never",
        alcohol: "Light — 1–2 drinks/week, avoids near bedtime",
        substances: "Occasional CBD gummies for sleep",
        exercise: "Hot yoga 2×/week; struggles to maintain routine due to fatigue",
        occupation: "Corporate Attorney",
      },
      ros: {
        systems: {
          Sleep: ["Sleep onset insomnia", "Nocturnal awakenings", "Unrefreshing sleep"],
          Neurological: ["Migraine 1–2×/month", "Anxious rumination", "Cognitive fatigue"],
          Cardiovascular: ["Palpitations at night — evaluated, benign"],
          General: ["Low energy", "Stress-related tension headaches"],
          GI: ["Appetite fluctuates with stress", "IBS-like symptoms during high-stress periods"],
        },
      },
    },
  },
  {
    id: "demo-pep-pt-8",
    firstName: "Robert",
    lastName: "Chen",
    email: "r.chen.demo@example.com",
    phone: "(904) 555-1108",
    dob: "1965-01-25",
    address: "1234 Atlantic Blvd",
    city: "Jacksonville",
    state: "FL",
    zip: "32207",
    source: "clinical-profile",
    clinicalProfile: {
      demographics: {
        firstName: "Robert",
        lastName: "Chen",
        dob: "1965-01-25",
        sex: "Male",
        email: "r.chen.demo@example.com",
        phone: "(904) 555-1108",
        heightFt: 5,
        heightIn: 10,
        weight: 204,
      },
      chief: {
        primaryComplaint: "General longevity and cognitive optimization goals",
        severity: 4,
        onset: "Gradual over 5 years",
        concerns: [
          "Slower recall and processing speed compared to 10 years ago",
          "Reduced physical stamina and recovery",
          "Wants to maintain sharpness and vitality into his 70s",
          "Interested in peptide protocols for longevity",
          "Mild erectile dysfunction",
        ],
      },
      pmh: {
        conditions: [
          "Type 2 Diabetes Mellitus (well-controlled)",
          "Hyperlipidemia",
          "Benign prostatic hyperplasia (BPH)",
          "Mild cognitive changes (subjective — no formal diagnosis)",
        ],
      },
      medications: {
        list: [
          { name: "Metformin", dose: "1000 mg", frequency: "Twice daily with meals" },
          { name: "Atorvastatin", dose: "40 mg", frequency: "Daily at bedtime" },
          { name: "Tamsulosin", dose: "0.4 mg", frequency: "Daily" },
          { name: "Low-dose aspirin", dose: "81 mg", frequency: "Daily" },
          { name: "Vitamin D3", dose: "5000 IU", frequency: "Daily" },
          { name: "Omega-3 fish oil", dose: "2 g", frequency: "Daily" },
        ],
      },
      allergies: {
        common: ["Amoxicillin"],
        custom: [{ allergen: "Contrast dye (iodine-based)", reaction: "Flushing and hives — premedicated for procedures" }],
      },
      surgical: {
        list: [
          { procedure: "Coronary angiography (diagnostic, no intervention)", year: 2018 },
          { procedure: "Right inguinal hernia repair", year: 2009 },
          { procedure: "Cholecystectomy (laparoscopic)", year: 2002 },
        ],
      },
      family: {
        list: [
          { relation: "Father", condition: "Type 2 Diabetes" },
          { relation: "Father", condition: "Coronary artery disease", notes: "CABG at age 67" },
          { relation: "Mother", condition: "Alzheimer's disease", notes: "Onset age 78" },
          { relation: "Mother", condition: "Hypertension" },
          { relation: "Sister", condition: "Breast cancer", notes: "BRCA negative, stage II — in remission" },
          { relation: "Paternal uncle", condition: "Stroke", notes: "Age 70" },
        ],
      },
      social: {
        tobacco: "Former — quit 20 years ago (15 pack-year history)",
        alcohol: "Light — 2–3 drinks/week",
        substances: "None",
        exercise: "Walks 30 min daily; retired from tennis due to knee pain",
        occupation: "Retired Cardiologist (now medical consultant)",
      },
      ros: {
        systems: {
          Neurological: ["Subjective memory slowing", "Word retrieval delay", "Mild processing speed reduction"],
          General: ["Reduced stamina", "Slower recovery from mild illness"],
          Cardiovascular: ["Well-controlled, no angina or syncope"],
          Endocrine: ["Nocturia 1–2×/night", "Erectile dysfunction — mild"],
          Musculoskeletal: ["Bilateral knee stiffness with prolonged sitting", "Mild lower back pain"],
          Sleep: ["Wakes once to use restroom", "Overall sleep quality fair"],
        },
      },
    },
  },
];

// Peptide orders distributed across kanban states. 30 orders spanning
// the last 6 months so analytics charts have density. Status keys
// match those used in PeptideOrders / PeptideKanbanColumn.
//
// Helper: ISO date N days ago (resolved at module load).
const _peptideDaysAgo = (n) => {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString();
};

// Helper: ISO date N hours ago (resolved at module load). Used to seed
// recent activity so the Recent Activity drawer's 24h window has events
// to display in demo mode.
const _peptideHoursAgo = (n) => {
  const d = new Date();
  d.setHours(d.getHours() - n);
  return d.toISOString();
};

export const demoPeptideOrders = [
  // ── DRAFT (manufacturer-created drafts awaiting provider review) ──
  {
    id: "demo-pep-order-1",
    organizationId: "demo-pep-provider-1",
    organizationName: "Coral Gables Wellness Clinic",
    patientId: "demo-pep-pt-1",
    patientFirstName: "Maria",
    patientLastName: "Lopez",
    patientEmail: "maria.lopez.demo@example.com",
    patientPhone: "(305) 555-1101",
    shippingAddress: "2401 Ponce de Leon Blvd, Coral Gables, FL 33134",
    lineItems: [
      {
        variantId: "bpc-157-10mg",
        productName: "BPC 157",
        size: "10MG",
        quantity: 2,
        unitPriceCents: 4000,
        lineTotalCents: 8000,
      },
    ],
    subtotalCents: 8000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 8000,
    paymentMethod: null,
    status: "draft",
    tier: "A",
    createdAt: _peptideHoursAgo(20),
    updatedAt: _peptideHoursAgo(20),
    statusHistory: [{ status: "draft", date: _peptideHoursAgo(20) }],
  },
  {
    id: "demo-pep-order-2",
    organizationId: "demo-pep-provider-3",
    organizationName: "South Beach Performance Medicine",
    patientId: "demo-pep-pt-7",
    patientFirstName: "Isabella",
    patientLastName: "Rossi",
    patientEmail: "i.rossi.demo@example.com",
    patientPhone: "(305) 555-1107",
    shippingAddress: "1100 Lincoln Rd, Suite 300, Miami Beach, FL 33139",
    lineItems: [
      {
        variantId: "tirz-glp-2-10mg",
        productName: "Tirz GLP-2",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 58000,
        lineTotalCents: 58000,
      },
    ],
    subtotalCents: 58000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 58000,
    paymentMethod: null,
    status: "denied",
    tier: "B",
    providerDeniedReason: "Patient currently on contraindicated medication (warfarin).",
    createdAt: _peptideDaysAgo(3),
    updatedAt: _peptideHoursAgo(4),
    statusHistory: [
      { status: "draft", date: _peptideDaysAgo(3) },
      { status: "submitted", date: _peptideDaysAgo(2) },
      { status: "denied", date: _peptideHoursAgo(4) },
    ],
  },

  // ── PAYMENT_AUTHORIZED (patient-placed, awaiting provider approval) ──
  // New pay-at-submit model: the patient checks out, Stripe authorizes (holds)
  // the charge, and the order waits in the provider's review queue. Approving
  // captures the hold (→ confirmed) and pushes it into manufacturer fulfillment;
  // denying voids the hold (→ denied) and refunds. These two drive the
  // PeptideDraftOrderReview flow end to end in demo mode.
  {
    id: "demo-pep-order-patient-1",
    organizationId: "demo-pep-provider-1",
    organizationName: "Coral Gables Wellness Clinic",
    patientId: "demo-pep-pt-1",
    patientFirstName: "Maria",
    patientLastName: "Lopez",
    patientEmail: "maria.lopez.demo@example.com",
    patientPhone: "(305) 555-1101",
    shippingAddress: "2401 Ponce de Leon Blvd, Coral Gables, FL 33134",
    lineItems: [
      {
        variantId: "bpc-157-10mg",
        productName: "BPC 157",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 12000,
        lineTotalCents: 12000,
      },
    ],
    subtotalCents: 12000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 12000,
    paymentMethod: "card",
    status: "payment_authorized",
    placedByPatient: true,
    source: "patient",
    assignType: "patient",
    assignedProviderId: "demo-pep-provider-1",
    referringProviderName: "Coral Gables Wellness Clinic",
    tier: "W",
    authorizedAt: _peptideHoursAgo(6),
    createdAt: _peptideHoursAgo(6),
    updatedAt: _peptideHoursAgo(6),
    statusHistory: [
      { status: "submitted", date: _peptideHoursAgo(6) },
      { status: "payment_authorized", date: _peptideHoursAgo(6) },
    ],
  },
  {
    id: "demo-pep-order-patient-2",
    organizationId: "demo-pep-provider-2",
    organizationName: "Sunrise Hormone Center",
    patientId: "demo-pep-pt-9",
    patientFirstName: "Daniel",
    patientLastName: "Okafor",
    patientEmail: "d.okafor.demo@example.com",
    patientPhone: "(954) 555-1109",
    shippingAddress: "8970 W Oakland Park Blvd, Sunrise, FL 33351",
    lineItems: [
      {
        variantId: "sema-glp-1-5mg",
        productName: "Sema GLP-1",
        size: "5MG",
        quantity: 2,
        unitPriceCents: 39000,
        lineTotalCents: 78000,
      },
      {
        variantId: "glutathione-200mg-ml-30ml",
        productName: "Glutathione",
        size: "200MG/ML",
        quantity: 1,
        unitPriceCents: 4500,
        lineTotalCents: 4500,
      },
    ],
    subtotalCents: 82500,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 82500,
    paymentMethod: "card",
    status: "payment_authorized",
    placedByPatient: true,
    source: "patient",
    assignType: "patient",
    assignedProviderId: "demo-pep-provider-2",
    referringProviderName: "Sunrise Hormone Center",
    tier: "W",
    authorizedAt: _peptideHoursAgo(30),
    createdAt: _peptideHoursAgo(30),
    updatedAt: _peptideHoursAgo(30),
    statusHistory: [
      { status: "submitted", date: _peptideHoursAgo(30) },
      { status: "payment_authorized", date: _peptideHoursAgo(30) },
    ],
    comments: [
      {
        creatorLabel: "Daniel Okafor",
        comment: "First time ordering — let me know if you need anything from me.",
        date: _peptideHoursAgo(29),
        from: "patient",
      },
    ],
  },

  // ── SUBMITTED ──
  {
    id: "demo-pep-order-3",
    organizationId: "demo-pep-provider-2",
    organizationName: "Sunrise Hormone Center",
    patientId: "demo-pep-pt-2",
    patientFirstName: "Jonathan",
    patientLastName: "Reed",
    patientEmail: "j.reed.demo@example.com",
    patientPhone: "(954) 555-1102",
    shippingAddress: "8970 W Oakland Park Blvd, Sunrise, FL 33351",
    lineItems: [
      {
        variantId: "sema-glp-1-5mg",
        productName: "Sema GLP-1",
        size: "5MG",
        quantity: 3,
        unitPriceCents: 25000,
        lineTotalCents: 75000,
      },
      {
        variantId: "glutathione-200mg-ml-30ml",
        productName: "Glutathione",
        size: "200MG/ML",
        quantity: 2,
        unitPriceCents: 3000,
        lineTotalCents: 6000,
      },
    ],
    subtotalCents: 81000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 81000,
    paymentMethod: "card",
    status: "submitted",
    tier: "B",
    createdAt: _peptideHoursAgo(20),
    updatedAt: _peptideHoursAgo(3),
    statusHistory: [
      { status: "draft", date: _peptideHoursAgo(20) },
      { status: "submitted", date: _peptideHoursAgo(3) },
    ],
    comments: [
      {
        creatorLabel: "Karen Patel",
        comment: "Could you confirm the loading-dose schedule for the Sema?",
        date: _peptideHoursAgo(2),
        from: "manufacturer",
      },
    ],
  },
  {
    id: "demo-pep-order-4",
    organizationId: "demo-pep-provider-5",
    organizationName: "Orlando Vitality MD",
    patientId: "demo-pep-pt-5",
    patientFirstName: "Sophia",
    patientLastName: "Garcia",
    patientEmail: "s.garcia.demo@example.com",
    patientPhone: "(407) 555-1105",
    shippingAddress: "12000 University Blvd, Orlando, FL 32817",
    lineItems: [
      {
        variantId: "sermorelin-10mg",
        productName: "Sermorelin",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 15000,
        lineTotalCents: 15000,
      },
    ],
    subtotalCents: 15000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 15000,
    paymentMethod: "zelle",
    status: "payment_pending",
    tier: "C",
    paymentReceiptFile: "demo-receipt-zelle-001.pdf",
    createdAt: _peptideDaysAgo(2),
    updatedAt: _peptideHoursAgo(1),
    statusHistory: [
      { status: "draft", date: _peptideDaysAgo(2) },
      { status: "submitted", date: _peptideDaysAgo(2) },
      { status: "payment_pending", date: _peptideHoursAgo(8) },
    ],
    comments: [
      {
        creatorLabel: "Dr. Alvarez",
        comment: "Receipt attached — Zelle confirmation 8417.",
        date: _peptideHoursAgo(7),
        from: "provider",
      },
      {
        creatorLabel: "Karen Patel",
        comment: "Thanks, processing now.",
        date: _peptideHoursAgo(1),
        from: "manufacturer",
      },
    ],
  },

  // ── PAYMENT_PENDING ──
  {
    id: "demo-pep-order-5",
    organizationId: "demo-pep-provider-4",
    organizationName: "Tampa Bay Longevity",
    patientId: "demo-pep-pt-4",
    patientFirstName: "David",
    patientLastName: "Kim",
    patientEmail: "d.kim.demo@example.com",
    patientPhone: "(813) 555-1104",
    shippingAddress: "4400 W Kennedy Blvd, Tampa, FL 33609",
    lineItems: [
      {
        variantId: "nad-plus-500mg",
        productName: "NAD+",
        size: "500MG",
        quantity: 1,
        unitPriceCents: 34000,
        lineTotalCents: 34000,
      },
    ],
    subtotalCents: 34000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 34000,
    paymentMethod: "zelle",
    status: "payment_pending",
    tier: "C",
    paymentReceiptFile: "demo-receipt-zelle-005.pdf",
    createdAt: _peptideDaysAgo(4),
    updatedAt: _peptideDaysAgo(3),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(4) },
      { status: "payment_pending", date: _peptideDaysAgo(3) },
    ],
  },

  // ── CONFIRMED ──
  {
    id: "demo-pep-order-6",
    organizationId: "demo-pep-provider-1",
    organizationName: "Coral Gables Wellness Clinic",
    patientId: "demo-pep-pt-3",
    patientFirstName: "Aisha",
    patientLastName: "Patel",
    patientEmail: "a.patel.demo@example.com",
    patientPhone: "(305) 555-1103",
    shippingAddress: "888 Brickell Ave, Apt 1402, Miami, FL 33131",
    lineItems: [
      {
        variantId: "bpc-157-10mg",
        productName: "BPC 157",
        size: "10MG",
        quantity: 2,
        unitPriceCents: 7000,
        lineTotalCents: 14000,
      },
      {
        variantId: "tb-500-10mg",
        productName: "TB 500",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 8000,
        lineTotalCents: 8000,
      },
    ],
    subtotalCents: 22000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 22000,
    paymentMethod: "card",
    status: "confirmed",
    tier: "A",
    createdAt: _peptideDaysAgo(5),
    updatedAt: _peptideHoursAgo(2),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(5) },
      { status: "confirmed", date: _peptideDaysAgo(4) },
    ],
    comments: [
      {
        creatorLabel: "Avery Singh",
        comment: "Dr. Rachel, do you want to ship this Friday or hold for the recurring batch?",
        date: _peptideHoursAgo(2),
        from: "manufacturer",
      },
    ],
  },
  {
    id: "demo-pep-order-7",
    organizationId: "demo-pep-provider-6",
    organizationName: "Naples Anti-Aging Institute",
    patientId: "demo-pep-pt-6",
    patientFirstName: "Marcus",
    patientLastName: "Thompson",
    patientEmail: "m.thompson.demo@example.com",
    patientPhone: "(561) 555-1106",
    shippingAddress: "885 5th Ave S, Naples, FL 34102",
    lineItems: [
      {
        variantId: "sema-glp-1-10mg",
        productName: "Sema GLP-1",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 62000,
        lineTotalCents: 62000,
      },
    ],
    subtotalCents: 62000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 62000,
    paymentMethod: "card",
    status: "confirmed",
    tier: "D",
    createdAt: _peptideDaysAgo(7),
    updatedAt: _peptideHoursAgo(2),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(7) },
      { status: "confirmed", date: _peptideDaysAgo(6) },
    ],
    comments: [
      {
        creatorLabel: "Dr. Rachel Adler",
        comment: "Avery — please prioritize this one, patient is traveling Friday.",
        date: _peptideHoursAgo(2),
        from: "provider",
      },
    ],
  },

  // ── FULFILLED (manufacturer fulfilled, awaiting ship) ──
  {
    id: "demo-pep-order-8",
    organizationId: "demo-pep-provider-3",
    organizationName: "South Beach Performance Medicine",
    patientId: "demo-pep-pt-7",
    patientFirstName: "Isabella",
    patientLastName: "Rossi",
    patientEmail: "i.rossi.demo@example.com",
    patientPhone: "(305) 555-1107",
    shippingAddress: "1100 Lincoln Rd, Suite 300, Miami Beach, FL 33139",
    lineItems: [
      {
        variantId: "cjc-1295-10mg",
        productName: "CJC 1295",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 9000,
        lineTotalCents: 9000,
      },
      {
        variantId: "ipamorelin-10mg",
        productName: "Ipamorelin",
        size: "10MG",
        quantity: 2,
        unitPriceCents: 4000,
        lineTotalCents: 8000,
      },
    ],
    subtotalCents: 17000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 17000,
    paymentMethod: "card",
    status: "fulfilled",
    tier: "B",
    createdAt: _peptideDaysAgo(10),
    updatedAt: _peptideDaysAgo(8),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(10) },
      { status: "confirmed", date: _peptideDaysAgo(9) },
      { status: "fulfilled", date: _peptideDaysAgo(8) },
    ],
  },

  // ── SHIPPED (with tracking) ──
  {
    id: "demo-pep-order-9",
    organizationId: "demo-pep-provider-1",
    organizationName: "Coral Gables Wellness Clinic",
    patientId: "demo-pep-pt-1",
    patientFirstName: "Maria",
    patientLastName: "Lopez",
    patientEmail: "maria.lopez.demo@example.com",
    patientPhone: "(305) 555-1101",
    shippingAddress: "2401 Ponce de Leon Blvd, Coral Gables, FL 33134",
    lineItems: [
      {
        variantId: "tirz-glp-2-10mg",
        productName: "Tirz GLP-2",
        size: "10MG",
        quantity: 2,
        unitPriceCents: 30000,
        lineTotalCents: 60000,
      },
    ],
    subtotalCents: 60000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 60000,
    paymentMethod: "card",
    status: "shipped",
    tier: "A",
    carrier: "FedEx",
    trackingNumber: "771234567890",
    createdAt: _peptideDaysAgo(14),
    updatedAt: _peptideHoursAgo(5),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(14) },
      { status: "confirmed", date: _peptideDaysAgo(13) },
      { status: "fulfilled", date: _peptideDaysAgo(12) },
      { status: "shipped", date: _peptideHoursAgo(5) },
    ],
  },
  {
    id: "demo-pep-order-10",
    organizationId: "demo-pep-provider-2",
    organizationName: "Sunrise Hormone Center",
    patientId: "demo-pep-pt-2",
    patientFirstName: "Jonathan",
    patientLastName: "Reed",
    patientEmail: "j.reed.demo@example.com",
    patientPhone: "(954) 555-1102",
    shippingAddress: "8970 W Oakland Park Blvd, Sunrise, FL 33351",
    lineItems: [
      {
        variantId: "tesamorelin-10mg",
        productName: "Tesamorelin",
        size: "10MG",
        quantity: 1,
        unitPriceCents: 10500,
        lineTotalCents: 10500,
      },
    ],
    subtotalCents: 10500,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 10500,
    paymentMethod: "card",
    status: "shipped",
    tier: "B",
    carrier: "UPS",
    trackingNumber: "1Z-9X8-7654-321-09",
    createdAt: _peptideDaysAgo(18),
    updatedAt: _peptideDaysAgo(15),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(18) },
      { status: "confirmed", date: _peptideDaysAgo(17) },
      { status: "fulfilled", date: _peptideDaysAgo(16) },
      { status: "shipped", date: _peptideDaysAgo(15) },
    ],
  },

  // ── DELIVERED ──
  ...["demo-pep-order-11", "demo-pep-order-12", "demo-pep-order-13", "demo-pep-order-14", "demo-pep-order-15"].map((id, i) => {
    const providers = [
      { id: "demo-pep-provider-1", name: "Coral Gables Wellness Clinic", tier: "A" },
      { id: "demo-pep-provider-4", name: "Tampa Bay Longevity", tier: "C" },
      { id: "demo-pep-provider-7", name: "Jacksonville Peptide Clinic", tier: "C" },
      { id: "demo-pep-provider-8", name: "Boca Regenerative Health", tier: "B" },
      { id: "demo-pep-provider-5", name: "Orlando Vitality MD", tier: "C" },
    ][i];
    const patient = ["demo-pep-pt-3", "demo-pep-pt-4", "demo-pep-pt-8", "demo-pep-pt-6", "demo-pep-pt-5"][i];
    const lineSets = [
      [
        {
          variantId: "ghk-cu-100mg",
          productName: "GHK-CU",
          size: "100MG",
          quantity: 1,
          unitPriceCents: 5500,
          lineTotalCents: 5500,
        },
      ],
      [
        {
          variantId: "mots-c-10mg",
          productName: "MOTS-C",
          size: "10MG",
          quantity: 2,
          unitPriceCents: 10500,
          lineTotalCents: 21000,
        },
      ],
      [
        {
          variantId: "aod-9604-5mg",
          productName: "AOD 9604",
          size: "5MG",
          quantity: 3,
          unitPriceCents: 5500,
          lineTotalCents: 16500,
        },
      ],
      [
        {
          variantId: "epithalon-50mg",
          productName: "Epithalon",
          size: "50MG",
          quantity: 1,
          unitPriceCents: 5000,
          lineTotalCents: 5000,
        },
      ],
      [
        {
          variantId: "pt-141-10mg",
          productName: "PT-141",
          size: "10MG",
          quantity: 1,
          unitPriceCents: 4500,
          lineTotalCents: 4500,
        },
      ],
    ][i];
    const total = lineSets.reduce((s, l) => s + l.lineTotalCents, 0);
    const placedDays = 30 + i * 8;
    return {
      id,
      organizationId: providers.id,
      organizationName: providers.name,
      patientId: patient,
      patientFirstName: "Demo",
      patientLastName: "Patient",
      patientEmail: "demo@example.com",
      patientPhone: "(305) 555-0000",
      shippingAddress: "Demo Address, FL 33000",
      lineItems: lineSets,
      subtotalCents: total,
      shippingCents: 0,
      taxCents: 0,
      totalCents: total,
      paymentMethod: "card",
      status: "delivered",
      tier: providers.tier,
      carrier: "USPS",
      trackingNumber: `9400-1000-${1000 + i}-0000`,
      createdAt: _peptideDaysAgo(placedDays + 7),
      updatedAt: _peptideDaysAgo(placedDays),
      statusHistory: [
        { status: "submitted", date: _peptideDaysAgo(placedDays + 7) },
        { status: "confirmed", date: _peptideDaysAgo(placedDays + 5) },
        { status: "fulfilled", date: _peptideDaysAgo(placedDays + 3) },
        { status: "shipped", date: _peptideDaysAgo(placedDays + 2) },
        { status: "delivered", date: _peptideDaysAgo(placedDays) },
      ],
    };
  }),

  // ── CANCELLED ──
  {
    id: "demo-pep-order-16",
    organizationId: "demo-pep-provider-6",
    organizationName: "Naples Anti-Aging Institute",
    patientId: "demo-pep-pt-6",
    patientFirstName: "Marcus",
    patientLastName: "Thompson",
    patientEmail: "m.thompson.demo@example.com",
    patientPhone: "(561) 555-1106",
    shippingAddress: "885 5th Ave S, Naples, FL 34102",
    lineItems: [
      {
        variantId: "tirz-glp-2-20mg",
        productName: "Tirz GLP-2",
        size: "20MG",
        quantity: 1,
        unitPriceCents: 142000,
        lineTotalCents: 142000,
      },
    ],
    subtotalCents: 142000,
    shippingCents: 0,
    taxCents: 0,
    totalCents: 142000,
    paymentMethod: "card",
    status: "cancelled",
    tier: "D",
    cancelReason: "Patient changed insurance plan",
    createdAt: _peptideDaysAgo(20),
    updatedAt: _peptideHoursAgo(5),
    statusHistory: [
      { status: "submitted", date: _peptideDaysAgo(20) },
      { status: "cancelled", date: _peptideHoursAgo(5) },
    ],
  },

  // ── HISTORICAL deliveries to give analytics 6 months of density ──
  ...Array.from({ length: 14 }).map((_, i) => {
    const providers = [
      "demo-pep-provider-1",
      "demo-pep-provider-2",
      "demo-pep-provider-3",
      "demo-pep-provider-4",
      "demo-pep-provider-5",
      "demo-pep-provider-6",
      "demo-pep-provider-7",
      "demo-pep-provider-8",
    ];
    const tiers = ["A", "B", "B", "C", "C", "D", "C", "B"];
    const pIdx = i % providers.length;
    const variants = [
      { variantId: "bpc-157-10mg", productName: "BPC 157", size: "10MG", price: 4000 },
      { variantId: "sema-glp-1-5mg", productName: "Sema GLP-1", size: "5MG", price: 25000 },
      { variantId: "tirz-glp-2-10mg", productName: "Tirz GLP-2", size: "10MG", price: 58000 },
      { variantId: "cjc-1295-10mg", productName: "CJC 1295", size: "10MG", price: 9000 },
      { variantId: "ghk-cu-100mg", productName: "GHK-CU", size: "100MG", price: 5500 },
      { variantId: "glutathione-200mg-ml-30ml", productName: "Glutathione", size: "200MG/ML", price: 7500 },
      { variantId: "nad-plus-500mg", productName: "NAD+", size: "500MG", price: 34000 },
    ];
    const v = variants[i % variants.length];
    const qty = (i % 3) + 1;
    const placedDays = 60 + i * 11;
    return {
      id: `demo-pep-order-h${i + 1}`,
      organizationId: providers[pIdx],
      organizationName: providers[pIdx].replace("demo-pep-provider-", "Provider ").replace(/^/, ""),
      patientId: `demo-pep-pt-${(i % 8) + 1}`,
      patientFirstName: "Demo",
      patientLastName: "Historical",
      patientEmail: "demo@example.com",
      patientPhone: "(305) 555-0000",
      shippingAddress: "Demo Address, FL 33000",
      lineItems: [
        {
          variantId: v.variantId,
          productName: v.productName,
          size: v.size,
          quantity: qty,
          unitPriceCents: v.price,
          lineTotalCents: v.price * qty,
        },
      ],
      subtotalCents: v.price * qty,
      shippingCents: 0,
      taxCents: 0,
      totalCents: v.price * qty,
      paymentMethod: "card",
      status: "delivered",
      tier: tiers[pIdx],
      carrier: "USPS",
      trackingNumber: `9400-2000-${i}-0000`,
      createdAt: _peptideDaysAgo(placedDays + 7),
      updatedAt: _peptideDaysAgo(placedDays),
      statusHistory: [
        { status: "submitted", date: _peptideDaysAgo(placedDays + 7) },
        { status: "delivered", date: _peptideDaysAgo(placedDays) },
      ],
    };
  }),
];

// -- Peptide-specific role orgInfo fixtures --
// Rich org-vertex shapes returned by query-vertices in demo mode for
// peptidesManufacturer / peptidesProvider so every Settings sidebar item
// renders populated. Catalog + tier pricing data is injected at request
// time from demoState slices, not from these fixtures.

export const demoPeptidesManufacturerOrgInfo = {
  name: "Lucas Peptide Labs",
  id: DEMO_ORG,
  officeName: "Lucas Peptide Labs",
  officeAddress: "1500 NW 10th Ave",
  officeCity: "Miami",
  officeState: "FL",
  officeZip: "33136",
  officePhone: "(305) 555-0210",
  ein: "82-1234567",
  npi: "1928374651",
  notUS: false,
  productLines: { peptides: true, dme: false },
  requirePsa: false,
  newAccountForm: {
    isTemplate: true,
    completedAt: null,
    fieldValues: {},
  },
  inboundNotifications: {
    newOrder: { email: "orders@lucaspeptidelabs.com", enabled: true },
    urgentEscalation: { email: "ops@lucaspeptidelabs.com", enabled: true },
    weeklyDigest: { email: "leadership@lucaspeptidelabs.com", enabled: false },
  },
  uberDirect: {
    connected: true,
    customerId: "cus_demo_uber_lpl4mfr",
    accountName: "Lucas Peptide Labs — Miami Warehouse",
    lastSyncedAt: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  signedBaas: [
    { id: "baa-1", providerName: "Coral Gables Wellness Clinic", signedAt: "2025-09-15", version: 2 },
    { id: "baa-2", providerName: "Aventura Longevity Center", signedAt: "2025-11-01", version: 2 },
    { id: "baa-3", providerName: "South Beach Anti-Aging", signedAt: "2026-01-12", version: 2 },
  ],
  receivedContracts: [
    {
      id: "rc-1",
      providerName: "Coral Gables Wellness Clinic",
      type: "PSA",
      signedAt: "2025-09-15",
      status: "signed",
    },
    {
      id: "rc-2",
      providerName: "Aventura Longevity Center",
      type: "BAA",
      signedAt: "2025-11-01",
      status: "signed",
    },
    {
      id: "rc-3",
      providerName: "South Beach Anti-Aging",
      type: "NAF",
      signedAt: "2026-01-12",
      status: "signed",
    },
    {
      id: "rc-4",
      providerName: "Brickell Hormone Therapy",
      type: "PSA",
      signedAt: "2026-02-04",
      status: "signed",
    },
  ],
  advancedTools: {
    autoApproveLowRisk: false,
    bulkExport: true,
    dataPipelineConnected: true,
  },
  securityDefaults: {
    deleteNotesAfter: "30",
    deleteTranscriptOnSign: "true",
    emptyTrashAfter: "15",
  },
  media: demoSalesMediaLibrary,
};

export const demoPeptidesProviderOrgInfo = {
  name: "Coral Gables Wellness Clinic",
  id: DEMO_ORG,
  officeName: "Coral Gables Wellness Clinic",
  officeAddress: "2401 Ponce de Leon Blvd",
  officeCity: "Coral Gables",
  officeState: "FL",
  officeZip: "33134",
  officePhone: "(305) 555-0144",
  ein: "47-8473625",
  notUS: false,
  pricingTier: "C",
  productLines: { peptides: true, dme: false },
  requirePsa: true,
  productServiceAgreement: {
    signedAt: "2025-08-20",
    signerName: "Dr. Rachel Adler",
    version: 1,
  },
  newAccountForm: {
    completedAt: "2025-09-01",
    fieldValues: {
      practiceLegalName: "Coral Gables Wellness Clinic LLC",
      practiceTaxId: "47-8473625",
      practiceNpi: "9988776655",
      practiceAddress: "2401 Ponce de Leon Blvd, Coral Gables, FL 33134",
      practicePhone: "(305) 555-0144",
      practiceContactName: "Rachel Adler, MD",
      practiceContactEmail: "demo.peptides.provider@lucashealth.ai",
      authorizedSignerName: "Dr. Rachel Adler",
      authorizedSignerTitle: "Medical Director",
    },
  },
  signedBaas: [{ id: "baa-1", providerName: "Lucas Peptide Labs", signedAt: "2025-08-15", version: 2 }],
  receivedContracts: [],
  terminologyLibrary: [
    { id: "tl-1", term: "GLP-1", expansion: "Glucagon-like peptide-1 receptor agonist", category: "peptides" },
    { id: "tl-2", term: "BPC", expansion: "Body Protection Compound", category: "peptides" },
    { id: "tl-3", term: "TRT", expansion: "Testosterone Replacement Therapy", category: "wellness" },
  ],
  uberDirect: { connected: false },
  securityDefaults: {
    deleteNotesAfter: "15",
    deleteTranscriptOnSign: "true",
    emptyTrashAfter: "15",
  },
};

// Auth blobs for peptide demo roles. Shape mirrors demoUsers.provider —
// the demo system spreads these into auth context on role switch.
export const demoPeptideUsers = {
  peptidesProvider: {
    user: {
      id: "demo-user-pep-provider",
      firstName: "Dr. Rachel",
      lastName: "Adler",
      email: "demo.peptides.provider@lucashealth.ai",
      role: "advanced",
      groups: ["supervisor", "doctor"],
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        doctorConsentAuthorizeSignatureDate: "2025-08-20",
        themePreference: null,
        npiNumber: "9988776655",
        licenseNumber: "ME-204881",
        phone: "(305) 555-0144",
        title: "MD",
        specialties: ["Functional Medicine", "Hormone Optimization"],
        practiceState: "FL",
        practiceZip: "33134",
        baaSignatureDate_lucas: "2025-01-01",
        baaVersion_lucas: 1,
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-provider",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-pep-provider",
    },
    orgInfo: demoPeptidesProviderOrgInfo,
    brain: { variables: {} },
  },
  peptidesManufacturer: {
    user: {
      id: "demo-user-pep-mfr",
      firstName: "Avery",
      lastName: "Singh",
      email: "demo.peptides.manufacturer@lucashealth.ai",
      role: "supervisor",
      groups: ["supervisor", "team-member"],
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        doctorConsentAuthorizeSignatureDate: "2025-07-15",
        themePreference: null,
        phone: "(305) 555-0210",
        title: "VP Operations",
        baaSignatureDate_lucas: "2025-01-01",
        baaVersion_lucas: 1,
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-manufacturer",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-pep-mfr",
    },
    orgInfo: demoPeptidesManufacturerOrgInfo,
    brain: {
      variables: {
        ordersManagement: "true",
      },
    },
  },
  peptidesPatient: {
    user: {
      id: "demo-user-pep-patient",
      firstName: "Maria",
      lastName: "Lopez",
      email: "demo.peptides.patient@example.com",
      role: "basic",
      groups: ["patient"],
      mobilePhone: "(305) 555-1101",
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        themePreference: null,
        dob: "1985-04-12",
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-patient",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-pep-patient",
      firstName: "Maria",
      lastName: "Lopez",
      email: "demo.peptides.patient@example.com",
      mobilePhone: "(305) 555-1101",
    },
    orgInfo: {
      name: "Demo Patient",
      id: DEMO_ORG,
      productLines: { peptides: true, dme: false },
    },
    brain: { variables: {} },
  },
  // Sales rep at a peptides-enabled manufacturer org. Mirrors the DME
  // `salesDashboard` persona (Torres / sales-rep-master) but points at the
  // peptides manufacturer orgInfo so `hasPeptidesProductLine` resolves true
  // — that's what surfaces the new "Order Peptides" sidebar entry and the
  // Sales Dashboard header shortcut, and lets the rep open /peptides as a
  // personal buyer (retail W tier, patient checkout) via the
  // usePeptidePricing sales-rep role override.
  peptidesSalesDashboard: {
    user: {
      id: "rep-torres-peptides",
      firstName: "Michael",
      lastName: "Torres",
      email: "demo.peptides.sales@lucashealth.ai",
      role: "advanced",
      groups: ["sales-rep-master"],
      mobilePhone: "(305) 555-0150",
      custom: {
        doctorConsentAuthorizeVersion: "demo",
        themePreference: null,
        // Tier the manufacturer assigned this rep during onboarding —
        // usePeptidePricing reads this to set activeTier when the rep
        // browses the catalog for personal orders.
        peptideRepTier: "A",
      },
    },
    session: {
      currentOrganizationName: DEMO_ORG,
      currentOrganizationPlan: "order-manufacturer",
      currentBrainId: "demo-brain",
      sessionId: "demo-session-pep-sales",
      // PatientPeptideCheckout reads the shipping pre-fill from session
      // fields (mirrors the peptidesPatient persona); without these the
      // form renders empty for the sales-rep demo.
      firstName: "Michael",
      lastName: "Torres",
      email: "demo.peptides.sales@lucashealth.ai",
      mobilePhone: "(305) 555-0150",
    },
    orgInfo: { ...demoPeptidesManufacturerOrgInfo, media: demoSalesMediaLibrary },
    brain: { variables: {} },
  },
};
